const fr = {
  translation: {
    common: {
      appName: "eServices",
      email: "Adresse Email",
      password: "Mot de passe",
      confirmPassword: "Confirmer le mot de passe",
      firstName: "Prénom",
      lastName: "Nom",
      phone: "Téléphone",
      address: "Adresse",
      submit: "Envoyer",
      save: "Sauvegarder",
      cancel: "Annuler",
      delete: "Supprimer",
      edit: "Modifier",
      back: "Retour",
      search: "Rechercher...",
      loading: "Chargement...",
      actions: "Actions",
      date: "Date",
      amount: "Montant",
      status: "Statut",
      total: "Total",
      quantity: "Quantité",
      price: "Prix",
      product: "Produit",
      see_details: "Détails",
      download: "Télécharger",
      copied: "Copié !",
      theme: "Thème",
      language: "Langue",
      settings: "Paramètres",
      logout: "Déconnexion",
      dashboard: "Tableau de bord",
      profile: "Profil",
      yes: "Oui",
      no: "Non",
      optional: "Optionnel",
      quantity_decrease: "Diminuer la quantité",
      quantity_increase: "Augmenter la quantité",
      currency: "DT",
      balance: "Solde",
      page: "page",
      next: "Suiv",
      prev: "Préc",
      read_all: "Tout marquer comme lu",
      reset: "Réinitialiser",
      filter: "Filtrer",
      confirm: "Confirmer",
      error: "Une erreur est survenue",
      unknown_error: "Erreur inconnue",
      unit: "unité",
      role: {
        admin: "Administrateur",
        client: "Client"
      },
      and: "et",
      favorites: "Favoris",
      login: "common.login",
      light_mode: "Mode clair",
      dark_mode: "Mode sombre",
      notifications: "Notifications",
      security: "Sécurité",
      close: "Fermer",
      open_full: "Ouvrir en plein écran",
      copy: "Copier"
    },
    ManageProducts: {
      header: {
        title: "Gestion Produits"
      },
      form: {
        titleNew: "Nouveau Produit",
        titleEdit: "Modifier Produit",
        name: "Nom du Produit",
        description: "Description",
        descriptionPlaceholder: "Description détaillée du produit...",
        price: "Prix de Base (TND)",
        category: "Catégorie",
        subcategory: "Sous-catégorie",
        status: "Statut",
        statusOnSale: "En vente",
        statusIncoming: "En arrivage",
        statusSoldOut: "Épuisé",
        value: "Valeur",
        valuePlaceholder: "Ex : 1 Go, 5 TND...",
        minQuantity: "Quantité minimale",
        deliveryMethod: "Méthode de livraison",
        deliveryMethods: {
          codeInstantane: "Code instantané",
          mailCompteCode: "Mail compte code",
          mailCode: "Mail code",
          mailAcces: "Mail accès",
          mailLicence: "Mail licence",
          traitementLien: "Traitement lien",
          livraisonDomicile: "Livraison à domicile"
        },
        saleType: "Type de vente",
        saleTypes: {
          detail: "Détail",
          gros: "Gros"
        },
        paymentMethods: "Moyens de paiement",
        paymentMethodsLabels: {
          solde: "Solde",
          livraison: "Livraison",
          carte: "Carte",
          virement: "Virement",
          mandat: "Mandat",
          portefeuille: "Portefeuille",
          p2p: "P2P"
        },
        validated: "Produit validé",
        bestSeller: "Meilleure vente",
        duplicateSuffix: "(Copie)",
        showPreview: "Prévisualiser le produit",
        hidePreview: "Masquer la prévisualisation",
        images: {
          logo: "1. Logo / Marque",
          main: "2. Image Principale",
          gallery: "3. Autres images (Galerie)"
        },
        preferences: {
          title: "Options Tarifaires",
          addGroup: "+ GROUPE",
          groupPlaceholder: "Ex : Type de couverture",
          optionPlaceholder: "Ex : Rigide",
          required: "Requis",
          featuresLabel: "Services inclus (1 par ligne)",
          featuresPlaceholder: "Saisir les fonctionnalités...",
          addValue: "+ NOUVELLE VALEUR",
          removeGroup: "Supprimer ce groupe de préférences",
          removeOption: "Supprimer cette option",
          removeCondition: "Supprimer cette condition",
          conditions: {
            if: "SI",
            groupSelect: "Groupe...",
            valueSelect: "Valeur...",
            thenPrice: "ALORS SUPPLÉMENT =",
            featuresLabel: "Services inclus (si condition)",
            featuresPlaceholder: "Fonctionnalités spécifiques...",
            add: "+ Condition tarifaire"
          }
        },
        submit: {
          processing: "TRAITEMENT...",
          update: "METTRE À JOUR",
          create: "ENREGISTRER LE PRODUIT"
        }
      },
      validation: {
        nameRequired: "Le nom du produit est requis",
        priceRequired: "Le prix doit être supérieur à 0",
        subcategoryRequired: "La sous-catégorie est requise",
        minQuantityInvalid: "La quantité minimale doit être au moins 1",
        preferenceLabelRequired: "Le label de la préférence {{index}} est requis",
        preferenceOptionsRequired: "La préférence \"{{label}}\" doit avoir au moins une option",
        optionNameRequired: "Le nom de l'option {{optionIndex}} de \"{{label}}\" est requis"
      },
      preview: {
        title: "Prévisualisation",
        preferences: "Personnalisation",
        productNamePlaceholder: "Nom du produit",
        valueLabel: "Valeur",
        selectPlaceholder: "Sélectionner...",
        inputPlaceholder: "Entrez {{field}}",
        amountPlaceholder: "Montant",
        estimatedTotal: "Prix total estimé",
        filePlaceholder: "Fichier à uploader"
      },
      filters: {
        searchLabel: "Recherche",
        searchPlaceholder: "Nom du produit...",
        categoryLabel: "Catégorie",
        subcategoryLabel: "Sous-catégorie",
        all: "Toutes"
      },
      list: {
        empty: "Aucun produit trouvé",
        basePriceSuffix: "(Base)",
        duplicate: "Dupliquer",
        edit: "Modifier",
        delete: "Supprimer"
      },
      messages: {
        confirmDelete: "Supprimer ce produit ?"
      }
    },
    ManagePaymentMethods: {
      page_title: "Méthodes de paiement",
      page_subtitle: "Configurez les moyens de paiement disponibles pour vos clients.",
      credentials_title: "Coordonnées de paiement",
      disabled_badge: "Désactivé",
      scope_short_order: "Commande",
      scope_short_deposit: "Dépôt",
      scope_short_product: "Catalogue",
      stats: {
        total: "Moyens de paiement",
        types: "Types (familles)",
        subtypes: "Sous-types",
        enabled: "Actifs",
        disabled: "Désactivés"
      },
      filters: {
        search: "Recherche",
        search_placeholder: "Nom, identifiant, RIB, code...",
        family: "Famille",
        status: "Statut",
        usage: "Portée",
        all_families: "Toutes les familles",
        all_statuses: "Tous les statuts",
        all_usages: "Toutes les portées",
        enabled: "Actifs",
        disabled: "Désactivés",
        usage_order: "Commande",
        usage_deposit: "Dépôt",
        usage_product: "Catalogue",
        reset: "Réinitialiser",
        no_results: "Aucun moyen de paiement ne correspond aux filtres.",
        results: "{{count}} résultat(s)"
      },
      card: {
        sort: "Ordre",
        created: "Créée le"
      },
form: {
        add_method: "Ajouter une méthode",
        edit_title: "Modifier la méthode",
        add_title: "Nouvelle méthode",
        family_label: "Famille",
        method: "Méthode",
        used_for_label: "Utilisé pour",
        scope_order: "Commande",
        scope_deposit: "Dépôt",
        scope_product: "Catalogue",
        sort_order: "Ordre d'affichage",
        instructions: "Instructions",
        instructions_placeholder: "Instructions affichées au client (optionnel).",
        enabled: "Actif",
        error_method_code: "Code méthode invalide.",
        error_scope: "Sélectionnez au moins une portée.",
        error_identifier_portefeuille: "Pour un portefeuille, le numéro de téléphone est obligatoire.",
        error_identifier_phone: "Numéro de mobile tunisien invalide.",
        error_identifier_rib_required: "Le RIB est obligatoire.",
        error_identifier_rib_format: "Le RIB doit contenir 20 chiffres.",
        error_identifier_ccp_required: "Le CCP est obligatoire.",
        error_identifier_ccp_format: "Le CCP doit contenir entre 10 et 16 chiffres.",
        error_provider: "Le nom du prestataire est requis.",
        error_scope_solde_deposit: "Le solde interne ne peut pas être utilisé pour les dépôts.",
        error_scope_livraison_deposit: "Le paiement à la livraison ne peut pas être utilisé pour les dépôts.",
        error_scope_livraison_product: "Le paiement à la livraison ne peut pas être utilisé pour le catalogue.",
        error_scope_p2p_order: "Le P2P ne peut pas être utilisé pour les commandes.",
        error_scope_p2p_product: "Le P2P ne peut pas être utilisé pour le catalogue.",
        scope_forbidden: "Non applicable",
        scope_solde_no_deposit: "Réservé aux commandes/catalogue",
        scope_livraison_no_deposit: "Réservé aux commandes",
        scope_livraison_no_product: "Réservé aux commandes",
        scope_p2p_no_order: "Réservé aux dépôts",
        scope_p2p_no_product: "Réservé aux dépôts",
        hint_rib: "20 chiffres requis pour un RIB bancaire",
        hint_ccp: "10 à 16 chiffres pour un CCP postal",
        hint_phone: "Numéro de mobile tunisien (+216)",
        identifier_label_portefeuille: "N° de téléphone (mobile TN)",
        identifier_label_virement: "RIB (20 chiffres)",
        identifier_label_virement_postal: "CCP / compte postal",
        identifier_label_mandat: "CIN ou référence (optionnel)",
        identifier_label_optional: "Identifiant (optionnel)",
        family_auto: "(détecté automatiquement)",
        provider_name: "Nom du prestataire",
        identifier: "Identifiant principal",
        iban_optional: "IBAN (optionnel)",
        account_holder_optional: "Titulaire du compte (optionnel)",
        family: {
          title: "Famille",
          solde: "Solde",
          livraison: "Livraison",
          portefeuille: "Portefeuille",
          virement: "Virement",
          carte: "Carte",
          mandat: "Mandat",
          p2p: "P2P"
        }
      },
      method: {
        solde_interne: "Solde Interne",
        livraison: "Paiement à la livraison",
        portefeuille_flouci: "Flouci",
        portefeuille_d17: "D17",
        portefeuille_izi_pay: "IZI Pay",
        portefeuille_wafacash: "Wafacash",
        virement_bancaire: "Virement Bancaire",
        virement_postal: "CCP / Poste",
        carte_bancaire: "Carte Bancaire",
        carte_postale: "Carte Postale",
        mandat_minute: "Mandat Minute",
        mandat_normale: "Mandat Normale",
        mandat_bancaire: "Mandat Bancaire",
        p2p: "P2P"
      },
      actions: {
        edit: "Modifier",
        duplicate: "Dupliquer",
        delete: "Supprimer"
      },
      details: {
        identifier: "Identifiant",
        iban: "IBAN",
        holder: "Titulaire"
      },
      messages: {
        load_error: "Erreur lors du chargement.",
        update_success: "Méthode mise à jour.",
        create_success: "Méthode créée.",
        delete_success: "Méthode supprimée.",
        delete_confirm: "Voulez-vous vraiment supprimer cette méthode ?"
      }
    },
    ManageStock: {
      header: {
        title: "Gestion du stock"
      },
      tabs: {
        instant: "📦 Codes Instantanés",
        manual: "🔧 Digital Manuel",
        physical: "🚚 Stock Physique"
      },
      common: {
        show: "Afficher",
        hide: "Masquer",
        loading: "Chargement...",
        error: "Une erreur est survenue",
        success: "Succès",
        all: "Tous",
        actions: "Actions",
        previous: "Précédent",
        next: "Suivant",
        cancel: "Annuler",
        close: "Fermer",
        save: "Sauvegarder",
        product: "Produit",
        choose: "Choisir",
        type: "Type",
        status: "Statut",
        quantity: "Quantité",
        date: "Date",
        email: "Adresse Email",
        customer: "Client",
        noData: "Aucune donnée"
      },
      status: {
        onSale: "En vente",
        soldOut: "Épuisé",
        incoming: "En arrivage"
      },
      sync: {
        button: "Sync statuses",
        nothingToUpdate: "Tout semble correct.",
        updated: "{{count}} produits mis à jour.",
        confirm: {
          title: "Synchroniser les statuts ?",
          description: "Cette action va scanner les produits et mettre à jour leur statut si nécessaire.",
          confirm: "Continuer"
        }
      },
      instant: {
        kpis: {
          total: "Total codes",
          available: "Disponibles",
          sold: "Vendus",
          expired: "Expirés"
        },
        import: {
          title: "Importer des codes",
          subtitle: "Format attendu : code;serial;date (JJ/MM/AAAA).",
          parsing: "Analyse du fichier…",
          noInstantProduct: "Aucun produit instantané",
          instantOnlyHint: "Import disponible uniquement pour les produits CODE_INSTANTANE.",
          fileLabel: "Fichier (.csv / .txt)",
          fileSelected: "Fichier sélectionné.",
          submit: "Importer",
          uploading: "Importation de {{count}} codes…",
          success: "Succès ! {{count}} codes importés.",
          errors: {
            badFormat: "Ligne {{line}} : format attendu \"code;serial;date\".",
            badCode: "Ligne {{line}} : le code doit contenir exactement 15 chiffres.",
            badSerial: "Ligne {{line}} : le serial doit respecter \"SN-XXXXXXXXXXXXX\" (13 chiffres).",
            badDate: "Ligne {{line}} : date invalide, format attendu JJ/MM/AAAA.",
            more: "(+{{count}} autres)",
            noCode: "Aucun code trouvé."
          }
        },
        table: {
          title: "Codes instantanés",
          subtitle: "Consultez et gérez les codes instantanés.",
          filters: {
            product: "Produit",
            status: "Statut",
            search: "Recherche",
            searchPlaceholder: "Référence ou serial…"
          },
          columns: {
            reference: "Référence",
            serial: "Serial",
            status: "Statut",
            expiration: "Date expiration",
            buyer: "Acheteur",
            soldAt: "Vendu le"
          },
          actions: {
            viewBuyer: "Voir acheteur",
            details: "Voir détails",
            markExpired: "Marquer comme expiré"
          },
          status: {
            available: "Disponible",
            sold: "Vendu",
            used: "Utilisé",
            expired: "Expiré"
          },
          pagination: {
            range: "{{from}} à {{to}} sur {{total}} codes",
            page: "Page {{page}} / {{pages}}"
          },
          confirmExpire: {
            title: "Marquer comme expiré ?",
            description: "Le statut passera à EXPIRED. Cette action est irréversible.",
            confirm: "Marquer expiré"
          },
          toastExpired: "Code marqué comme expiré."
        },
        details: {
          title: "Détails du code",
          codeEncrypted: "Code (masqué par défaut)",
          codeHash: "Hash",
          actions: {
            copyReference: "Copier la référence"
          },
          otp: {
            hint: "Pour afficher le code, une validation OTP WhatsApp est requise.",
            grantedFor: "Affichage autorisé pendant {{seconds}} s.",
            phoneRequired: "Numéro WhatsApp requis pour afficher le code (vérifiez votre profil).",
            transactionLabel: "affichage du code",
            success: "OTP validé. Affichage autorisé pendant ~{{minutes}} min."
          }
        },
        buyer: {
          title: "Acheteur",
          openProfile: "Ouvrir la fiche client"
        }
      },
      manual: {
        title: "Digital Manuel",
        subtitle: "Basculer le statut des produits manuels.",
        actions: {
          setSoldOut: "Mettre en épuisé",
          setOnSale: "Mettre en vente"
        }
      },
      physical: {
        title: "Stock Physique",
        typeLabel: "Physique",
        actions: {
          history: "Historique",
          adjust: "Ajuster"
        },
        adjust: {
          title: "Ajustement stock",
          movementType: "Type de mouvement",
          in: "+ Entrée",
          out: "- Sortie",
          reason: "Raison",
          reasonPlaceholder: "Ex : casse, inventaire, retour…",
          toastSuccess: "Stock ajusté avec succès."
        }
      }
    },
    SplashScreen: {
      tagline: {
        slogan: "Votre espace numérique"
      },
      status: {
        checking: "Vérification des mises à jour...",
        applying: "Application de la mise à jour...",
        loading: "Chargement des ressources..."
      },
      footer: {
        buildLabel: "Build"
      },
      logo: {
        appName: "eServices"
      }
    },
    favorites: {
      title: "Favoris",
      empty:
        "Vous n'avez pas encore de favori. Parcourez le catalogue et ajoutez les produits qui vous intéressent.",
      remove: "Retirer des favoris",
      view_all: "Voir tous les favoris",
      load_error:
        "Impossible d'afficher vos favoris. Vérifiez votre connexion internet, puis réessayez.",
      retry: "Actualiser la liste"
    },
    AIChatAssistant: {
      header: {
        title: "eServices AI",
        statusOnline: "En ligne",
        resetConversation: "Réinitialiser la conversation"
      },
      emptyState: {
        title: "Besoin d'aide ?",
        description: "Posez-moi vos questions sur les recharges ou nos services."
      },
      input: {
        placeholder: "Votre message..."
      },
      tooltip: {
        help: "Besoin d'aide ?"
      },
      messages: {
        errorTechnical: "Désolé, je rencontre une petite difficulté technique.",
        errorUnavailable: "Service momentanément indisponible.",
        errorQuota: "Limite d'utilisation de l'assistant atteinte. Réessayez dans quelques minutes."
      }
    },
    status: {
      pending: "En attente",
      validated: "Validé",
      refused: "Refusé",
      validé: "Validé",
      refusé: "Refusé",
      en_attente: "En attente",
      in_delivery: "En cours de livraison",
      completed: "Terminée",
      cancelled: "Annulée",
      dispute: "En litige",
      processing: "En cours de traitement",
      delivered: "Livré",
      failed: "Échec",
      refunded: "Remboursé",
      en_vente: "En vente",
      en_arrivage: "En arrivage",
      ouvert: "Ouvert",
      en_cours: "En cours",
      actif: "Actif",
      suspendu: "Suspendu",
      en_attente_email: "En attente email",
      awaiting_delivery: "Prêt à expédier",
      p2p: "Transfert vers identifiant (type dépôt)",
      postal: "Mandat Postal",
      flouci: "Flouci",
      d17: "D17",
      izi_pay: "IZI Pay",
      virement: "Virement Bancaire",
      épuisé: "Épuisé"
    },
    notifications: {
      filter_by_type: "Filtrer par type",
      filter_all: "Toutes",
      filter_orders: "Commandes",
      filter_tickets: "Tickets",
      filter_deposits: "Dépôts",
      filter_admin: "Clients",
      filter_alerts: "Alertes",
      empty_filtered: "Aucune notification dans cette catégorie.",
      empty: "Aucune notification pour le moment.",
      order_status_changed: "Le statut de votre commande #{{orderId}} est maintenant : {{status}}",
      replacement_order_created: "Une commande de remplacement (#{{replacementId}}) a été créée pour votre commande #{{originalId}}. Les nouveaux codes sont disponibles dans Mes Codes.",
      deposit_validated: "Votre dépôt de {{amount}} a été validé.",
      deposit_refused: "Votre dépôt de {{amount}} a été refusé.",
      ticket_reply: "Nouvelle réponse sur votre ticket #{{ticketId}}",
      admin: {
        new_order: "Nouvelle commande #{{orderId}} reçue ({{amount}})",
        new_deposit: "Nouveau dépôt de {{amount}} reçu via {{method}}",
        new_ticket: "Nouveau ticket de support : {{sujet}}",
        new_client: "Nouveau client inscrit : {{name}}",
        new_client_unknown: "Nouveau client"
      },
      generic: {
        default: "Nouvelle notification",
        ticket_reponse: "Nouvelle réponse sur un ticket de support",
        ticket_statut: "Mise à jour du statut de votre ticket",
        ticket_cree: "Votre ticket a été créé",
        ticket_urgence: "Ticket marqué comme urgent",
        depot_valide: "Votre dépôt a été validé",
        depot_refuse: "Votre dépôt a été refusé",
        depot_cree: "Votre dépôt a été enregistré",
        commande_statut: "Mise à jour du statut de votre commande",
        commande_creee: "Votre commande a été créée",
        commande_payee: "Votre commande a été payée",
        commande_livree: "Votre commande a été livrée",
        commande_annulee: "Votre commande a été annulée",
        commande_litige: "Mise à jour concernant votre commande",
        nouveau_client: "Nouveau client inscrit",
        nouveau_ticket: "Nouveau ticket de support",
        stock_faible: "Alerte stock faible",
        stock_epuise: "Stock épuisé",
        system_alert: "Alerte système"
      }
    },
    auth: {
      login: {
        title: "Bon retour !",
        subtitle: "Connectez-vous à votre espace client",
        cta: "Se connecter",
        forgot_password: "Mot de passe oublié ?",
        new_user: "Nouveau sur Services ?",
        create_account: "Créer un compte gratuitement",
        back_home: "Retour à l",
        loading: "Connexion..."
      },
      register: {
        title: "Créer un compte",
        subtitle: "Remplissez le formulaire ci-dessous pour commencer.",
        cta: "Créer mon compte",
        have_account: "Vous avez déjà un compte ?",
        login_link: "Connectez-vous ici",
        success_title: "Félicitations !",
        success_msg: "Votre compte a été créé avec succès. Un email de confirmation a été envoyé. Veuillez vérifier votre boîte email et cliquer sur le lien de confirmation. Pensez également à vérifier votre dossier de courrier indésirable (spam).",
        email_sent: "Un email de confirmation a été envoyé à",
        back_login: "Retour à la connexion"
      },
      errors: {
        invalid_credentials: "Email ou mot de passe incorrect.",
        user_not_found: "Aucun compte trouvé avec cet email.",
        email_exists: "Un compte existe déjà avec cette adresse email.",
        password_mismatch: "Les mots de passe ne correspondent pas.",
        email_not_confirmed: "Votre compte n'est pas encore confirmé. Veuillez vérifier votre boîte email et cliquer sur le lien de confirmation. Pensez également à vérifier votre dossier de courrier indésirable (spam).",
        generic: "Une erreur est survenue."
      }
    },
    Deposits: {
      paymentMethods: {
        p2p: "P2P",
        virement: "Virement",
        mandat: "Mandat",
        portefeuilles: "Portefeuilles",
        carte: "Carte",
        livraison: "Livraison"
      },
      mandatTypes: {
        minute: "Mandat minute",
        normale: "Mandat Normale",
        moneyGram: "MoneyGram"
      },
      p2p: {
        instructionsTitle: "Instructions pour P2P (Main à la main)",
        instructionsDesc: "Cette méthode est une remise en main propre. Saisissez uniquement votre nom de vérification ci-dessous.",
        clientNameLabel: "Nom du client pour la vérification",
        clientNamePlaceholder: "Votre nom d'expéditeur / de remise"
      },
      mandat: {
        instructionsTitle: "Instructions pour envoyer un Mandat",
        typeLabel: "Type de mandat effectué"
      }
    },
    Login: {
      sidebar: {
        appName: "eServices",
        heroDesc: "Votre partenaire de confiance pour tous vos services numériques.",
        securityBadge: "Sécurité eServices",
        trustedLoginQuote: "Connexion fiable, vérification WhatsApp instantanée et accès protégé à chaque session.",
        secureService: "Service sécurisé et fiable",
        support24_7: "Support 24/7 disponible"
      },
      header: {
        title: "Bon retour !",
        subtitle: "Connectez-vous à votre espace client"
      },
      form: {
        email: "Adresse Email",
        password: "Mot de passe",
        emailPlaceholder: "exemple@email.com",
        passwordPlaceholder: "••••••••"
      },
      validation: {
        credentialsInvalid: "Email ou mot de passe incorrect.",
        emailInvalid: "Format d'email invalide"
      },
      twoFA: {
        label: "Code de vérification (2FA)",
        hint: "Entrez le code à 6 chiffres depuis votre application d'authentification",
        placeholder: "000000",
        codeError: "Veuillez entrer un code à 6 chiffres",
        invalidCode: "Code 2FA invalide",
        back: "← Retour"
      },
      options: {
        rememberMe: "Rester connecté",
        forgotPassword: "Mot de passe oublié ?"
      },
      captcha: {
        pleaseValidate: "Veuillez valider le CAPTCHA de sécurité.",
        pleaseComplete: "Veuillez compléter la vérification de sécurité",
        devMode: "🔧 Mode développement : CAPTCHA désactivé"
      },
      cta: {
        loading: "Connexion...",
        submit: "Se connecter"
      },
      divider: {
        orContinueWith: "Ou continuer avec"
      },
      oauth: {
        googleError: "Erreur lors de la connexion avec Google",
        comingSoon: "Bientôt disponible",
        googleLabel: "Google"
      },
      footer: {
        noAccount: "Pas encore de compte ?",
        createAccount: "Créer un compte gratuitement",
        agreePrefix: "En vous connectant, vous acceptez nos",
        termsLink: "Conditions d'utilisation",
        and: "et notre",
        privacyLink: "Politique de confidentialité"
      },
      whatsappOtp: {
        title: "Vérification WhatsApp",
        description:
          "Un code à 6 chiffres a été envoyé à votre numéro WhatsApp enregistré.",
        cancelButton: "Annuler",
        submitButton: "Valider le code",
        verifying: "Vérification..."
      }
    },
    ResetPassword: {
      errors: {
        invalidOrExpiredLink: "Lien de réinitialisation invalide ou expiré. Veuillez demander un nouveau lien.",
        invalidLink: "Lien de réinitialisation invalide. Veuillez demander un nouveau lien.",
        verificationFailed: "Erreur lors de la vérification du lien. Veuillez réessayer.",
        updateFailed: "Erreur lors de la mise à jour du mot de passe",
        resetFailed: "Erreur lors de la réinitialisation. Veuillez réessayer."
      },
      validation: {
        passwordRequired: "Le mot de passe est requis",
        passwordMinLength: "Le mot de passe doit contenir au moins 6 caractères",
        confirmPasswordRequired: "La confirmation est requise",
        passwordMismatch: "Les mots de passe ne correspondent pas"
      },
      loading: {
        verifyingLink: "Vérification du lien..."
      },
      invalidState: {
        title: "Lien invalide",
        message: "Ce lien de réinitialisation est invalide ou a expiré. Veuillez demander un nouveau lien.",
        requestNewLink: "Demander un nouveau lien"
      },
      sidebar: {
        appName: "eServices",
        heroDesc: "Définissez un nouveau mot de passe sécurisé",
        securePassword: "Mot de passe sécurisé",
        bankEncryption: "Chiffrement de niveau bancaire"
      },
      header: {
        title: "Nouveau mot de passe",
        subtitle: "Entrez votre nouveau mot de passe sécurisé"
      },
      success: {
        title: "Mot de passe mis à jour avec succès !",
        description: "Redirection vers la page de connexion dans quelques secondes..."
      },
      form: {
        newPasswordLabel: "Nouveau mot de passe",
        confirmPasswordLabel: "Confirmer le mot de passe",
        passwordPlaceholder: "••••••••",
        passwordHint: "Minimum 6 caractères"
      },
      cta: {
        loading: "Mise à jour en cours...",
        submit: "Mettre à jour le mot de passe"
      },
      footer: {
        rememberPassword: "Vous vous souvenez de votre mot de passe ?",
        loginLink: "Se connecter"
      }
    },
    ForgotPassword: {
      validation: {
        emailRequired: "L'email est requis",
        emailInvalid: "Format d'email invalide"
      },
      errors: {
        sendFailed: "Erreur lors de l'envoi de l'email de récupération",
        sendRetry: "Erreur lors de l'envoi de l'email. Veuillez réessayer."
      },
      sidebar: {
        appName: "eServices",
        heroDesc: "Récupération de mot de passe sécurisée",
        secureRecoveryLink: "Lien de récupération sécurisé",
        instantEmail: "Email envoyé instantanément"
      },
      header: {
        title: "Mot de passe oublié ?",
        subtitle: "Entrez votre adresse email et nous vous enverrons un lien de récupération"
      },
      success: {
        title: "Email envoyé avec succès !",
        description: "Vérifiez votre boîte de réception. Un lien de réinitialisation a été envoyé à votre adresse email. Le lien est valide pendant 1 heure.",
        backToLogin: "Retour à la connexion"
      },
      form: {
        emailPlaceholder: "exemple@email.com"
      },
      cta: {
        loading: "Envoi en cours...",
        submit: "Envoyer le lien de récupération"
      },
      footer: {
        rememberPassword: "Vous vous souvenez de votre mot de passe ?",
        loginLink: "Se connecter",
        needHelp: "En cas de problème, contactez notre",
        supportLink: "support"
      }
    },
    Register: {
      sidebar: {
        securityBadge: "Inscription sécurisée eServices",
        title: "Créez votre compte",
        titleHighlight: "en moins de 2 minutes.",
        description: "Espace chiffré, vérification intelligente, et activation rapide de votre profil client.",
        testimonialQuote: "\"Inscription ultra fluide, vérification instantanée et interface claire. On sent tout de suite la fiabilité.\"",
        testimonialAuthorInitials: "AT",
        testimonialAuthorName: "Amira T.",
        testimonialAuthorRole: "Fondatrice eCommerce"
      },
      success: {
        title: "Félicitations !",
        message: "Votre compte a été créé avec succès. Un email de confirmation a été envoyé. Veuillez vérifier votre boîte email et cliquer sur le lien de confirmation. Pensez également à vérifier votre dossier de courrier indésirable (spam).",
        backToLogin: "Retour à la connexion",
        phoneVerificationHint: "Vous pouvez aussi vérifier votre numéro de téléphone via WhatsApp avant de vous connecter."
      },
      errors: {
        email_already_used: "Cette adresse email est déjà utilisée par un autre compte.",
        phone_already_used: "Ce numéro de téléphone est déjà utilisé par un autre compte."
      },
      header: {
        title: "Créer un compte",
        subtitle: "Remplissez le formulaire ci-dessous pour commencer."
      },
      form: {
        firstName: "Prénom",
        lastName: "Nom",
        email: "Adresse Email",
        phone: "Téléphone",
        address: "Adresse",
        password: "Mot de passe",
        confirmPassword: "Confirmer le mot de passe",
        firstNamePlaceholder: "Jean",
        lastNamePlaceholder: "Dupont",
        emailPlaceholder: "exemple@email.com",
        phonePlaceholder: "+216 21 380 039",
        phonePlaceholderDigits: "XXXXXXXX",
        phoneHelper: "Format: +216 XX XXX XXX",
        addressPlaceholder: "Rue, Ville, Code postal",
        passwordPlaceholder: "••••••••"
      },
      validation: {
        firstNameRequired: "Le prénom est requis",
        firstNameMinLength: "Le prénom doit contenir au moins 2 caractères",
        lastNameRequired: "Le nom est requis",
        lastNameMinLength: "Le nom doit contenir au moins 2 caractères",
        emailRequired: "L'email est requis",
        emailInvalid: "Format d'email invalide",
        phoneRequired: "Le téléphone est requis",
        phoneInvalid: "Format de téléphone invalide",
        phoneMinDigits: "Le numéro doit contenir au moins 8 chiffres",
        addressRequired: "L'adresse est requise",
        addressMinLength: "L'adresse doit contenir au moins 5 caractères",
        passwordRequired: "Le mot de passe est requis",
        passwordMinLength: "Le mot de passe doit contenir au moins 6 caractères",
        passwordRecommendLength: "Pour plus de sécurité, utilisez au moins 8 caractères",
        confirmPasswordRequired: "Veuillez confirmer votre mot de passe",
        passwordMismatch: "Les mots de passe ne correspondent pas"
      },
      captcha: {
        pleaseValidate: "Veuillez valider le CAPTCHA de sécurité.",
        pleaseComplete: "Veuillez compléter la vérification de sécurité",
        devMode: "🔧 Mode développement : CAPTCHA désactivé"
      },
      cta: {
        loading: "Chargement...",
        submit: "Créer mon compte"
      },
      footer: {
        haveAccount: "Vous avez déjà un compte ?",
        loginLink: "Connectez-vous ici",
        agreePrefix: "En créant un compte, vous acceptez nos",
        termsLink: "Conditions d'utilisation",
        and: "et notre",
        privacyLink: "Politique de confidentialité"
      }
    },
    LandingPage: {
      badges: {
        securePayment: "Paiement sécurisé",
        instantDelivery: "Livraison instantanée",
        support24_7: "Support 7j/7"
      },
      hero: {
        badge: "Plateforme N°1 en Tunisie",
        title: "Vos services digitaux",
        titleHighlight: "livrés en quelques secondes",
        subtitle: "Cartes cadeaux, codes gaming, licences logicielles, abonnements streaming... Achetez en toute sécurité et recevez instantanément par email. 100% automatisé, 24h/24.",
        ctaPrimary: "Créer un compte gratuit",
        ctaSecondary: "Explorer nos services",
        deliveryLabel: "Livraison",
        deliveryValue: "Instantanée ⚡"
      },
      favorites: {
        badge: "Vos favoris",
        title: "Produits que vous aimez",
        subtitle: "Découvrez vos produits favoris",
        scrollPrev: "Faire défiler les favoris vers la gauche",
        scrollNext: "Faire défiler les favoris vers la droite"
      },
      categories: {
        badge: "Nos services",
        title: "Catégories populaires",
        subtitle: "Des centaines de produits digitaux disponibles, livrés instantanément dans votre boîte email",
        gaming: { title: "Cartes & Codes Gaming", desc: "PlayStation, Xbox, Steam, Nintendo, Free Fire, PUBG..." },
        giftCards: { title: "Cartes Cadeaux", desc: "Amazon, Google Play, App Store, Spotify, Netflix..." },
        mobile: { title: "Recharges Mobile", desc: "Ooredoo, Orange, Tunisie Telecom, forfaits internet..." },
        licenses: { title: "Licences & Abonnements", desc: "Windows, Office, Antivirus, VPN, Canva Pro, Adobe..." }
      },
      steps: {
        step1: { title: "Choisissez votre produit", desc: "Parcourez notre catalogue et sélectionnez le service digital dont vous avez besoin. Codes gaming, cartes cadeaux, licences..." },
        step2: { title: "Payez en toute sécurité", desc: "Réglez par solde interne, carte bancaire D17 ou virement. Toutes les transactions sont sécurisées et chiffrées." },
        step3: { title: "Recevez instantanément", desc: "Votre code ou licence est livré automatiquement par email et dans votre espace client. Aucune attente, 24h/24." }
      },
      howItWorks: {
        badge: "Simple & rapide",
        title: "Comment ça marche ?",
        subtitle: "3 étapes simples pour recevoir vos produits digitaux en moins d'une minute"
      },
      features: {
        badge: "Nos avantages",
        title: "Pourquoi choisir eServices ?",
        subtitle: "Une plateforme pensée pour votre confort, votre sécurité et votre satisfaction",
        instant: { title: "Livraison instantanée", desc: "Recevez vos codes et licences immédiatement après paiement. Système 100% automatisé, disponible 24h/24 et 7j/7." },
        secure: { title: "Paiements 100% sécurisés", desc: "Transactions chiffrées SSL, protection Cloudflare, et conformité aux standards de sécurité les plus stricts." },
        variety: { title: "Large choix de services", desc: "Des centaines de produits : gaming, streaming, logiciels, cartes cadeaux, recharges mobiles et bien plus encore." },
        automated: { title: "Système automatisé 24/7", desc: "Aucune intervention humaine nécessaire. Commandez à toute heure, recevez instantanément, même la nuit ou le weekend." },
        support: { title: "Support client réactif", desc: "Une équipe dédiée pour répondre à vos questions via le système de tickets, Facebook et Instagram." },
        pricing: { title: "Prix compétitifs", desc: "Les meilleurs tarifs du marché tunisien. Pas de frais cachés, prix affichés en Dinar Tunisien (DT)." }
      },
      testimonials: {
        badge: "Avis vérifiés",
        title: "Ce que nos clients disent",
        subtitle: "Rejoignez des milliers de clients satisfaits à travers toute la Tunisie",
        reviewsCount: "Plus de 2000 avis positifs",
        roles: { gamer: "Gamer passionné", entrepreneur: "Entrepreneure", student: "Étudiant" },
        reviews: {
          review1: "Service incroyable ! J'ai reçu mon code PlayStation Store en moins de 30 secondes. C'est devenu ma référence pour tous mes achats gaming.",
          review2: "J'utilise eServices pour mes licences professionnelles. Prix imbattables et livraison instantanée. Je recommande à tous mes collègues !",
          review3: "Parfait pour les cartes cadeaux Netflix et Spotify. Le support est super réactif et les prix sont les meilleurs que j'ai trouvés en Tunisie."
        }
      },
      security: {
        badge: "100% Sécurisé",
        title: "Votre sécurité est notre priorité absolue",
        subtitle: "Nous utilisons les technologies les plus avancées pour protéger vos données personnelles et vos transactions financières.",
        encryption: { title: "Chiffrement SSL 256-bit", desc: "Toutes vos données et transactions sont protégées par un chiffrement de niveau bancaire." },
        cloudflare: { title: "Protection Cloudflare", desc: "Notre plateforme est protégée contre les attaques DDoS et les menaces web par Cloudflare." },
        supabase: { title: "Base de données sécurisée", desc: "Infrastructure Supabase avec authentification renforcée et sauvegarde automatique." },
        automated: { title: "Livraison sans intervention", desc: "Système entièrement automatisé. Vos codes sont générés et livrés sans manipulation humaine." },
        uptime: "Disponibilité garantie",
        ssl: "Chiffrement avancé"
      },
      cta: {
        badge: "Inscription 100% gratuite",
        title: "Prêt à recevoir vos services digitaux en quelques secondes ?",
        subtitle: "Rejoignez des milliers de clients satisfaits. Créez votre compte en 30 secondes et profitez de la livraison instantanée.",
        button: "Créer mon compte gratuitement",
        trust: "✓ Sans engagement  ✓ Sans carte bancaire  ✓ Accès immédiat à tous les services"
      }
    },
    Profile: {
      appName: "eServices",
      header: {
        title: "Mon Profil"
      },
      subtitle: "Compte client eServices.tn",
      state: {
        loading: "Chargement du profil..."
      },
      success: {
        message: "Profil mis à jour avec succès !"
      },
      section: {
        title: "Informations Personnelles",
        personal: "Informations personnelles",
        contact: "Contact & sécurité"
      },
      actions: {
        cancel: "Annuler",
        saving: "Sauvegarde...",
        save: "Sauvegarder",
        edit: "Modifier"
      },
      avatar: {
        change: "Changer"
      },
      form: {
        firstName: "Prénom",
        lastName: "Nom",
        email: "Email",
        phone: "Téléphone",
        address: "Adresse",
        phoneEmpty: "Non renseigné"
      },
      security: {
        note: "Ces informations sont utilisées pour la connexion, la récupération de compte et les notifications importantes."
      },
      validation: {
        phoneInvalid: "Format de téléphone invalide. Utilisez +216 XX XXX XXX"
      }
    },
    ClientServices: {
      header: {
        title: "Services"
      },
      Categories: {
        section: {
          mobileTopups: "Recharges et forfaits pour tous les opérateurs.",
          internationalPayments: "Vous pouvez acheter de n'importe quel site international et payer en dinar tunisien.",
          customDocuments: "Personnalisez vos documents graphiques, éducatifs et administratifs.",
          subscriptions: "Services de streaming, jeux et plus encore."
        }
      },
      SubCategories: {
        section: {
          graphicDesign: "Services de design graphique et création visuelle",
          tunisieTelecom: "Services et recharges Tunisie Télécom",
          internationalTransactions: "Solutions de paiement pour transactions internationales",
          ooredooTunisie: "Services et recharges Ooredoo Tunisie",
          localTransactions: "Solutions de paiement pour transactions locales",
          orangeTunisie: "Services et recharges Orange Tunisie",
          streamingVideoMusic: "Services de streaming vidéo et musique",
          gamingServices: "Jeux vidéo et services gaming",
          appsAndSoftware: "Applications et logiciels divers",
          educationalResources: "Documents et ressources pédagogiques",
          certificatesGeneration: "Génération de certificats et attestations",
          administrativeDocuments: "Traitement de documents administratifs",
          secureOnlinePayments: "Services de paiement sécurisé en ligne",
          onlineCourses: "Formations et cours en ligne",
          productivityTools: "Outils pour améliorer la productivité"
        }
      },
      navigation: {
        back: "Retour",
        allCategories: "Toutes les catégories"
      },
      state: {
        loading: "Chargement...",
        loadError: "Impossible de charger les services.",
        emptyProducts: "Aucun produit trouvé."
      }
    },
    CategoryCard: {
      content: {
        noDescription: "Aucune description"
      }
    },
    MyCodes: {
      appName: "eServices",
      header: {
        title: "Mes Codes"
      },
      actions: {
        refreshTitle: "Actualiser la liste"
      },
      alert: {
        deliveryPendingTitle: "Livraison en attente",
        deliveryPendingMessage: "Certains de vos codes récents n'ont pas pu être livrés automatiquement suite à un problème technique. Ne vous inquiétez pas : nos administrateurs ont été prévenus et vont assigner vos codes manuellement très prochainement après validation de votre commande.",
        checkOrders: "Vérifier mes commandes",
        openTicket: "Ouvrir un ticket d'aide"
      },
      sidebar: {
        history: "Historique"
      },
      state: {
        loading: "Chargement..."
      },
      empty: {
        message: "Aucun code trouvé."
      },
      badges: {
        code: "Code",
        licence: "Licence",
        compte: "Compte",
        acces: "Accès",
        lien: "Lien"
      },
      fallback: {
        product: "Produit"
      },
      security: {
        title: "Consignes de sécurité",
        description: "Ce code est strictement confidentiel. Ne partagez jamais de captures d'écran ou le texte de ce code avec des tiers. Pour tout problème technique, contactez notre support client.",
        refLabel: "REF:",
        batchIdLabel: "BATCH ID:"
      },
      selectHint: {
        title: "Sélectionnez un code dans la liste pour voir les détails.",
        description: "Veuillez choisir un code ou un accès dans la liste pour voir les détails."
      }
    },
    MobileManageOrders: {
      list: {
        title: "Commandes",
        subtitle: "Gérez les commandes des clients",
        totalAmount: "Montant total",
        paymentMethod: "Moyen de paiement",
        itemsCount: "Articles ({{count}})",
        moreItems_one: "+1 autre article",
        moreItems_other: "+{{count}} autres articles",
        details: "Détails",
        detailsA11y: "Voir les détails de la commande"
      },
      empty: {
        title: "Aucune commande",
        description: "Aucune commande reçue."
      },
      modal: {
        orderTitle: "Commande #{{id}}",
        close: "Fermer",
        client: "Client",
        deliveryPerProduct: "Livraison par produit",
        accountEmail: "Identifiant / Email",
        pAccountEmail: "email@exemple.com",
        password: "Mot de passe",
        invitationUrl: "URL d'invitation / Email",
        licenceKey: "Clé de licence",
        certificateLink: "Lien certificat (optionnel)",
        trackingLink: "Lien de tracking",
        pTracking: "N° tracking ou lien",
        clientNote: "Note au client",
        pNote: "Ex: En cours, C'est fait...",
        code: "Code",
        pCode: "Code envoyé par email",
        assignedCodes: "Codes assignés",
        deliveryStatus: "Statut livraison",
        inDelivery: "En livraison",
        delivered: "Livré",
        payment: "Paiement",
        status: "Statut",
        items: "Articles",
        total: "Total",
        unsavedConfirm: "Données non enregistrées. Fermer quand même ?"
      },
      status: {
        instantCodesDone: "Cette commande a deja livre des codes instantanes. Le statut 'Terminee' ne peut pas etre applique une deuxieme fois."
      }
    },
    MobileTicketClients: {
      header: {
        title: "Clients avec Tickets"
      },
      search: {
        placeholder: "Rechercher par nom ou email..."
      },
      filters: {
        all: "Tous",
        active: "Actifs",
        inProgress: "En cours",
        closed: "Fermés"
      },
      empty: {
        noClients: "Aucun client trouvé",
        noResultsSearch: "Aucun résultat pour votre recherche.",
        noResults: "Aucun client avec des tickets."
      },
      client: {
        activeCount: "actif(s)",
        lastActivity: "Dernière activité",
        totalTickets: "ticket(s)",
        closedCount: "fermé(s)",
        unknownEmail: "Email inconnu",
        guestClient: "Client invité"
      }
    },
    MobileCheckout: {
      nav: {
        back: "Retour"
      }
    },
    ClientCheckout: {
      appName: "eServices",
      header: {
        title: "Paiement"
      },
      summary: {
        title: "Résumé de la commande",
        preview: "Résumé",
        edit: "Modifier",
        totalToPay: "Total à payer",
        itemsCount: "{{count}} article(s)",
        delivery: "Livraison",
        stampFee: "Timbre fiscal",
        remise: "Remise",
        quantity: "Quantité",
        securePayment: "TTC · Paiement sécurisé",
        estimateHomeDelivery: "Livraison estimée 2–4 j",
        estimateInstant: "Livraison instantanée",
        estimateDigital: "Livraison numérique 1–24 h"
      },
      deliveryNotice: {
        instantTitle: "Livraison instantanée",
        instantMessage: "Votre panier contient des produits à livraison instantanée. Tous les produits de cette commande doivent être payés immédiatement via le solde interne.",
        homeTitle: "Livraison à domicile",
        homeMessage: "Votre commande sera traitée le plus vite possible.",
        emailTitle: "Livraison",
        emailMessage: "Vos codes et informations d'accès seront envoyés par email après validation de votre paiement."
      },
      deliveryInstructions: {
        code_instantane: "Code Instantané",
        mail_compte_code: "Compte + Code (Email)",
        mail_code: "Code (Email)",
        mail_acces: "Accès (Email)",
        mail_licence: "Licence (Email)",
        traitement_lien: "Traitement à distance",
        livraison_domicile: "Livraison à domicile",
        free: "Gratuite"
      },
      payment: {
        title: "Moyen de paiement"
      },
      selectSpecificMethod: "Veuillez sélectionner un moyen de paiement spécifique",
      instructions: "Instructions",
      paymentMethods: {
        solde: "Solde",
        solde_interne: "Solde Interne",
        portefeuille: "Portefeuille mobile",
        flouci: "Flouci",
        d17: "D17",
        izi_pay: "IZI Pay",
        virement: "Virement Bancaire",
        carte: "Carte Bancaire",
        mandat: "Mandat",
        livraison: "Paiement à la livraison",
        p2p: "P2P"
      },
      alerts: {
        limitedMethods: "Note : Votre panier contient des articles à livraison instantanée. Seuls les paiements immédiats sont autorisés pour cette commande.",
        restrictedByProduct: "Certains modes de paiement ne sont pas disponibles pour ce type de produit."
      },
      legal: {
        checkboxLabel: "J'accepte expressément ",
        terms: "Conditions Générales",
        privacy: "Politique de Confidentialité",
        refund: "Politique de Remboursement",
        delivery: "Politique de Livraison",
        and: "et"
      },
      errors: {
        selectMethod: "Veuillez sélectionner une méthode de paiement.",
        selectSpecificMethod: "Veuillez sélectionner un moyen de paiement spécifique.",
        acceptTermsRequired: "Veuillez accepter les conditions générales avant de continuer.",
        invalidInput: "Veuillez vérifier vos informations de paiement.",
        mandatNumberRequired: "Veuillez saisir le numéro du mandat effectué.",
        createError: "Erreur lors de la création de la commande.",
        insufficientStock: "Stock insuffisant pour ce produit : quantité demandée {{requested}}, quantité disponible {{available}}."
      },
      success: {
        title: "Commande Confirmée !",
        message: "Votre commande a été passée avec succès.",
        viewOrders: "Consulter mes commandes"
      },
      solde: {
        current: "Solde actuel :",
        insufficient: "Solde insuffisant. Il vous manque",
        missing: " manquant.",
        sufficient: "Solde suffisant.",
        processing: "Traitement...",
        payBtn: "Payer avec mon Solde",
        cardIcon: "💳"
      },
      flouci: {
        instructionsTitle: "Instructions pour FLOUCI",
        step1: "Envoyez le montant {{amount}} TND vers le compte du numéro suivant :",
        step2: "Saisissez la référence de transaction effectuée :",
        refLabel: "Référence de l'opération (10 chiffres aphanumériques majuscules)",
        refPlaceholder: "ex: ABC123XYZ9",
        verifying: "Vérification...",
        confirmBtn: "Confirmer le paiement",
        validationNote: "Validation sous 10-30 minutes"
      },
      d17: {
        instructionsTitle: "Instructions pour D17",
        step1: "Envoyez le montant {{amount}} TND vers le compte du numéro suivant :",
        step2: "Saisissez le numéro d'autorisation :",
        authLabel: "Le numéro d'autorisation (6 chiffres)",
        authPlaceholder: "ex: 123456",
        verifying: "Vérification...",
        confirmBtn: "Confirmer le paiement"
      },
      izi_pay: {
        instructionsTitle: "Instructions pour IZI Pay",
        step1: "Envoyez le montant {{amount}} TND vers l'identifiant IZI Pay affiché ci-dessous :",
        step2: "Saisissez le code ou la référence de transaction affichée après paiement :",
        authLabel: "Code / référence de transaction (6 chiffres)",
        authPlaceholder: "ex: 123456",
        verifying: "Vérification...",
        confirmBtn: "Confirmer le paiement"
      },
      portefeuille: {
        instructionsTitle: "Paiement par portefeuille mobile",
        step1: "Envoyez le montant {{amount}} vers l’identifiant indiqué ci-dessous (l’application ou le service exact figure sur la fiche du vendeur).",
        step2: "Saisissez la référence ou le code d’opération affiché après le paiement.",
        refLabel: "Référence / code de transaction",
        refPlaceholder: "ex: ABC123XYZ9",
        verifying: "Vérification...",
        confirmBtn: "Confirmer le paiement",
        validationNote: "Validation sous 10–30 minutes selon l'opérateur.",
        accountHolderSeparator: " — "
      },
       virement: {
         title: "Virement Bancaire",
         bankAccounts: "Comptes bancaires",
         instructions: "Effectuez un virement de {{amount}} vers l'un des comptes ci-dessous.",
        rib: "RIB",
        iban: "IBAN",
        labelProof: "Uploader la preuve de virement",
        chooseFile: "Choisir un fichier",
        fileTypes: "Images, PDF (MAX 5MB)",
        btnSending: "Envoi...",
        btnSend: "Envoyer la preuve",
        missingAccountHolder: "Titulaire du compte non fourni",
         accountHolder: "Titulaire",
         proofLabel: "Preuve de paiement (reçu)",
        bankIcon: "🏦"
      },
       selectHint: "Veuillez sélectionner un mode de paiement pour continuer",
       missingIdentifier: "Identifiant non fourni",
       termsAcceptance: "J'ai lu et j'accepte les conditions générales de vente et la politique de confidentialité.",
       confirmOrder: "Confirmer la commande",
      config: {
        keyValue: "{{key}} : {{value}}"
      },
      disabled: {
        notAllowed: "Non autorisé pour ce produit",
        notConfigured: "Non configuré",
        options: "option(s)"
      },
      livraison: {
        desc: "Paiement en espèces lors de la réception de votre commande à domicile.",
        note: "Un supplément de livraison peut s'appliquer. Vous serez contacté pour confirmer l'adresse et le créneau.",
        processing: "Traitement...",
        confirmBtn: "Commander — Paiement à la livraison"
      },
      carte: {
        desc: "Paiement par carte bancaire. Vous recevrez les instructions de paiement après confirmation de la commande.",
        note: "Les détails de paiement par carte vous seront communiqués après validation de votre commande.",
        processing: "Traitement...",
        confirmBtn: "Payer par carte bancaire"
      },
        mandat: {
        instructionsTitle: "Paiement par Mandat",
        desc: "Envoyez le montant via un mandat postal ou bancaire (Mandat Normal, Mandat Minute Poste ou MoneyGram) vers l'un des destinataires ci-dessous, puis saisissez le numéro du mandat.",
        refLabel: "Numéro du mandat",
        refPlaceholder: "ex: 123456789",
        numberHint: "Saisissez uniquement le numéro du mandat (chiffres), il permettra à notre équipe de vérifier votre transaction.",
        verifying: "Vérification...",
        confirmBtn: "Confirmer le paiement",
        validationNote: "Validation sous 30–60 minutes selon l'opérateur."
      },
       p2p: {
         desc: "Transfert direct de personne à personne. Contactez-nous pour obtenir les coordonnées du destinataire.",
         note: "Cette méthode nécessite un contact préalable avec notre équipe pour organiser le transfert.",
         processing: "Traitement...",
         confirmBtn: "Confirmer le transfert P2P"
       }
    },
    NewOrder: {
      appName: "eServices",
      header: {
        title: "Passer une Commande"
      },
      browser: {
        back: "Retour",
        categories: "Catégories"
      },
      state: {
        loading: "Chargement...",
        loadError: "Impossible de charger les services."
      },
      cart: {
        title: "Votre Commande",
        empty: "Votre panier est vide.",
        emptyHint: "Sélectionnez une catégorie pour commencer.",
        removeItem: "Retirer",
        total: "Total"
      },
      errors: {
        selectMethod: "Veuillez sélectionner une méthode de paiement.",
        proofRequired: "Veuillez télécharger une preuve de paiement pour ce mode de paiement.",
        insufficientBalance: "Solde insuffisant. Veuillez recharger votre compte.",
        createError: "Erreur lors de la création de la commande.",
        paymentConfig: "Erreur de configuration des paiements. Veuillez contacter le support."
      },
      success: {
        message: "Commande passée avec succès!"
      },
      payment: {
        label: "Mode de Paiement",
        placeholder: "Choisir une méthode...",
        proofLabel: "Preuve de paiement (Requis)",
        proofHint: "Veuillez uploader une capture d'écran ou un reçu pour valider la transaction.",
        alertNote: "Note :",
        alertMessage: "Certains produits dans votre panier sont en livraison \"Code Instantané\". Seuls les paiements immédiats sont autorisés pour cette commande."
      },
      paymentMethods: {
        solde_interne: "Solde Interne",
        flouci: "Flouci",
        d17: "D17",
        virement: "Virement Bancaire"
      },
      deliveryInstructions: {
        code_instantane: "Code Instantané",
        mail_compte_code: "Compte + Code (Email)",
        mail_code: "Code (Email)",
        mail_acces: "Accès (Email)",
        mail_licence: "Licence (Email)",
        traitement_lien: "Traitement à distance",
        livraison_domicile: "Livraison à domicile"
      },
      actions: {
        submitProcessing: "Envoi en cours...",
        submitConfirm: "Confirmer la Commande"
      }
    },
    CartPage: {
      appName: "eServices",
      title: "Votre Panier",
      itemSingular: "article",
      itemPlural: "articles",
      inBasket: "dans votre panier",
      empty: {
        title: "Votre panier est vide",
        description: "Il semble que vous n'avez pas encore ajouté de produit au panier.",
        browseServices: "Parcourir les services"
      },
      alert: {
        instantMessage: "Votre panier contient des produits à livraison instantanée. Tous les produits de cette commande doivent être payés immédiatement via le solde interne."
      },
      deliveryMethods: {
        code_instantane: "Code instantané",
        mail_compte_code: "Compte par email",
        mail_code: "Code par email",
        mail_acces: "Accès par email",
        mail_licence: "Licence par email",
        traitement_lien: "Traitement par lien",
        livraison_domicile: "Livraison à domicile"
      },
      deliveryInstructions: {
        code_instantane: "Code Instantané",
        mail_compte_code: "Compte + Code (Email)",
        mail_code: "Code (Email)",
        mail_acces: "Accès (Email)",
        mail_licence: "Licence (Email)",
        traitement_lien: "Traitement à distance",
        livraison_domicile: "Livraison à domicile"
      },
      groupCount: {
        article: "article",
        articles: "articles"
      },
      summary: {
        title: "Résumé de la commande",
        subtotal: "Sous-total",
        deliveryFee: "Frais de livraison",
        stampFee: "Timbre fiscal",
        total: "Total",
        ttc: "TTC",
        vatLabel: "Dont TVA (19%) :",
        vatNote: "À titre indicatif - Prix déjà TTC"
      },
      actions: {
        remove: "Retirer",
        minRequired: "Quantité minimum de {{min}} requise pour ce type de produit.",
        checkoutBtn: "Passer la commande",
        loginToCheckout: "Se connecter pour commander",
        continueShopping: "Continuer mes achats"
      },
      unit: "unité",
      securePayment: "Paiement sécurisé"
    },
    MobileDashboard: {
      appName: "eServices",
      banner: {
        welcome: "Bienvenue,",
        totalRevenue: "Chiffre d'affaires total",
        availableBalance: "Solde disponible"
      },
      miniStats: {
        today: "Aujourd'hui",
        deposits: "Dépôts",
        totalOrders: "Total Commandes",
        ticketsSupport: "Tickets Support",
        myOrders: "Mes Commandes",
        myDeposits: "Mes Dépôts"
      },
      adminStats: {
        pendingOrders: "Commandes en attente",
        pendingDeposits: "Dépôts en attente"
      },
      section: {
        seeAll: "Voir tout",
        managementTitle: "Gestion & Administration",
        quickActionsTitle: "Actions Rapides",
        popularProducts: "Produits Populaires",
        lastOrders: "Dernières Commandes",
        recentActivities: "Activités Récentes",
        daySummary: "Résumé du Jour",
        newOrdersToday: "{{count}} nouvelles commandes aujourd'hui."
      },
      quickActions: {
        orders: "Commandes",
        deposits: "Dépôts",
        tickets: "Tickets",
        clients: "Clients",
        products: "Produits",
        stock: "Stock",
        categories: "Catégories",
        media: "Média",
        recharge: "Recharger",
        shop: "Boutique",
        support: "Support",
        history: "Historique"
      },
      promotion: {
        limitedOffer: "Offre Limitée",
        title: "Netflix Premium -20%",
        description: "Profitez du meilleur du streaming à prix réduit."
      },
      empty: {
        noRecentOrders: "Aucune commande récente"
      },
      fallback: {
        product: "Produit"
      },
      orderTitlePrefix: "Commande #"
    },
    errors: {
      network: "Problème de connexion. Veuillez vérifier votre accès internet.",
      timeout: "Le serveur met trop de temps à répondre. Veuillez réessayer.",
      auth: {
        invalid: "Email ou mot de passe incorrect.",
        not_found: "Aucun compte trouvé avec cet email.",
        unconfirmed: "Votre compte n'est pas encore confirmé. Veuillez vérifier votre boîte email et cliquer sur le lien de confirmation. Pensez également à vérifier votre dossier de courrier indésirable (spam).",
        exists: "Un compte existe déjà avec cette adresse email.",
        signup_failed: "Impossible de créer le compte. L'email ou le numéro de téléphone est peut-être déjà utilisé. Vérifiez vos informations ou réessayez plus tard.",
        too_short: "Le mot de passe est trop court (min 6 caractères).",
        expired: "Votre session a expiré. Veuillez vous reconnecter.",
        rate_limit: "Trop de tentatives. Veuillez patienter quelques instants."
      },
      db: {
        duplicate: "Cette information existe déjà dans le système (ex: Email ou Téléphone).",
        constraint: "Action impossible car cet élément est lié à d'autres éléments.",
        denied: "Accès refusé. Vous n'avez pas les permissions nécessaires pour accéder à cette ressource."
      },
      storage: {
        not_found: "Fichier introuvable sur le serveur.",
        too_large: "Le fichier est trop volumineux."
      }
    },
    nav: {
      home: "Accueil",
      services: "Services",
      about: "À Propos",
      contact: "Contact",
      cart: "Panier",
      favorites: "Favoris",
      my_orders: "Mes Commandes",
      my_deposits: "Mes Dépôts",
      my_codes: "Mes Codes",
      my_tickets: "Mes Tickets",
      site_home: "Accueil du site",
      support: "Support",
      admin_panel: "Administration",
      search_order: "Rechercher une commande..."
    },
    dashboard: {
      welcome: "Bienvenue, {{name}} !",
      current_balance: "Solde actuel",
      recent_deposits: "Dépôts récents",
      recent_orders: "Commandes récentes",
      last_30_days: "30 derniers jours",
      download_invoice: "Télécharger la facture",
      no_data: "Aucune donnée disponible",
      items_count: "{{count}} articles",
      view_invoice: "Facture",
      loading: "Chargement du tableau de bord...",
      available_balance: "Solde disponible"
    },
    Dashboard: {
      header: {
        appBadge: "Espace Client",
        securityBadge: "Coffre sécurisé",
        clientOverviewTitle: "Vue client {{name}}",
        activeStatus: "Compte actif"
      },
      stats: {
        balance: "Solde disponible",
        deposits: "Dépôts récents",
        orders: "Commandes récentes",
        pending: "Opérations en attente"
      },
      alerts: {
        lowBalance: "Avertissement : votre solde est insuffisant. Merci d'effectuer un dépôt.",
        pendingOperations: "Alerte : vous avez {{count}} opération(s) en attente."
      },
      orders: {
        invoiceFileLabel: "PDF"
      }
    },
    landing: {
      hero_title: "Tous vos services électroniques",
      hero_subtitle: "au même endroit",
      hero_desc: "Services devient votre plateforme complète pour acheter des services numériques et bien plus. Gérez toutes vos demandes facilement.",
      cta_start: "Commencer",
      cta_services: "Nos Services",
      features: {
        fast: "Rapide et Fiable",
        secure: "Paiements Sécurisés",
        support: "Support 24/7",
        operators: "Tous les Opérateurs"
      },
      how_it_works: "Comment ça marche ?",
      steps: {
        1: "Créez un compte",
        2: "Faites un dépôt",
        3: "Passez une commande"
      },
      testimonials: {
        1: {
        },
        2: {
        },
        3: {
        },
        4: {
        },
        5: {
        },
        title: "Ce que disent nos clients"
      },
      cta_footer: {
        title: "Prêt à simplifier vos recharges ?"
      },
      hero_image_alt: "eServices Illustration"
    },
    cart: {
      title: "Votre Panier",
      empty_title: "Votre panier est vide",
      empty_desc: "Il semble que vous n'avez pas encore ajouté de produit au panier.",
      browse_services: "Parcourir les services",
      mode: "Mode :",
       remove: "Retirer",
       pay: "Payer",
       min_required: "Quantité minimum de {{min}} requise pour ce type de produit.",
      summary_title: "Résumé de la commande",
      subtotal: "Sous-total",
      total: "Total",
      checkout_btn: "Passer la commande",
      login_to_checkout: "Se connecter pour commander",
      continue_shopping: "Continuer mes achats",
      in_your_basket: "dans votre panier",
      extra_fees: "Frais de service"
    },
    checkout: {
      title: "Paiement",
      summary_title: "Résumé de la commande",
      edit: "Modifier",
      total_to_pay: "Total à payer",
      payment_method_title: "Moyen de paiement",
      alerts: {
        limited_methods: "Note : Votre panier contient des articles à livraison instantanée. Seuls les paiements immédiats sont autorisés pour cette commande."
      },
      errors: {
        select_method: "Veuillez sélectionner une méthode de paiement.",
        invalid_input: "Veuillez vérifier vos informations de paiement.",
        create_error: "Erreur lors de la création de la commande.",
        insufficient_stock: "Stock insuffisant pour ce produit : quantité demandée {{requested}}, quantité disponible {{available}}.",
        accept_terms_required: "Veuillez accepter les conditions générales avant de continuer."
      },
      select_hint: "Veuillez sélectionner un mode de paiement pour continuer",
      view_orders: "Consulter mes commandes",
      solde: {
        current: "Solde actuel :",
        insufficient: "Solde insuffisant. Il vous manque",
        sufficient: "Solde suffisant.",
        processing: "Traitement...",
        pay_btn: "Payer avec mon Solde"
      },
      flouci: {
        title: "Payer avec Flouci",
        instructions: "Envoyez le paiement vers le compte du numéro suivant :",
        step1: "1. Ouvrez l",
        no_account: "Aucun compte Flouci configuré.",
        label_id: "Votre ID de Transaction",
        placeholder_id: "ex: ABC123XYZ",
        btn_verifying: "Vérification...",
        btn_confirm: "Confirmer le paiement"
      },
      d17: {
        title: "Payer avec D17",
        instructions: "Envoyez le paiement vers l",
        step1: "1. Ouvrez l",
        no_account: "Aucun compte D17 configuré.",
        step2: "2. Saisissez le code de transaction reçu par SMS.",
        label_code: "Code de Transaction (SMS)",
        placeholder_code: "ex: 12345678",
        btn_verifying: "Vérification...",
        btn_confirm: "Confirmer le paiement"
      },
      izi_pay: {
        title: "Payer avec IZI Pay",
        instructions: "Envoyez le paiement vers l'identifiant IZI Pay indiqué.",
        step1: "1. Ouvrez l'application IZI Pay et envoyez {{amount}} vers l'identifiant ci-dessous.",
        no_account: "Aucun compte IZI Pay configuré.",
        step2: "2. Saisissez le code ou la référence de transaction.",
        label_code: "Code / référence de transaction",
        placeholder_code: "ex: 123456",
        btn_verifying: "Vérification...",
        btn_confirm: "Confirmer le paiement"
      },
      portefeuille: {
        title: "Payer par portefeuille mobile",
        instructions: "Envoyez le montant vers le numéro ou l’identifiant indiqué ci-dessous.",
        step1: "1. Ouvrez l’application de votre opérateur et envoyez {{amount}} vers l’identifiant ci-dessous.",
        no_account: "Aucun compte portefeuille n’est configuré pour ce dépôt.",
        step2: "2. Saisissez la référence ou le code de transaction fourni après le paiement.",
        label_code: "Référence / code de transaction",
        placeholder_code: "ex: ABC123 ou 123456",
        btn_verifying: "Vérification...",
        btn_confirm: "Confirmer le dépôt"
      },
      virement: {
        title: "Virement Bancaire",
        instructions: "Effectuez un virement de {{amount}} vers l",
        rib: "RIB :",
        iban: "IBAN :",
        holder: "Titulaire :",
        no_account: "Aucun compte bancaire configuré.",
        label_proof: "Uploader la preuve de virement",
        choose_file: "Choisir un fichier",
        file_selected: "Fichier sélectionné : {{name}}",
        no_file: "Aucun fichier choisi",
        btn_sending: "Envoi...",
        btn_send: "Envoyer la preuve"
      },
      success: {
        title: "Commande Confirmée !",
        message: "Votre commande a été passée avec succès."
      },
      legal: {
        checkbox_label: "J'accepte expressément les "
      }
    },
    transactionOTP: {
      title: "Confirmer par code",
      subtitle: "Le code sera envoyé au {{phone}}.",
      subtitleWithAmount: "Confirmez votre {{label}} de {{amount}} avec le code qui sera envoyé au {{phone}}.",
      sendCode: "Envoyer le code",
      sending: "Envoi en cours...",
      confirm: "Valider",
      verifying: "Vérification...",
      resend: "Renvoyer",
      cancel: "Annuler",
      expiresIn: "Expire dans {{seconds}} s",
      errorExpired: "Code expiré. Demandez un nouveau code.",
      errorTooMany: "Trop de tentatives. Réessayez plus tard.",
      errorInvalid: "Code invalide. Vérifiez et réessayez.",
      phoneRequired: "Ajoutez votre numéro de téléphone dans votre profil pour confirmer les transactions."
    },
    TransactionOTPModal: {
      a11y: {
        close: "Fermer"
      },
      header: {
        title: "Confirmer par code",
        subtitle:
          "Nous enverrons un code à 6 chiffres au numéro {{phone}} (SMS ou WhatsApp selon les cas).",
        subtitleWithAmount:
          "Pour confirmer votre {{label}} de {{amount}}, nous enverrons un code à 6 chiffres au {{phone}}."
      },
      send: {
        sendCode: "Envoyer le code",
        sending: "Envoi du code en cours…",
        phoneInvalid:
          "Nous ne pouvons pas envoyer le code : le numéro semble absent ou incorrect. Vérifiez-le dans votre profil."
      },
      testAccount: {
        a11yTitle: "Confirmation de la transaction (compte test)",
        loading: "Finalisation de votre opération…",
        error:
          "L'opération n'a pas pu se terminer. Utilisez « Réessayer » ou fermez cette fenêtre.",
        retry: "Réessayer",
        close: "Fermer"
      },
      postVerify: {
        error:
          "Votre code est bon, mais la transaction n'a pas abouti. Réessayez. Si le problème continue, contactez le support."
      },
      code: {
        expiresIn: "Le code expire dans {{seconds}} s",
        verifying: "Vérification du code…",
        confirm: "Confirmer",
        resend: "Renvoyer le code",
        resendWithCountdown: "{{label}} ({{seconds}}s)"
      },
      footer: {
        cancelDecorated: "─── Annuler ───"
      }
    },
    otpErrors: {
      send: {
        invalid_phone: "Le numéro de téléphone est invalide ou manquant. Vérifiez le format (ex. 216 XXXXXXXX).",
        rate_limited: "Trop de demandes de code. Attendez quelques minutes avant d'en demander un nouveau.",
        api_error: "Impossible d'envoyer le code pour le moment. Réessayez plus tard ou contactez le support.",
        ip_blocked: "Trop de demandes depuis votre connexion. Réessayez dans 1 heure ou plus tard. Si le problème persiste, contactez le support.",
        network: "Problème de connexion. Vérifiez votre internet et réessayez."
      },
      verify: {
        invalid_code: "Le code saisi est incorrect. Vérifiez les 6 chiffres et réessayez.",
        expired: "Ce code a expiré. Cliquez sur « Renvoyer » pour recevoir un nouveau code.",
        too_many_attempts: "Le nombre maximum de tentatives pour ce code a été atteint. Veuillez demander un nouveau code.",
        ip_blocked: "Trop de demandes depuis votre connexion. Réessayez dans 1 heure ou plus tard.",
        network: "Problème de connexion. Vérifiez votre internet et réessayez."
      },
      code_length: "Le code doit contenir exactement 6 chiffres."
    },
    rateLimitingPolicy: {
      title: "Limites d'utilisation et politique de sécurité",
      subtitle: "Informations sur les limites de requêtes et les mesures de sécurité appliquées sur la plateforme.",
      lastUpdate: "Dernière mise à jour :",
      intro: "Pour protéger la plateforme et tous les utilisateurs contre les abus (envoi massif de codes, inscriptions frauduleuses, etc.), nous appliquons des limites par adresse IP et par action. Voici le détail des politiques en vigueur.",
      tips: {
        sectionTitle: "Pour une bonne expérience : que faire pour éviter les blocages",
        intro: "En suivant ces quelques règles simples, vous éviterez tout blocage ou message de limite dépassée.",
        tip1: "Saisissez le code reçu (SMS/WhatsApp) dans les 10 minutes et avec attention — au maximum 5 essais par code.",
        tip2: "Attendez au moins 10 minutes entre deux demandes de « Nouveau code » pour le même numéro.",
        tip3: "Évitez d’enchaîner de nombreuses opérations (commande + dépôt + renvois) en très peu de temps ; espacez-les de quelques minutes si possible.",
        tip4: "Utilisez de préférence une connexion stable (Wi‑Fi ou 4G) pour ne pas multiplier les tentatives inutiles.",
        tip5: "En cas de message de blocage, attendez le délai indiqué (ex. 10 min, 1 heure, 24 h) ou contactez le support si vous estimez qu’il s’agit d’une erreur."
      },
      otp: {
        sectionTitle: "1. Codes de vérification (OTP)",
        intro: "Les codes à 6 chiffres envoyés par WhatsApp (ou SMS) pour la connexion, la confirmation de téléphone et la validation des transactions (dépôt, achat) sont soumis aux règles suivantes :",
        limit10m: "Limite de 5 envois maximum par type d'action (connexion, dépôt, commande, admin) sur 10 minutes.",
        limit10mBlock: "Chaque type d'action a son propre quota ; après 5 envois pour une même action en 10 min, blocage de 10 min pour cette action.",
        limitPerAction: "Les compteurs sont séparés par action : connexion, dépôt, commande et admin n'utilisent pas le même quota sur 10 minutes.",
        limitDay: "Limite quotidienne de 20 envois par numéro sur 24 heures (toutes actions confondues).",
        limitDayBlock: "À 20 envois atteints, blocage automatique pour 24 heures.",
        oneCodeActive: "Un seul code actif à la fois par numéro.",
        maxAttemptsPerCode: "5 essais maximum par code.",
        maxAttemptsBlock: "Après 5 tentatives incorrectes, le code devient invalide et un nouveau code doit être demandé.",
        blockVerify: "Dépassement 5 tentatives de validation : code OTP invalidé, demander un nouveau code.",
        codeValidity: "Validité du code : 10 minutes après génération.",
        blockTitle: "En cas de dépassement :",
        block10m: "Dépassement des 5 envois / 10 min pour une action : blocage de 10 minutes pour cette action.",
        blockDay: "Dépassement des 20 envois / 24 h : blocage pour 24 heures.",
        blockExtreme: "Abus manifeste (très grand nombre de requêtes) : blocage prolongé possible."
      },
      register: {
        sectionTitle: "2. Inscription (création de compte)",
        intro: "Les tentatives de création de compte depuis une même connexion sont limitées comme suit :",
        limit1h: "Limite de 3 inscriptions maximum par heure.",
        limitDay: "Limite quotidienne de 10 inscriptions par jour.",
        blockTitle: "En cas de dépassement :",
        block1h: "Blocage de 1 heure après 3 inscriptions en une heure.",
        block1hAfter: "Après 3 inscriptions en une heure, blocage de 1 heure.",
        blockDay: "À 10 inscriptions atteintes, blocage pour 24 heures.",
        blockExtreme: "Abus manifeste : blocage prolongé possible.",
        waitTime: "Temps d'attente conseillé : 20 minutes minimum entre chaque inscription."
      },
      general: {
        sectionTitle: "3. Comportement général",
        byIp: "Les limites sont comptées par adresse IP individuellement. Un même réseau Wi‑Fi ou partage de connexion partage ces limites.",
        noAccount: "Les restrictions s'appliquent même sans compte utilisateur : toute requête vers les services concernés est prise en compte.",
        contact: "Si vous êtes bloqué alors que vous utilisez la plateforme normalement, contactez le support (contact@eservices.tn) en indiquant votre situation.",
        tableNote: "Les temps d'attente indiqués sont des recommandations pour éviter les blocages automatiques ; les durées de blocage sont appliquées par le système."
      },
      table: {
        title: "Récapitulatif des limites",
        action: "Action",
        limit: "Limite",
        waitTime: "Temps d'attente conseillé",
        blockDuration: "Blocage en cas de dépassement",
        rowSendOtp: "Envoi OTP",
        sendOtpLimit: "5 / 10 min (par action)",
        rowValidateOtp: "Validation OTP",
        validateOtpLimit: "5 essais par code",
        validateOtpWait: "Demander un nouveau code si les tentatives sont dépassées",
        validateOtpBlock: "Code OTP invalidé",
        rowDailyOtp: "Envois quotidiens OTP",
        rowRegister: "Inscription",
        rowDailyRegister: "Inscriptions quotidiennes",
        waitExpiration: "Attendre expiration du code",
        spaceOut: "Espacer les envois",
        limitCreations: "Limiter les créations",
        rowIpBlock: "Blocage IP (opérations successives sans attente)",
        limitSuccessive: "Trop de requêtes ou actions rapprochées",
        waitBetweenActions: "Quelques minutes entre chaque action",
        blockIpDuration: "1 h à 24 h (selon le cas)"
      },
      footer: "Ces politiques peuvent être ajustées pour améliorer la sécurité ou l’expérience utilisateur. Les valeurs indiquées ci-dessus reflètent la configuration actuelle."
    },
    contact: {
      page_title: "Contactez-nous",
      page_subtitle: "Nous sommes là pour vous aider. Envoyez-nous un message et nous vous répondrons dès que possible.",
      info_emails_title: "Envoyez un email",
      info_label_general: "Général",
      info_label_support: "Support",
      info_label_sales: "Ventes",
      info_phones_title: "Appelez-nous",
      info_address_title: "Rendez-nous visite",
      form_title: "Envoyer un message",
      label_name: "Nom",
      placeholder_name: "Votre nom",
      label_email: "Email",
      placeholder_email: "votre@email.com",
      label_phone: "Téléphone",
      placeholder_phone: "+216 21 380 039",
      label_subject: "Sujet",
      subject_general: "Question générale",
      subject_support: "Support technique",
      subject_sales: "Ventes et partenariats",
      subject_other: "Autre",
      label_message: "Message",
      placeholder_message: "Comment pouvons-nous vous aider ?",
      btn_sending: "Envoi...",
      btn_submit: "Envoyer le message",
      footer_text: "Notre équipe est disponible 24/7 pour répondre à vos questions.",
      error_required: "Veuillez remplir tous les champs obligatoires.",
      ticket_subject: "{{theme}} - {{name}}",
      success_message: "Votre message a été envoyé avec succès !"
    },
    faq: {
      title: "Foire Aux Questions",
      subtitle: "Trouvez des réponses à toutes vos questions sur l",
      question: "Comment effectuer une commande ?"
    },
    servicesPage: {
      hero: {
        titleFavorites: "Vos Favoris",
        titleAll: "Découvrez nos services",
        subtitleFavorites: "Retrouvez ici tous les produits que vous avez aimés.",
        subtitleAll: "Des solutions pour tous vos besoins numériques et de communication."
      },
      filters: {
        category: "Catégorie",
        categoryAll: "Toutes les catégories",
        subcategory: "Sous-catégorie",
        subcategoryAll: "Toutes",
        availability: "Disponibilité",
        availabilityAll: "Tous les statuts",
        saleType: "Type de vente",
        saleTypeAll: "Tous les types",
        saleTypeDetail: "Détail",
        saleTypeGros: "Gros",
        search: "Rechercher",
        searchPlaceholder: "Nom, valeur..."
      },
      state: {
        loading: "Chargement..."
      },
      empty: {
        favorites: "Vous n'avez pas de favoris.",
        search: "Aucun produit ne correspond à vos critères."
      }
    },
    ServicesPage: {
      hero: {
        logo: "eServices",
        titleFavorites: "Vos Favoris",
        titleAll: "Découvrez nos services",
        subtitleFavorites: "Retrouvez ici tous les produits que vous avez aimés.",
        subtitleAll: "Des solutions pour tous vos besoins numériques et de communication."
      },
      filters: {
        category: "Catégorie",
        categoryAll: "Toutes les catégories",
        subcategory: "Sous-catégorie",
        subcategoryAll: "Toutes",
        availability: "Disponibilité",
        availabilityAll: "Tous les statuts",
        saleType: "Type de vente",
        saleTypeAll: "Tous les types",
        saleTypeDetail: "Détail",
        saleTypeGros: "Gros",
        search: "Rechercher",
        searchPlaceholder: "Nom, valeur..."
      },
      state: {
        loading: "Chargement..."
      },
      empty: {
        favorites: "Vous n'avez pas de favoris.",
        search: "Aucun produit ne correspond à vos critères."
      }
    },
    product: {
      product: "Produit",
      price_total: "Prix Total",
      item: "article",
      items: "articles",
      delivery_method: "Mode de livraison",
      similar_products: "Produits similaires",
      adding: "Ajout...",
      added: "Ajouté",
      add_to_cart: "Ajouter au panier",
      unavailable: "Produit non disponible",
      add: "Ajouter",
      soon_available: "Bientôt disponible",
      out_of_stock: "Rupture de stock",
      see_options: "Voir les options",
      badges: {
        wholesale: "Gros (Min {{min}})",
        sold_out: "Épuisé",
        incoming: "Arrivage",
        best_seller: "Top Vente",
        soon: "Bientôt"
      },
      card: {
        decrease_qty: "Diminuer quantité",
        increase_qty: "Augmenter quantité",
        remove_favorite: "Retirer des favoris",
        add_favorite: "Ajouter aux favoris"
      },
      alerts: {
        min_qty: "La quantité minimale pour ce produit est de {{min}}.",
        required_field: "Le champ {{label}} est requis",
        select_option: "Veuillez sélectionner une option pour : {{label}}",
        upload_login: "Vous devez être connecté pour uploader des fichiers.",
        upload_error: "Erreur lors de l",
        add_error: "Erreur lors de l",
        rating_required: "Veuillez donner une note."
      },
      breadcrumb: {
        home: "Accueil",
        services: "Services",
        category: "Catégorie"
      },
      preferences: {
        required: "(Requis)",
        included_features: "Fonctionnalités incluses :"
      },
      gallery: {
        view: "Vue",
        unavailable: "Image non disponible"
      },
      reviews: {
        title: "Avis Clients",
        based_on: "Basé sur {{count}} avis",
        write_review: "Écrire un avis",
        rating_label: "Note",
        comment_label: "Commentaire",
        comment_placeholder: "Partagez votre expérience...",
        submitting: "Envoi...",
        submit: "Envoyer l",
        login_to_review: "Veuillez vous connecter pour laisser un avis.",
        login_link: "Se connecter",
        count: "({{count}} avis)",
        empty: "Aucun avis pour le moment."
      }
    },
    ProductDetailPage: {
      state: {
        loading: "Chargement...",
        notFound: "Produit introuvable."
      },
      hero: {
        reviewsCount: "{{count}} avis"
      },
      description: {
        title: "Ce que vous obtenez",
        subtitle: "Fonctionnalités incluses"
      },
      configurator: {
        title: "Personnalisation & Options",
        required: "Requis",
        amountPlaceholder: "Saisir montant",
        currencyUnit: "DT",
        fileUploading: "Chargement...",
        fileAdded: "Fichier ajouté",
        addFile: "Ajouter un fichier",
        uploadError: "Erreur d'upload.",
        includedWithChoices: "Inclus avec vos choix",
        unitPrice: "Prix unitaire",
        estimatedTotal: "Total estimé",
        minQuantityGros: "Quantité minimum : {{min}} (vente en gros)"
      },
      cta: {
        soldOut: "Épuisé",
        orderNow: "Commander maintenant"
      },
      similar: {
        title: "Produits similaires",
        items: "articles"
      },
      preferences: {
        labels: {
          typeDeCompte: "Type de compte",
          fullName: "Nom et prénom",
          phone: "Téléphone",
          email: "Email",
          duree: "Durée",
          productLink: "Lien De produit à acheter",
          productPriceTnd: "Prix de produit en (TND)",
          productScreenshot: "Capture de produit",
          intlDelivery: "Livraison Internationale",
          subscriptionDuration: "Durée d'abonnement",
          language: "Langue",
          regionalAdmin: "Administration régionale",
          school: "Établissement scolaire",
          teacherName: "Nom de l'enseignant",
          levelsTaught: "Niveaux enseignés",
          sheetCount: "Nombre de feuilles (recto / verso)",
          spiralBinding: "Spiralisation",
          templateNumber: "N° de Template",
          otherInstructions: "Autres consignes",
          printing: "Impression"
        },
        options: {
          yearlyOffer: "Offre annuel",
          lifetimeOffer: "Offre à vie",
          oneYear: "1 Année",
          oneMonth: "1 Mois",
          threeMonths: "3 Mois",
          fourMonths: "4 Mois",
          sixMonths: "6 Mois",
          twelveMonths: "12 Mois",
          essentiel: "Essentiel",
          standard: "Standard",
          premium: "Premium",
          free: "Gratuit",
          paid: "Payée",
          french: "Français",
          english: "Anglais",
          arabic: "Arabe",
          sheets40: "40",
          sheets60: "60",
          sheets80: "80",
          spiralPlastic: "Spirale plastique",
          spiralMetal: "Spirale métallique",
          hotBinding: "reliure à chaud",
          blackWhite: "Noir Blanc",
          color: "Couleur",
          shared: "Partagé",
          personal: "Personnel"
        },
        features: {
          productPriceInflated: "le prix du produit sera gonflé",
          productPriceReduced: "le prix du produit sera réduit",
          smallPrice90Days: "Petit prix sur 90 jours",
          bestValue: "Meilleur compromis",
          upTo2MonthsFree: "Jusqu'à 2 mois offerts",
          netflix1Device: "Regardez Netflix Tunisie sur 1 appareil compatible à la fois",
          netflix2Devices: "Regardez Netflix Tunisie sur 2 appareil compatible à la fois",
          netflix4Devices: "Regardez Netflix Tunisie sur 4 appareil compatible à la fois",
          netflix720p: "Regardez Netflix Tunisie en 720p (HD)",
          netflix1080p: "Regardez Netflix Tunisie en 1080p (Full HD)",
          netflix4k: "Regardez Netflix Tunisie en 4K (Ultra HD) + HDR",
          download1Device: "Téléchargez des titres sur 1 appareil compatible à la fois",
          download2Devices: "Téléchargez des titres sur 2 appareil compatible à la fois",
          download6Devices: "Téléchargez des titres sur 6 appareil compatible à la fois"
        }
      }
    },
    orders: {
      page_title: "Mes Commandes",
      empty: "Aucune commande trouvée.",
      processing_message: "Votre commande est en cours de traitement. Vous serez notifié par email sous peu.",
      view_codes: "Voir les codes",
      track_package: "Numéro de suivi"
    },
    deposits: {
      page_title: "Mes Dépôts",
      new_deposit: "Nouveau Dépôt",
      amount_label: "Montant",
      payment_method: "Méthode de Paiement",
      instructions_header: "Instructions de Paiement",
      proof_label: "Preuve de Paiement",
      history_title: "Historique des Dépôts",
      empty: "Aucun dépôt trouvé.",
      submit_btn: "Soumettre le Dépôt"
    },
    my_codes: {
      title: "Mes Codes",
      history: "Historique",
      select_hint: "Sélectionnez un code dans la liste pour voir les détails.",
      empty_codes: "Aucun code trouvé.",
      security_title: "Consignes de sécurité",
      security_desc: "Ce code est strictement confidentiel. Ne partagez jamais de captures d",
      history_desc: "Veuillez choisir un code dans la liste pour voir les détails."
    },
    tickets: {
      page_title: "Tickets Support",
      open_new: "Ouvrir un ticket",
      subject: "Sujet",
      type: "Type",
      status: "Statut",
      last_update: "Dernière MàJ",
      no_tickets: "Aucun ticket trouvé.",
      form_title: "Nouveau Ticket",
      message_placeholder: "Décrivez votre problème...",
      attachment: "Pièce jointe (Optionnel)",
      back_to_list: "← Retour à la liste des tickets",
      reply_placeholder: "Réponse...",
      sending: "Envoi...",
      reply_btn: "Envoyer la réponse",
      close_ticket: "Fermer le ticket",
      close_confirm_title: "Confirmer la fermeture",
      close_confirm_message: "Êtes-vous sûr de vouloir fermer ce ticket ? Une fois fermé, vous ne pourrez plus y répondre."
    },
    SupportTickets: {
      table: {
        id: "ID",
        title: "Mes Tickets",
        lastUpdate: "Dernière mise à jour :",
        ticketSingular: "ticket",
        ticketPlural: "tickets"
      },
      empty: {
        description: "Créez un ticket pour toute question, problème technique ou réclamation ; notre équipe vous répondra rapidement."
      },
      context: {
        orderRef: "Référence commande :",
        module: "Module concerné :",
        environment: "Environnement :"
      },
      modal: {
        info: {
          autoContactInfo: "Votre compte sera automatiquement associé à ce ticket (nom, email)."
        }
      },
      form: {
        type: {
          orderIssue: "Problème Commande"
        },
        order: {
          relatedOrderLabel: "Commande concernée",
          selectOrderPlaceholder: "Sélectionnez une commande",
          noOrders: "Vous n'avez aucune commande."
        },
        support: {
          moduleLabel: "Module concerné (optionnel)",
          modulePlaceholder: "Ex : Paiement, Mes codes, Livraison...",
          environmentLabel: "Environnement (optionnel)",
          environmentPlaceholder: "Ex : Chrome 120, Windows 11 / Safari iOS 17..."
        }
      },
      messages: {
        selectOrderRequired: "Veuillez sélectionner la commande concernée.",
        createdRef: "Ticket #{{ref}} créé avec succès. Vous pouvez suivre son avancement ci-dessous."
      }
    },
    profile: {
      information: "Informations",
      balance: "Solde TND",
      orders: "Commandes",
      update_success: "Profil mis à jour !",
      settings: {
        language: "Langue",
        theme: {
          dark: "Mode sombre",
          light: "Mode clair"
        },
        notifications: "Notifications",
        notifications_desc: "Recevoir les notifications"
      },
      security: {
        title: "Sécurité",
        change_password: {
          desc: "Mettez à jour votre mot de passe régulièrement"
        },
        current_password: "Mot de passe actuel",
        new_password: "Nouveau mot de passe",
        confirm_password: "Confirmer le mot de passe",
        forgot_password: "Mot de passe oublié ?",
        update_password: "Mettre à jour le mot de passe",
        tips: {
          1: "Utilisez un mot de passe fort et unique",
          2: "Changez votre mot de passe régulièrement",
          3: "Ne partagez jamais votre mot de passe",
          title: "Conseils de sécurité"
        },
        "2fa": {
          title: "Authentification à deux facteurs",
          disabled: "Protection supplémentaire pour votre compte",
          enable: "Activer la 2FA",
          enabled: "Protection activée",
          regenerate_codes: "Régénérer les codes de récupération",
          disable: {
            title: "Désactiver la 2FA",
            warning: "Pour des raisons de sécurité, veuillez confirmer votre mot de passe pour désactiver la 2FA.",
            confirm: "Désactiver"
          },
          setup: {
            title: "Configuration Google Authenticator",
            step1: "Étape 1 : Ajouter à Google Authenticator",
            step1_1: "Ouvrez Google Authenticator sur votre téléphone",
            step1_2: "Appuyez sur ",
            step1_3: "Sélectionnez ",
            step2: "Étape 2 : Entrer la clé secrète",
            secret_warning: "IMPORTANT : Entrez la clé SANS tirets, espaces ou séparateurs",
            secret_note: "Type : Basé sur le temps | Algorithme : SHA1",
            step3: "Étape 3 : Vérifier le code"
          },
          verify: "Vérifier et activer",
          recovery_codes: {
            title: "Codes de récupération",
            warning: "⚠️ IMPORTANT : Enregistrez ces codes dans un endroit sûr. Ils ne seront plus affichés.",
            saved: "J\\"
          }
        }
      }
    },
    AdminDashboard: {
      header: {
        title: "Tableau de bord administrateur"
      },
      noData: "Aucune donnée disponible",
      filters: {
        period: "Période",
        today: "Aujourd'hui",
        last7Days: "7 derniers jours",
        last30Days: "30 derniers jours",
        last90Days: "90 derniers jours",
        clientType: "Type",
        all: "Tous",
        allFeminine: "Toutes",
        new: "Nouveaux",
        loyal: "Fidèles",
        inactive: "Inactifs",
        spending: "Dépenses",
        low: "Faible",
        medium: "Moyen",
        high: "Élevé"
      },
      exportCsv: "Exporter CSV",
      kpi: {
        totalClients: "Total clients",
        newRegistrations: "Nouveaux inscrits",
        activeClients: "Clients actifs",
        inactiveClients: "Clients inactifs",
        usersWithoutAction: "Inscrits sans action",
        revenueGenerated: "Revenus générés",
        retentionRate: "Taux de rétention",
        mostLoyalClient: "Client le plus fidèle",
        orders: "commandes"
      },
      chartLabels: {
        active: "Actifs",
        inactive: "Inactifs",
        noAction: "Sans action"
      },
      charts: {
        registrationsEvolution: "Évolution des inscriptions",
        revenueEvolution: "Évolution des revenus",
        topLoyalClients: "Top clients fidèles",
        clientDistribution: "Répartition des clients"
      },
      insights: {
        title: "Insights Clients",
        mostLoyal: "Client le plus fidèle",
        atRisk: "Clients à risque",
        noRisk: "Aucun client à risque",
        highPotential: "Nouveaux à fort potentiel",
        noPotential: "Aucun nouveau client à fort potentiel",
        totalSpent: "total dépensé",
        daysAgo: "jours"
      },
      clientsTable: {
        title: "Résumé des clients",
        name: "Nom",
        email: "Email",
        registrationDate: "Date inscription",
        lastActivity: "Dernière activité",
        ordersCount: "Nb commandes",
        totalSpent: "Total dépensé",
        status: "Statut",
        actions: "Actions"
      },
      status: {
        new: "Nouveau",
        loyal: "Fidèle",
        inactive: "Inactif"
      },
      never: "Jamais",
      viewProfile: "Voir profil",
      notAvailable: "N/A",
      unknown: "Inconnu",
      exportHeaders: {
        name: "Nom",
        email: "Email",
        registrationDate: "Date inscription",
        lastActivity: "Dernière activité",
        ordersCount: "Nb commandes",
        totalSpent: "Total dépensé",
        status: "Statut"
      }
    },
    SecurityDashboard: {
      header: {
        title: "Sécurité & Qualité"
      },
      ipBlocked: {
        title: "IP bloquées",
        last24h: "Nouvelles IP bloquées sur 24h"
      },
      ipActivity: {
        title: "Activité IP (24h)",
        hint: "IP ayant frappé des endpoints sensibles"
      },
      otp: {
        title: "OTP (total)",
        sent: "envoyés",
        validationRate: "Taux de validation"
      },
      tickets: {
        openTickets: "Tickets ouverts",
        firstResponse: "Temps moyen 1ʳᵉ réponse"
      },
      reviews: {
        title: "Avis clients (30j)",
        avgRating: "Note moyenne"
      },
      twoFa: {
        title: "Comptes 2FA activée",
        hint: "Utilisateurs avec authentification forte"
      },
      expired: {
        expired24h: "Comptes expirés (24h)",
        hint: "Créés mais non activés dans les délais",
        total: "Comptes expirés au total",
        totalHint: "Historique des comptes nettoyés automatiquement"
      },
      notAvailable: "N/A"
    },
    ManageUsers: {
      header: {
        title: "Gestion des utilisateurs"
      },
      addButton: "Ajouter Client",
      filters: {
        searchPlaceholder: "Rechercher...",
        statusLabel: "Filtrer Statut",
        all: "Tous",
        showAllAccounts: "Afficher tous les comptes",
        showExpiredOnly: "Afficher les comptes expirés",
        deleteSelected: "Supprimer les comptes sélectionnés"
      },
      table: {
        client: "Client",
        status: "Statut",
        balance: "Solde",
        activity: "Activité",
        registration: "Inscription",
        actions: "Actions",
        orders: "Commandes",
        deposits: "Dépôts"
      },
      loading: "Chargement...",
      emptyState: "Aucun client trouvé.",
      messages: {
        fetchError: "Échec du chargement des utilisateurs",
        bulkDeleteSuccess: "Comptes expirés supprimés avec succès.",
        bulkDeleteError: "Erreur lors de la suppression en lot.",
        statusUpdated: "Statut mis à jour.",
        checkDepsError: "Impossible de vérifier les dépendances.",
        deleteSuccess: "Utilisateur supprimé avec succès.",
        deleteError: "Erreur lors de la suppression."
      },
      bulkDelete: {
        confirm: "Supprimer définitivement {{count}} compte(s) expiré(s) ? Cette action est irréversible."
      },
      deleteModal: {
        title: "Supprimer {{name}} ?",
        analyzing: "Analyse des données en cours...",
        hasDependencies: "Attention : Ce client possède {{count}} éléments liés.",
        orders: "Commandes",
        deposits: "Dépôts",
        tickets: "Tickets",
        reviews: "Avis",
        forceDeleteWarning: "Forcer la suppression effacera définitivement tout l'historique lié.",
        noDependencies: "Aucune donnée liée trouvée. La suppression est sans risque.",
        cancel: "Annuler",
        deleting: "Suppression...",
        forceDelete: "Supprimer (Force)",
        confirm: "Confirmer"
      },
      addModal: {
        title: "Nouveau client",
        firstName: "Prénom",
        lastName: "Nom",
        email: "Email",
        password: "Mot de passe",
        phonePlaceholder: "+216 XX XXX XXX",
        address: "Adresse",
        cancel: "Annuler",
        createAccount: "Créer le compte",
        emailInvalid: "Format d'email invalide.",
        phoneInvalid: "Téléphone invalide. Utilisez +216 XX XXX XXX"
      }
    },
    ManageOrders: {
      modal: {
        orderTitle: "Commande #{{id}}",
        close: "Fermer",
        subtotal: "Sous-total",
        deliveryFee: "Frais de livraison",
        stampFee: "Timbre fiscal",
        total: "Total",
        deliveryAction: "Action de Livraison",
        productConcerned: "Produit concerné",
        identifierEmail: "Identifiant / Email",
        emailPlaceholder: "email@exemple.com",
        password: "Mot de passe",
        passwordPlaceholder: "••••••••",
        licenceKey: "Clé de licence",
        licencePlaceholder: "XXXXX-XXXXX-XXXXX-...",
        certificateLink: "Lien certificat (optionnel)",
        urlPlaceholder: "https://...",
        invitationUrl: "URL d'invitation (Canva, Google Family, etc.)",
        trackingLink: "Lien de tracking",
        trackingPlaceholder: "N° tracking ou lien",
        noteToClient: "Note au client",
        notePlaceholder: "Instructions ou message au client...",
        codeLabel: "Code (carte cadeau / bon d'achat)",
        codePlaceholder: "Code envoyé par email",
        codesAssigned: "Codes assignés (livraison automatique)",
        codesAssignedShort: "Codes assignés:",
        codeInstantInfo: "Code instantané : livré automatiquement à la validation de la commande ou déjà affiché dans la liste des produits ci-dessous.",
        saving: "Enregistrement...",
        saveAndSend: "Enregistrer et Envoyer",
        productsCount: "Produits ({{count}})",
        ship: "Expédier",
        delivered: "Livré",
        resolveProblem: "Résoudre le problème",
        resolveTitle: "Résoudre le problème — Commande #{{id}}",
        step: "Étape {{step}}",
        problemType: "Type de problème :",
        action: "Action :",
        quantityToReplace: "Quantité à remplacer par ligne (stock vérifié à la création) :",
        max: "max {{count}}",
        compensationCart: "Panier de compensation (stock vérifié à la création) :",
        chooseProduct: "Choisir un produit",
        add: "Ajouter",
        summaryAndOptions: "Récapitulatif et options :",
        problem: "Problème :",
        actionLabel: "Action :",
        quantities: "Quantités :",
        compensationLines: "{{count}} ligne(s) de compensation",
        internalNote: "Note interne (optionnel)",
        internalNotePlaceholder: "Commentaire pour l'audit...",
        riskLevel: "Niveau de risque (optionnel)",
        notSpecified: "— Non renseigné —",
        riskLow: "Faible",
        riskMedium: "Moyen",
        riskHigh: "Élevé",
        evidenceRequested: "Preuve demandée au client",
        cancel: "Annuler",
        back: "Retour",
        sending: "Envoi...",
        confirm: "Confirmer",
        next: "Suivant",
        remove: "Retirer",
        indicateQuantity: "Indiquez au moins une quantité à remplacer.",
        addCompensation: "Ajoutez au moins un produit à la compensation.",
        instantCodesDelivered: "Cette commande a déjà livré des codes instantanés. Le statut « Terminée » ne peut pas être appliqué une deuxième fois.",
        trackingNumber: "Numéro de suivi"
      },
      filters: {
        searchPlaceholder: "Rechercher par n° commande, client, email...",
        reset: "Réinitialiser",
        type: "Type",
        all: "Toutes",
        standard: "Standard",
        replacement: "Remplacement",
        compensation: "Compensation",
        paid: "Payante",
        free: "Gratuite (0)",
        allStatus: "Tous",
        ordersCount: "{{count}} / {{total}} commande(s)"
      },
      table: {
        typeInfo: "Type / Info",
        replacement: "Remplacement",
        compensation: "Compensation",
        originalOrder: "Commande d'origine",
        problemResolved: "Problème résolu"
      }
    },
    AdminProfile: {
      header: {
        title: "Profil Administrateur",
        cancel: "Annuler",
        saving: "Sauvegarde...",
        save: "Sauvegarder",
        editProfile: "Modifier le profil"
      },
      loading: "Chargement du profil...",
      banner: {
        avatar: "Avatar",
        adminSpace: "Espace administrateur",
        backOffice: "Gestion du back-office eServices.tn",
        securityTitle: "Sécurité du compte",
        securityDescription: "Gardez votre email et votre numéro de téléphone à jour pour une expérience plus sécurisée."
      },
      messages: {
        success: "Profil mis à jour avec succès !",
        error: "Erreur lors de la mise à jour du profil."
      },
      personalInfo: {
        title: "Informations personnelles",
        firstName: "Prénom",
        lastName: "Nom",
        address: "Adresse postale"
      },
      contact: {
        title: "Contact & connexion",
        loginEmail: "Email de connexion",
        phone: "Numéro de téléphone",
        notProvided: "Non renseigné",
        usageNote: "Les informations de contact sont utilisées pour la récupération de compte, les notifications critiques et la double vérification de votre identité."
      }
    },
    admin: {
      nav: {
        dashboard: "Tableau de Bord",
        deposits: "Gérer Dépôts",
        orders: "Gérer Commandes",
        stock: "Gérer Stock",
        products: "Gérer Produits",
        categories: "Gérer Catégories",
        media: "Médiathèque",
        security: "Sécurité",
        users: "Utilisateurs",
        tickets: "Support / Tickets",
        payment_methods: "Méthodes de paiement",
        delivery_settings: "Livraison",
        settings: "Réglages Généraux",
        view_site: "Voir le Site"
      },
      dashboard: {
        title: "Administration",
        total_revenue: "Revenu Total",
        total_users: "Clients Inscrits",
        total_orders: "Total Commandes",
        pending_deposits: "Dépôts en attente",
        revenue_by_operator: "Revenu par Opérateur",
        orders_status: "Statut des Commandes",
        revenue: "Revenu",
        orders: "commandes"
      },
      profile: {
        title: "Profil Administrateur",
        cancel: "Annuler",
        saving: "Sauvegarde...",
        save: "Sauvegarder",
        edit: "Modifier",
        success: "Profil mis à jour avec succès !",
        error: "Erreur lors de la mise à jour du profil.",
        loading: "Chargement du profil...",
        first_name: "Prénom",
        last_name: "Nom",
        email: "Email",
        phone: "Téléphone",
        address: "Adresse",
        avatar: "Avatar"
      },
      preferences: {
        title: "Préférences de Paiement",
        add_method: "Ajouter une méthode",
        update_success: "Préférence mise à jour.",
        create_success: "Nouvelle préférence ajoutée.",
        delete_success: "Préférence supprimée.",
        load_error: "Erreur lors du chargement des préférences.",
        delete_confirm: "Voulez-vous vraiment supprimer cette entrée ?",
        edit_title: "Modifier une méthode de paiement",
        add_title: "Ajouter une méthode de paiement",
        category: "Catégorie",
        category_bank: "Banque",
        category_ccp: "CCP (Poste)",
        category_wallet: "Wallet (Flouci, D17)",
        provider_name: "Nom du prestataire (ex: BTE, Flouci)",
        identifier: "Identifiant principal (RIB, N° Tél)",
        iban_optional: "IBAN (Optionnel)",
        account_holder_optional: "Nom du titulaire (Optionnel)",
        cancel: "Annuler",
        save: "Enregistrer",
        edit_tooltip: "Modifier",
        duplicate_tooltip: "Dupliquer",
        delete_tooltip: "Supprimer",
        identifier_label: "Identifiant / RIB / Tél",
        iban_label: "IBAN",
        holder_label: "Titulaire"
      },
      payment_methods: {
        page_title: "Méthodes de paiement",
        page_subtitle:
          "Configurez les coordonnées de paiement (RIB, portefeuilles, mandats…) visibles par les clients. La logique détaillée (rails, enums, panier) est décrite dans le dépôt : docs/paiement-moyens.md.",
        section_deposits: "Recharge du solde (dépôts)",
        section_deposits_hint: "Enums PostgreSQL deposit_method — sans solde interne.",
        section_orders: "Paiement des commandes",
        section_orders_hint: "Enums order_payment_method — inclut la livraison (paiement à la livraison).",
        section_products: "Moyens autorisés par produit",
        section_products_hint: "Type payment_method[] sur les produits (hors livraison à domicile).",
        rules_title: "Règles appliquées dans l’application",
        rule_deposits: "Les dépôts utilisent uniquement deposit_method (transfert vers identifiant, mandat postal, Flouci, D17, virement bancaire) — jamais le solde interne.",
        rule_instant: "Produit « code instantané » : seul le solde interne est proposé au checkout.",
        rule_non_instant: "Autres modes de livraison : toutes les méthodes de commande pertinentes (solde, livraison, Flouci, D17, virement) selon les règles du panier et du produit.",
        rule_admin_table: "Chaque ligne ci-dessous a un code métier (même valeur que les enums PostgreSQL) et des cases « commande / dépôt / catalogue » pour savoir où les coordonnées s’affichent.",
        credentials_title: "Coordonnées de paiement (admin_payment_settings)",
        disabled_badge: "Désactivé",
        scope_short_order: "Commande",
        scope_short_deposit: "Dépôt",
        scope_short_product: "Catalogue",
        card: {
          sort: "Ordre",
          created: "Créée le",
        },
        payment_setting_category: {
          carte_bancaire: "Carte bancaire",
          carte_prepayee: "Carte prépayée",
          carte_credit: "Carte de crédit",
          carte_debit: "Carte de débit",
          virement_bancaire: "Virement bancaire",
          virement_postal: "Virement / compte postal",
          p2p: "Paiement entre pairs (P2P)",
          portefeuille_electronique: "Portefeuille électronique",
          portefeuille_mobile: "Portefeuille mobile",
          solde_interne: "Solde interne",
          mandat_cash: "Mandat cash",
          mandat_compte: "Mandat sur compte",
          mandat_postal: "Mandat postal",
          mandat_bancaire: "Mandat / transfert bancaire (ex. MoneyGram)",
          cheque_bancaire: "Chèque bancaire",
          cheque_postal: "Chèque postal",
          cheque_vacances: "Chèque vacances",
          especes: "Espèces",
          prelevement_automatique: "Prélèvement automatique",
          cryptomonnaie: "Cryptomonnaie",
          autre: "Autre",
        },
        form: {
          category_group_enum: "Catégories (enum PostgreSQL)",
          category_group_legacy: "Anciennes catégories (texte)",
          method_code: "Code métier (enum)",
          method_code_hint:
            "Codes admin : virement_bancaire, virement_postal (CCP), mandat_postal, mandat_bancaire (ex. MoneyGram), etc. Côté client les enums commande/dépôt gardent virement / postal.",
          optgroup_order_product: "Commande & catalogue — virements banque / postal",
          optgroup_deposit_extra: "Dépôts — mandat postal, mandat bancaire, P2P",
          scope_order: "Utilisable pour le paiement des commandes (checkout)",
          scope_deposit: "Utilisable pour les dépôts / recharges",
          scope_product: "Référence pour le catalogue (moyens autorisés par produit — affichage / règles)",
          sort_order: "Ordre d’affichage",
          instructions: "Instructions (optionnel)",
          instructions_placeholder: "Texte affiché au client pour cette ligne, si besoin.",
          enabled: "Actif",
          error_method_code: "Code métier invalide.",
          error_scope: "Cochez au moins une portée : commande, dépôt ou catalogue.",
          error_identifier_portefeuille:
            "Pour un portefeuille mobile, l’identifiant (n° de téléphone) est obligatoire.",
          error_identifier_phone:
            "Indiquez un numéro de mobile tunisien valide (8 chiffres, préfixes 2, 3, 4, 5 ou 9 après +216).",
          error_identifier_rib_required: "Le RIB est obligatoire pour un virement bancaire.",
          error_identifier_rib_format: "Le RIB doit comporter exactement 20 chiffres.",
          error_identifier_ccp_required: "Le numéro CCP / compte postal est obligatoire pour un virement postal.",
          error_identifier_ccp_format: "Le CCP doit comporter entre 10 et 16 chiffres.",
          identifier_label_portefeuille: "N° de téléphone (mobile TN) — obligatoire",
          identifier_label_virement: "RIB (20 chiffres) — obligatoire",
          identifier_label_virement_postal: "CCP / compte postal — obligatoire",
          identifier_label_mandat: "CIN ou référence (optionnel)",
          identifier_label_optional: "Identifiant (optionnel)",
          error_provider: "Le nom du compte / fournisseur est requis."
        }
      },
      categories: {
        title: "Gestion des Catégories",
        add: "Ajouter Catégorie",
        new_category: "Nouvelle Catégorie",
        name: "Nom",
        desc: "Description",
        cover_image: "Image de couverture",
        subcategories_list: "Sous-catégories :",
        new_subcategory: "Nouvelle Sous-catégorie",
        add_sub: "Ajouter Sous-cat."
      },
      products: {
        title: "Gestion Produits",
        add: "Ajouter",
        edit: "Modifier",
        form: {
          title_new: "Nouveau Produit",
          title_edit: "Modifier Produit",
          name: "Nom du Produit",
          category: "Catégorie",
          price: "Prix de Base (TND)",
          subcategory: "Sous-catégorie",
          description: "Description",
          description_placeholder: "Description détaillée du produit...",
          status_label: "Statut",
          status: {
            on_sale: "En vente",
            incoming: "En arrivage",
            sold_out: "Épuisé"
          },
          value: "Valeur",
          value_placeholder: "Ex: 1 Go, 5 TND...",
          min_quantity: "Quantité minimale",
          delivery_method: "Méthode de livraison",
          sale_type: "Type de vente",
          payment_methods: "Moyens de paiement",
          validated: "Produit validé",
          best_seller: "Meilleure vente",
          duplicate_suffix: "(Copie)",
          show_preview: "Prévisualiser le produit",
          hide_preview: "Masquer la prévisualisation",
          desc: "Description",
          delivery_mode: "Mode de Livraison",
          best_seller_old: "🔥 Top Vente",
          active_product: "Produit Actif",
          save: "Enregistrer",
          images: {
            logo: "1. Logo / Marque",
            main: "2. Image Principale",
            gallery: "3. Autres images (Galerie)"
          },
          preferences: {
            title: "Options Tarifaires",
            add_group: "+ GROUPE D",
            group_placeholder: "Ex: Type de couverture",
            option_placeholder: "Ex: Rigide",
            required: "Requis",
            features_label: "Services inclus (1 par ligne)",
            features_placeholder: "Saisir les fonctionnalités...",
            add_value: "+ NOUVELLE VALEUR",
            conditions: {
              if: "SI",
              group_select: "Groupe...",
              value_select: "Valeur...",
              then_price: "ALORS SUPPLÉMENT =",
              features_label: "SERVICES INCLUS (SI CONDITION)",
              features_placeholder: "Fonctionnalités spécifiques...",
              add: "+ Condition tarifaire"
            }
          },
          delivery_methods: {
            code_instantane: "Code instantané",
            mail_compte_code: "Mail compte code",
            mail_code: "Mail code",
            mail_acces: "Mail accès",
            mail_licence: "Mail licence",
            traitement_lien: "Traitement lien",
        livraison_domicile: "Livraison à domicile",
        free: "Gratuite"
      },
          sale_types: {
            detail: "Détail",
            gros: "Gros"
          },
          payment_methods_labels: {
            solde: "Solde",
            livraison: "Livraison",
            carte: "Carte",
            mandat: "Mandat",
            p2p: "P2P",
            solde_interne: "Solde interne",
            portefeuille: "Portefeuille mobile",
            virement: "Virement",
            flouci: "Flouci",
            d17: "D17",
            izi_pay: "IZI Pay",
            carte_bancaire: "Carte bancaire"
          },
          preview: {
            title: "Prévisualisation",
            preferences: "Personnalisation",
            product_name_placeholder: "Nom du produit",
            value_label: "Valeur",
            select_placeholder: "Sélectionner...",
            input_placeholder: "Entrez {{field}}",
            amount_placeholder: "Montant",
            estimated_total: "Prix total estimé",
            file_placeholder: "Fichier à uploader"
          },
          validation: {
            name_required: "Le nom du produit est requis",
            price_required: "Le prix doit être supérieur à 0",
            subcategory_required: "La sous-catégorie est requise",
            min_quantity_invalid: "La quantité minimale doit être au moins 1",
            preference_label_required: "Le label de la préférence {{index}} est requis",
            preference_options_required: "La préférence \\",
            option_name_required: "Le nom de l"
          },
          submit: {
            processing: "TRAITEMENT...",
            update: "METTRE À JOUR",
            create: "ENREGISTRER LE PRODUIT"
          }
        },
        main_image_section: {
          no_image: "Aucune image",
          upload_pc: "Uploader depuis le PC",
          choose_library: "Choisir depuis la médiathèque",
          format: "Format : JPG, PNG ou SVG. Max 2Mo."
        },
        gallery: {
          add: "+ Ajouter des images",
          empty: "Aucune image dans la galerie.",
          new_label: "Nouveau",
          view: "Vue"
        },
        filter_title: "Filtrer les Produits",
        filters: {
          search_label: "Recherche",
          search_placeholder: "Nom du produit...",
          category_label: "Catégorie",
          subcategory_label: "Sous-catégorie",
          all: "Toutes"
        },
        list: {
          empty: "Aucun produit trouvé",
          base_price_suffix: "(Base)",
          duplicate: "Dupliquer",
          edit: "Modifier",
          delete: "Supprimer"
        },
        messages: {
          confirm_delete: "Supprimer ce produit ?",
          required_error: "Champs requis manquants."
        },
        main_image: "admin.products.main_image",
        validation: {
          name_required: "Le nom du produit est requis",
          price_required: "Le prix doit être supérieur à 0",
          subcategory_required: "La sous-catégorie est requise",
          min_quantity_invalid: "La quantité minimale doit être au moins 1",
          preference_label_required: "Le label de la préférence {{index}} est requis",
          preference_options_required: "La préférence \\",
          option_name_required: "Le nom de l"
        }
      },
      media: {
        title: "Médiathèque",
        sync: "Synchroniser",
        upload: "Upload",
        search: "Rechercher une image...",
        filename: "Nom de fichier",
        type: "Type",
        size: "Taille",
        added_on: "Ajouté le",
        delete_confirm: "Voulez-vous vraiment supprimer ce fichier ?",
        details: "Détails",
        usage: "Utilisation",
        bucket: "Bucket",
        all_buckets: "Tous les buckets"
      },
      tickets: {
        title: "Gestion du Support",
        status_tabs: {
          open: "Ouverts",
          in_progress: "En cours",
          closed: "Fermés",
          all: "Tous"
        },
        filters: {
          all_types: "Tous types",
          all_priorities: "Toutes priorités"
        },
        table: {
          id: "ID",
          client: "Client",
          subject: "Sujet",
          type: "Type",
          priority: "Priorité",
          status: "Statut",
          last_update: "Mise à jour"
        },
        no_results: "Aucun ticket trouvé.",
        ticket_prefix: "Ticket #",
        status_label: "Statut:",
        load_error: "Impossible de charger le ticket.",
        loading: "Chargement du ticket...",
        not_found: "Ticket non trouvé.",
        reply_placeholder: "Réponse de l",
        sending: "Envoi...",
        send_reply: "Envoyer la réponse",
        back_to_list: "← Retour à la liste des tickets",
        client_info: "Informations Demandeur",
        view_profile: "Voir profil",
        guest_title: "Invité (Non inscrit)",
        name_label: "Nom:",
        email_label: "Email:",
        source_label: "Source:",
        created_label: "Créé le:",
        configuration: "Configuration",
        priority_label: "Priorité",
        type_label: "Type de demande",
        support_name: "Support Services",
        guest_name: "Invité",
        conversations: {
          no_conversations: "Aucune conversation",
          no_conversations_desc: "Ce client n\\",
          no_conversations_filter: "Aucune conversation avec ce statut.",
          create_new: "Nouvelle conversation",
          you: "Vous",
          created: "Créé",
          create_desc: "Fonctionnalité à implémenter - création de ticket depuis mobile admin"
        },
        messages: {
          attachment: "Pièce jointe",
          no_messages: "Aucun message dans cette conversation",
          reply_placeholder: "Réponse...",
          change_status: "Changer le statut"
        },
        clients: {
          title: "Clients avec Tickets",
          search_placeholder: "Nom, valeur...",
          no_clients: "Aucun client trouvé",
          no_results_search: "Aucun résultat pour votre recherche.",
          no_results: "Aucun ticket trouvé.",
          active: "actif(s)",
          last_activity: "Dernière activité",
          total_tickets: "ticket(s)",
          closed: "fermé(s)"
        }
      },
      deposits: {
        title: "Gestion des Dépôts",
        pending: "En attente",
        all: "Tous",
        allMethods: "Toutes méthodes",
        filterByMethod: "Filtrer par méthode",
        client: "Client",
        amount: "Montant",
        method: "Méthode",
        date: "Date",
        confirm_refuse: "Voulez-vous vraiment refuser ce dépôt ?",
        confirm_validate: "Confirmer la validation du dépôt de",
        proof: "Voir la preuve",
        validate: "Valider",
        refuse: "Refuser",
        proof_viewer: "Preuve de paiement",
        code_viewer: "Code de transaction",
        transactionRef: "Référence transaction",
        mandatType: "Type de mandat",
        clientName: "Nom du client",
      },
      stock: {
        title: "Gestion des Stocks",
        sync_btn: "Synchro Statuts",
        digital_tab: "Stock Numérique",
        physical_tab: "Stock Physique",
        import_title: "Importer des Codes",
        import_desc: "Importer des codes par CSV (Format: Code;Série)",
        product: "Produit",
        choose: "Choisir...",
        file_csv: "Fichier CSV",
        import: "Importer",
        state_title: "État du Stock Numérique",
        available: "Dispo.",
        sold: "Vendu",
        status_base: "Statut (Base)",
        inventory_title: "Inventaire Physique / Traitement",
        history: "Historique",
        adjust: "Ajuster",
        movement_type: "Type de Mouvement",
        reason: "Raison",
        sync_statuses: "Synchroniser les statuts",
        digital_stock: "Stock numérique",
        physical_stock: "Stock physique",
        import_codes: "Importation",
        digital_stock_status: "État Stock Digital",
        product_header: "Produit",
        available_header: "Dispo.",
        sold_header: "Vendu",
        status_base_header: "Statut",
        no_instant_product: "Aucun produit code instantané",
        import_instant_only: "L'import est réservé aux produits « Code instantané ».",
        instant_codes: "Code instantané",
        manual_digital: "Gestion manuelle (code différé)",
        set_sold_out: "Mettre Épuisé",
        set_on_sale: "Mettre En vente"
      },
      users: {
        title: "Gestion des utilisateurs",
        add: "Ajouter Client",
        search: "Rechercher...",
        filter_status: "Filtrer Statut",
        all: "Tous",
        details: "Détails",
        suspended_btn: "Suspendre",
        active_btn: "Activer",
        activity: "Activité",
        registered: "Inscrit le",
        detail: {
          save_success: "Profil mis à jour.",
          status_success: "Statut mis à jour.",
          confirm_reset: "Envoyer un lien de réinitialisation à {{email}} ?",
          reset_sent: "Email de réinitialisation envoyé.",
          delete_title: "Supprimer le client {{name}} ?",
          checking_deps: "Vérification des données...",
          deps_warning: "Attention : Ce client possède :",
          tabs: {
            orders: "Commandes",
            deposits: "Dépôts",
            tickets: "Tickets"
          },
          reviews: "Avis",
          deps_loss: "La suppression effacera tout l",
          no_deps: "Aucune donnée liée. Suppression sûre.",
          force_delete: "Supprimer Tout (Forcer)",
          deleting: "Suppression...",
          balance_modal: {
            title: "Gestion du Solde",
            current: "Solde actuel :",
            operation: "Opération",
            add: "Ajouter",
            subtract: "Soustraire",
            set: "Définir",
            new_balance: "Nouveau Solde",
            amount: "Montant",
            success: "Solde mis à jour : {{amount}}"
          },
          loading: "Chargement...",
          not_found: "Client non trouvé.",
          edit_profile: "Modifier Profil",
          personal_info: "Informations Personnelles",
          account_management: "Gestion du Compte",
          account_status: "Statut du Compte",
          manage_balance: "Gérer le Solde",
          reset_password: "Réinit. Mot de Passe",
          delete_client: "Supprimer Client"
        }
      },
      settings: {
        title: "Réglages Généraux",
        app_prefs: "Préférences Application",
        interface_theme: "Thème Interface",
        sticky_bar: "Barre de filtre fixe",
        language: "Langue"
      },
      deliverySettings: {
        title: "Paramètres de Livraison",
        baseFeeLabel: "Frais de livraison de base",
        baseFeeHint: "Montant par défaut pour la livraison à domicile. S'applique à toutes les régions sauf surcharge spécifique.",
        stampFeeLabel: "Timbre fiscal",
        stampFeeHint: "Timbre fiscal de 0,100 TND appliqué par commande contenant une livraison à domicile.",
        saveBtn: "Enregistrer",
        saving: "Enregistrement...",
        saved: "Paramètres enregistrés avec succès.",
        error: "Erreur lors de l'enregistrement."
      },
      orders: {
        title: "Gestion des Commandes",
        duplicate: "Dupliquer",
        delete: "Supprimer",
        details: "Détails",
        confirm_delete: "Supprimer cette commande ?",
        confirm_delete_bulk: "Supprimer {{count}} commande(s) ? Cette action est irréversible.",
        confirm_duplicate: "Dupliquer cette commande ?",
        client: "Client",
        total: "Total",
        payment: "Paiement",
        status: "Statut",
        ref_trans: "Réf Trans",
        transactionRef: "Référence transaction",
        clientName: "Nom du client",
        mandatNumber: "Numéro du mandat",
        proof: "Preuve de paiement",
        openProof: "Ouvrir la preuve",
        paymentDetail: "Détail du paiement",
        generate_invoice: "Générer Facture",
        generate_bl: "Générer BL",
        view_invoice: "Voir Facture",
        ref: "Réf",
        deleted_one: "Commande supprimée.",
        deleted_bulk: "{{count}} commande(s) supprimée(s).",
        select_all: "Tout sélectionner",
        clear_selection: "Tout désélectionner",
        delete_selection: "Supprimer la sélection",
        selected_one: "commande sélectionnée",
        selected_bulk: "commandes sélectionnées"
      }
    },
    delivery: {
      instructions: {
        code_instantane: "Code affiché immédiatement dans votre compte.",
        mail_compte_code: "Compte + Code envoyés par email.",
        mail_code: "Code envoyé par email.",
        mail_acces: "Identifiants d",
        mail_licence: "Licence envoyée par email.",
        traitement_lien: "Une fois votre commande validée, le traitement se fera à distance et vous recevrez la confirmation par email.",
        livraison_domicile: "Livraison physique à votre adresse.",
        default: "Mode de livraison standard."
      },
      methods: {
        code_instantane: "Code instantané",
        mail_compte_code: "Compte (Mail)",
        mail_code: "Code (Mail)",
        mail_acces: "Accès (Mail)",
        mail_licence: "Licence (Mail)",
        traitement_lien: "Service / Traitement",
        livraison_domicile: "Livraison Domicile"
      }
    },
    payment: {
      methods: {
        solde_interne: "Solde Interne",
        carte_bancaire: "Carte Bancaire",
        flouci: "Flouci",
        d17: "D17",
        izi_pay: "IZI Pay",
        virement: "Virement"
      }
    },
    payment_methods: {
      solde: "Paiement par solde",
      mandat: "Mandat",
      carte: "Paiement par carte",
      solde_interne: "Solde Interne",
      livraison: "Paiement à la livraison",
      portefeuille: "Portefeuille mobile",
      p2p: "Transfert vers identifiant (type dépôt)",
      postal: "Mandat postal",
      mandat_postal: "Mandat postal (code admin)",
      mandat_bancaire: "Mandat bancaire (ex. MoneyGram)",
      carte_bancaire: "Carte Bancaire",
      flouci: "Flouci",
      d17: "D17",
      izi_pay: "IZI Pay",
      virement: "Virement",
      virement_bancaire: "Virement bancaire (code admin)",
      virement_postal: "Virement postal (CCP / compte postal)"
    },
    delivery_instructions: {
      code_instantane: "Code Instantané",
      mail_compte_code: "Compte + Code (Email)",
      mail_code: "Code (Email)",
      mail_acces: "Accès (Email)",
      mail_licence: "Licence (Email)",
      traitement_lien: "Traitement à distance",
      livraison_domicile: "Livraison à domicile"
    },
    ticket_types: {
      SUPPORT: "Support",
      COMMANDE: "Commande",
      CONTACT: "Contact"
    },
    product_names: {
    },
    categories: {
      Recharge: "Recharge Mobile",
      "Recharge Mobile": "Recharge Mobile",
      "Documents personnalisés": "Documents personnalisés",
      "Paiement International": "Paiement International",
      Jeux: "Jeux Vidéo",
      Streaming: "Streaming & TV",
      Logiciels: "Logiciels & VPN",
      Paiement: "Cartes de Paiement",
      Divers: "Divers",
      Abonnements: "Abonnements"
    },
    categories_desc: {
      Abonnements: "Services de streaming, jeux et plus encore."
    },
    subcategories: {
      Ooredoo: "Ooredoo",
      Orange: "Orange",
      Streaming: "Streaming",
      Gaming: "Gaming",
      "Conception graphisque": "Conception graphique",
      "Tunisie Télécom": "Tunisie Télécom",
      "Paiement Internationale": "Paiement international",
      "Paiement Nationale": "Paiement national",
      "Applications & Logiciels": "Applications & Logiciels",
      "Documents éducatifs": "Documents éducatifs",
      "Certificats & Attestations": "Certificats & Attestations",
      "Documents administratifs": "Documents administratifs",
      "Paiement en ligne": "Paiement en ligne",
      "Cours en ligne": "Cours en ligne",
      "Outils de productivité": "Outils de productivité"
    },
    footer: {
      brand_desc: "Votre partenaire de confiance pour tous vos services numériques. Recharge mobile, abonnements, et plus encore.",
      rating: {
        excellent: "Excellent",
        based_on: "basé sur"
      },
      sections: {
        navigation: "Navigation",
        legal: "Légal",
        newsletter: "Newsletter"
      },
      links: {
        faq: "FAQ",
        terms: "Conditions Générales",
        privacy: "Politique de Confidentialité",
        refund: "Politique de Remboursement",
        delivery: "Politique de Livraison",
        legal_notice: "Mentions Légales",
        cookies: "Politique de Cookies",
        terms_desc: "Consultez nos conditions d\\",
        privacy_desc: "Découvrez comment nous protégeons vos données personnelles et vos droits en matière de confidentialité",
        refund_desc: "Informations détaillées sur les conditions de remboursement, garanties et procédures de retour",
        delivery_desc: "Délais de livraison, frais, zones de livraison et suivi de commande",
        legal_notice_desc: "Informations légales et réglementaires sur l\\",
        cookies_desc: "Informations sur l\\",
        rate_limiting: "Limites d'utilisation et sécurité",
        rate_limiting_desc: "Politiques de limites de requêtes (OTP, inscription) et blocages temporaires.",
        faq_desc: "Questions fréquemment posées et réponses sur nos services"
      },
      newsletter: {
        desc: "Restez informé de nos dernières actualités",
        placeholder: "Votre email",
        btn: {
          subscribe: "S'abonner",
          loading: "Envoi...",
          success: "Abonné !"
        },
        error: "Erreur lors de l",
        disclaimer: "Nous respectons votre vie privée. Désabonnement possible à tout moment."
      },
      download_app: {
        title: "Télécharger l'application",
        cta: "Obtenir sur Google Play",
        apple: "Télécharger sur l'App Store"
      },
      copyright: "Tous droits réservés",
      legal: {
        view_all: "Consultez tous nos documents politiques"
      }
    },
    about: {
      title: "À Propos de",
      subtitle: "Votre partenaire de confiance pour une vie numérique simplifiée en Tunisie.",
      mission_title: "Notre Mission",
      mission_desc: "Chez EServices.tn, notre mission est de simplifier la vie numérique des utilisateurs tunisiens. Nous avons créé une plateforme centralisée et intuitive pour vous offrir un accès instantané à une large gamme de services essentiels, allant des recharges téléphoniques aux abonnements numériques, en passant par la création de documents personnalisés. Nous nous engageons à rendre chaque interaction aussi fluide et agréable que possible.",
      values_title: "Nos Valeurs",
      values: {
        reliability: {
          title: "Fiabilité",
          desc: "Nous garantissons des transactions sécurisées et des services livrés à temps, à chaque fois."
        },
        speed: {
          title: "Rapidité",
          desc: "Notre plateforme est optimisée pour vous offrir une expérience ultra-rapide, de la commande à la livraison."
        },
        accessibility: {
          title: "Accessibilité",
          desc: "Nous concevons nos services pour être simples et accessibles à tous, où que vous soyez en Tunisie."
        },
        innovation: {
          title: "Innovation",
          desc: "Nous cherchons constamment à améliorer et à élargir notre offre pour répondre aux besoins changeants de nos clients."
        }
      },
      quote: "Chez EServices.tn, nous plaçons la satisfaction de nos clients au cœur de tout ce que nous faisons."
    },
    AboutPage: {
      header: {
        logo: "eServices"
      },
      team: {
        imageAlt: "Notre Équipe"
      },
      mission: {
        quote: "Innover pour rendre le digital accessible à chaque tunisien."
      }
    },
    MobileAboutPage: {
      header: {
        logo: "eServices"
      },
      team: {
        imageAlt: "Notre Équipe"
      },
      mission: {
        quote: "Innover pour rendre le digital accessible à chaque tunisien."
      }
    },
    MobileSecurity: {
      header: {
        title: "Sécurité"
      },
      password: {
        changeTitle: "Changer le mot de passe",
        changeDesc: "Mettez à jour votre mot de passe régulièrement",
        cancel: "Annuler",
        edit: "Modifier",
        currentPassword: "Mot de passe actuel",
        newPassword: "Nouveau mot de passe",
        confirmPassword: "Confirmer le mot de passe",
        placeholder: "••••••••",
        hide: "Masquer",
        show: "Afficher",
        minChars: "Minimum 6 caractères",
        forgotPassword: "Mot de passe oublié ?",
        updateButton: "Mettre à jour le mot de passe",
        changingInProgress: "Changement en cours...",
        errorAllRequired: "Tous les champs sont requis",
        errorMinLength: "Le nouveau mot de passe doit contenir au moins 6 caractères",
        errorMismatch: "Les mots de passe ne correspondent pas",
        errorSameAsOld: "Le nouveau mot de passe doit être différent de l'ancien",
        errorCurrentIncorrect: "Mot de passe actuel incorrect",
        errorUpdate: "Erreur lors du changement de mot de passe",
        successUpdated: "Mot de passe modifié avec succès"
      },
      tips: {
        title: "Conseils de sécurité",
        item1: "Utilisez un mot de passe fort et unique",
        item2: "Changez votre mot de passe régulièrement",
        item3: "Ne partagez jamais votre mot de passe"
      },
      twoFa: {
        title: "Authentification à deux facteurs",
        disabledDesc: "Protection supplémentaire pour votre compte",
        enableButton: "Activer la 2FA",
        enabledLabel: "Protection activée",
        enabledOn: "Activée le",
        enabledBadge: "Activée",
        enabledMessage: "Votre compte est protégé par une authentification à deux facteurs. Vous devrez entrer un code de vérification à chaque connexion.",
        actionsLabel: "Actions",
        regenerateCodes: "Régénérer les codes de récupération",
        regenerateCodesDesc: "Générer de nouveaux codes de secours",
        disableButton: "Désactiver la 2FA",
        disableButtonDesc: "Retirer la protection supplémentaire",
        setup: {
          title: "Configuration Google Authenticator",
          step1Title: "Étape 1 : Ajouter à Google Authenticator",
          step1_1: "Ouvrez Google Authenticator sur votre téléphone",
          step1_2: "Appuyez sur \"+\" pour ajouter un compte",
          step1_3: "Sélectionnez \"Saisir une clé de configuration\"",
          step2Title: "Étape 2 : Entrer la clé secrète",
          secretWarning: "IMPORTANT : Entrez la clé SANS tirets, espaces ou séparateurs",
          secretNote: "Type : Basé sur le temps | Algorithme : SHA1",
          step3Title: "Étape 3 : Vérifier le code",
          codePlaceholder: "000000"
        },
        verify: "Vérifier et activer",
        recoveryCodes: {
          title: "Codes de récupération",
          warning: "IMPORTANT : Enregistrez ces codes dans un endroit sûr. Ils ne seront plus affichés.",
          saved: "J'ai enregistré les codes"
        },
        disable: {
          title: "Désactiver la 2FA",
          warning: "Pour des raisons de sécurité, veuillez confirmer votre mot de passe pour désactiver la 2FA.",
          success: "2FA désactivée avec succès",
          inProgress: "Désactivation...",
          confirm: "Désactiver"
        },
        errorGenerate: "Erreur lors de la génération du secret",
        errorCode6Digits: "Veuillez entrer un code à 6 chiffres",
        errorCodeIncorrect: "Code incorrect. Veuillez réessayer.",
        errorVerify: "Erreur lors de la vérification du code",
        errorPasswordRequired: "Veuillez entrer votre mot de passe",
        errorDisable: "Erreur lors de la désactivation",
        errorRegenerate: "Erreur lors de la régénération des codes"
      }
    },
    MobileFavorites: {
      header: {
        title: "Mes Favoris",
        subtitle: "Retrouvez les articles que vous avez aimés."
      },
      state: {
        loading: "Chargement..."
      },
      empty: {
        title: "Aucun favori",
        description: "Parcourez le catalogue et ajoutez des articles à vos coups de cœur."
      }
    },
    MobileManageDeposits: {
      header: {
        title: "Gestion des Dépôts"
      },
      confirm: {
        refuse: "Êtes-vous sûr de vouloir refuser ce dépôt ?",
        validate: "Valider ce dépôt de {{amount}} ?"
      },
      filters: {
        pending: "En attente",
        validated: "Validés",
        refused: "Refusés",
        all: "Tous"
      },
      card: {
        amount: "Montant",
        method: "Méthode",
        proofLabel: "Preuve de paiement",
        viewImage: "Voir l'image",
        viewCode: "Voir le code",
        proofAlt: "Preuve de dépôt",
        imageUnavailable: "Image non disponible",
        clickToViewCode: "Cliquez pour voir le code complet"
      },
      actions: {
        validate: "Valider",
        refuse: "Refuser"
      },
      empty: {
        title: "Aucun dépôt",
        pending: "Aucun dépôt en attente de validation.",
        noMatch: "Aucun dépôt trouvé pour ce filtre."
      },
      modal: {
        proofTitle: "Preuve de paiement",
        codeTitle: "Code de transaction",
        openFullScreen: "Ouvrir en plein écran",
        copied: "Copié",
        copy: "Copier",
        close: "Fermer"
      },
      error: "Erreur"
    },
    Wallet: {
      card: {
        revenue: "Chiffre d'Affaires",
        myBalance: "Mon Solde",
        recharge: "Réapprovisionner"
      },
      stats: {
        depositsThisMonth: "Dépôts ce mois",
        spendingThisMonth: "Dépenses ce mois"
      },
      section: {
        depositManagement: "Gestion des dépôts",
        transactionHistory: "Historique des transactions",
        pendingCount: "{{count}} en attente"
      },
      list: {
        rechargeVia: "Recharge via {{method}}"
      },
      empty: {
        noDeposits: "Aucun dépôt trouvé"
      },
      modal: {
        stepAmount: "Montant du dépôt",
        stepMethod: "Méthode de paiement",
        stepInstructions: "Finaliser le dépôt",
        customAmount: "Montant personnalisé",
        placeholderAmount: "0.000",
        continue: "Continuer",
        chooseMethod: "Choisissez une méthode",
        submitting: "Traitement...",
        submitDeposit: "Soumettre le dépôt"
      },
      instructions: {
        title: "Instructions de Paiement",
        portefeuilleIntro: "Ouvrez l’application indiquée par le vendeur et envoyez {{amount}} TND vers l’identifiant ci-dessous.",
        flouciStep1: "Ouvrez l'application Flouci et envoyez {{amount}} TND",
        d17Step1: "Ouvrez l'application D17 et envoyez le montant",
        iziStep1: "Ouvrez l'application IZI Pay et envoyez {{amount}} TND",
        transactionIdLabel: "2. Mentionner l'Identifiant de l'opération",
        transactionIdPlaceholder: "ID de transaction",
        bankTransferTitle: "Virement bancaire",
        bankTransferStep1: "1. Effectuez un virement de {{amount}} TND vers l'un des comptes ci-dessous :",
        rib: "RIB :",
        iban: "IBAN :",
        accountHolder: "Titulaire :",
        proofLabel: "2. Preuve de Paiement (uploader un fichier de preuve)"
      },
      success: {
        depositSubmitted: "Dépôt soumis avec succès !"
      },
      error: {
        submitError: "Erreur lors de la soumission. Veuillez réessayer."
      },
      methods: {
        portefeuille: "Portefeuille mobile",
        flouci: "Flouci",
        d17: "D17",
        izi_pay: "IZI Pay",
        virement: "Virement Bancaire"
      }
    },
    hardcoded: {
      notre_quipe: "Notre Équipe",
      profil_administrateur: "Profil Administrateur",
      avatar: "Avatar",
      chargement_du_profil_: "Chargement du profil...",
      pr_nom: "Prénom",
      email: "Email",
      t_l_phone: "Téléphone",
      adresse: "Adresse",
      preuve: "Preuve",
      scanner_le_stockage: "Scanner le stockage",
      sync_: "Sync?",
      invit_: "INVITÉ",
      nom: "Nom",
      mot_de_passe: "Mot de passe",
      activit_: "Activité",
      actions: "Actions",
      chargement_: "Chargement...",
      aucun_client_trouv_: "Aucun client trouvé.",
      analyse_des_: "Analyse des بيانات في دور المعالجة...",
      forcer_la_suppression_effacera_d_finitivement_tout: "Forcer la suppression effacera définitivement tout l'historique lié.",
      aucune_donn_e_li_e_trouv_e_la_suppression_est_sans: "Aucune donnée liée trouvée. La suppression est sans risque.",
      nouveau_client: "Nouveau client",
      annuler: "Annuler",
      cr_er_le_compte: "Créer le compte",
      logo_light: "Logo Light",
      logo_dark: "Logo Dark",
      logo_mode_clair_: "Logo (Mode Clair)",
      ce_logo_s_affichera_sur_les_fonds_clairs_ex_th_me_: "Ce logo s'affichera sur les fonds clairs (ex: Thème Light).",
      logo_mode_sombre_: "Logo (Mode Sombre)",
      ce_logo_s_affichera_sur_les_fonds_sombres_ex_th_me: "Ce logo s'affichera sur les fonds sombres (ex: Thème Dark).",
      utiliser_le_th_me_sombre: "Utiliser le thème sombre",
      garder_la_barre_de_recherche_visible_lors_du_d_fil: "Garder la barre de recherche visible lors du défilement (Services).",
      activer_la_barre_fixe: "Activer la barre fixe",
      choisir_la_langue_de_l_interface_: "Choisir la langue de l'interface.",
      fran_ais: "Français",
      english: "English",
      inscription: "Inscription",
      utilisateur_introuvable_: "Utilisateur introuvable.",
      enregistrer: "Enregistrer",
      solde: "Solde",
      actions_rapides: "Actions rapides",
      supprimer_client: "Supprimer Client",
      analyse_de_l_historique_: "Analyse de l'historique...",
      forcer_la_suppression_effacera_tout_l_historique_d: "Forcer la suppression effacera tout l'historique de manière définitive.",
      aucune_donn_e_li_e_trouv_e_suppression_s_curis_e_: "Aucune donnée liée trouvée. Suppression sécurisée.",
      g_rer_le_solde: "Gérer le Solde",
      valider: "Valider",
      offerts: "Offerts",
      ttc_livraison_comprise: "TTC / Livraison comprise",
      paiement_100_s_curis_: "Paiement 100% sécurisé",
      validation_sous_10_30_minutes: "Validation sous 10-30 minutes",
      images_pdf_max_5mb_: "Images, PDF (MAX 5MB)",
      articles_livraison: "Articles & Livraison",
      codes_assign_s_: "Codes assignés :",
      documents_administratifs: "Documents administratifs",
      facture_officielle: "Facture officielle",
      barre_de_filtre_fixe: "Barre de filtre fixe",
      actualiser_la_liste: "Actualiser la liste",
      livraison_automatique_en_attente: "Livraison automatique en attente",
      v_rifier_mes_commandes: "Vérifier mes commandes",
      ouvrir_un_ticket_d_aide: "Ouvrir un ticket d'aide",
      passer_une_commande: "Passer une Commande",
      cat_gories: "Catégories",
      votre_commande: "Votre Commande",
      votre_panier_est_vide_: "Votre panier est vide.",
      s_lectionnez_une_cat_gorie_pour_commencer_: "Sélectionnez une catégorie pour commencer.",
      total: "Total",
      mode_de_paiement: "Mode de paiement",
      note_: "Note :",
      choisir_une_m_thode_: "Choisir une méthode...",
      veuillez_uploader_une_capture_d_cran_ou_un_re_u_po: "Veuillez uploader une capture d'écran ou un reçu pour valider la transaction.",
      mon_profil: "Mon Profil",
      informations_personnelles: "Informations Personnelles",
      changer: "Changer",
      votre_nom: "Votre nom",
      probl_me_commande: "Problème Commande",
      email_de_contact_optionnel_: "Email de contact (optionnel)",
      nom_de_contact_optionnel_: "Nom de contact (optionnel)",
      ticket_non_trouv_: "Ticket non trouvé.",
      lien_de_r_cup_ration_s_curis_: "Lien de récupération sécurisé",
      email_envoy_instantan_ment: "Email envoyé instantanément",
      envoi_en_cours_: "Envoi en cours...",
      envoyer_le_lien_de_r_cup_ration: "Envoyer le lien de récupération",
      chrome_: "Chrome :",
      firefox_: "Firefox :",
      safari_: "Safari :",
      edge_: "Edge :",
      a_cookie_is_a_small_text_file_stored_on_your_devic: "A cookie is a small text file stored on your device (computer, tablet, smartphone) when you visit a website. Cookies allow the site to remember your actions and preferences over a period of time.",
      enhance_your_user_experience_and_personalize_the_i: "Enhance your user experience and personalize the interface",
      ensure_the_technical_functioning_of_the_site_login: "Ensure the technical functioning of the site (login, cart management, transaction security)",
      analyze_site_traffic_and_audience_to_optimize_our_: "Analyze site traffic and audience to optimize our services",
      remember_your_preferences_language_dark_mode_displ: "Remember your preferences (language, dark mode, display settings)",
      protect_the_platform_against_fraudulent_activities: "Protect the platform against fraudulent activities",
      tunisian_law_no_2018_20: "Tunisian Law No. 2018-20",
      essential_cookies_technical_: "Essential Cookies (Technical)",
      indispensable_for_platform_functionality_: "Indispensable for platform functionality:",
      user_authentication_and_session_management: "User authentication and session management",
      maintaining_account_and_transaction_security: "Maintaining account and transaction security",
      preserving_items_in_your_cart_between_sessions: "Preserving items in your cart between sessions",
      remembering_your_privacy_preferences: "Remembering your privacy preferences",
      these_cookies_cannot_be_disabled_via_our_interface: "These cookies cannot be disabled via our interface.",
      analytical_cookies_statistical_: "Analytical Cookies (Statistical)",
      we_use_internal_analytics_tools_to_: "We use internal analytics tools to:",
      measure_audience_and_site_performance: "Measure audience and site performance",
      understand_how_users_interact_with_the_platform: "Understand how users interact with the platform",
      detect_and_resolve_technical_issues: "Detect and resolve technical issues",
      continuously_improve_user_experience: "Continuously improve user experience",
      these_cookies_are_anonymized_and_do_not_allow_pers: "These cookies are anonymized and do not allow personal identification.",
      preference_cookies: "Preference Cookies",
      they_remember_your_personal_choices_: "They remember your personal choices:",
      interface_language_french_arabic_english_: "Interface language (French, Arabic, English)",
      display_mode_dark_light_: "Display mode (dark/light)",
      regional_settings: "Regional settings",
      notification_preferences: "Notification preferences",
      some_services_integrated_into_eservices_may_deposi: "Some services integrated into eServices may deposit their own cookies:",
      payment_services_: "Payment Services:",
      analytics_tools_: "Analytics Tools:",
      transactional_email_services_: "Transactional Email Services:",
      we_carefully_select_our_partners_and_ensure_they_c: "We carefully select our partners and ensure they comply with data protection standards. These cookies are subject to the privacy policies of their issuers.",
      you_have_control_over_cookie_usage_: "You have control over cookie usage:",
      via_our_consent_banner: "Via Our Consent Banner",
      during_your_first_visit_a_banner_allows_you_to_acc: "During your first visit, a banner allows you to accept or refuse non-essential cookies. You can modify your choices at any time by clicking the \"Manage Cookies\" link at the bottom of the page.",
      via_your_browser_settings: "Via Your Browser Settings",
      you_can_configure_your_browser_to_: "You can configure your browser to:",
      refuse_all_cookies: "Refuse all cookies",
      accept_only_essential_cookies: "Accept only essential cookies",
      be_notified_each_time_a_cookie_is_deposited: "Be notified each time a cookie is deposited",
      automatically_delete_cookies_upon_closing: "Automatically delete cookies upon closing",
      the_procedure_varies_by_browser_: "The procedure varies by browser:",
      consequences_of_refusal: "Consequences of Refusal",
      if_you_disable_cookies_: "If you disable cookies:",
      you_will_need_to_log_in_on_each_visit: "You will need to log in on each visit",
      your_cart_will_not_be_saved_between_sessions: "Your cart will not be saved between sessions",
      your_preferences_language_dark_mode_will_not_be_re: "Your preferences (language, dark mode) will not be remembered",
      some_features_may_be_limited: "Some features may be limited",
      security_of_certain_transactions_may_be_reduced: "Security of certain transactions may be reduced",
      cookies_have_varying_lifespans_: "Cookies have varying lifespans:",
      session_cookies_: "Session Cookies:",
      persistent_cookies_: "Persistent Cookies:",
      authentication_cookies_: "Authentication Cookies:",
      analytical_cookies_: "Analytical Cookies:",
      privacy_policy: "Privacy Policy",
      data_collected_via_cookies_is_processed_securely: "Data collected via cookies is processed securely",
      we_do_not_share_your_browsing_data_for_commercial_: "We do not share your browsing data for commercial purposes without your consent",
      analytical_cookies_are_anonymized: "Analytical cookies are anonymized",
      we_retain_technical_logs_related_to_cookies_for_a_: "We retain technical logs related to cookies for a maximum of 1 year",
      you_have_the_right_to_access_rectify_and_object_to: "You have the right to access, rectify, and object to the processing of your data",
      we_may_update_this_cookie_policy_to_reflect_: "We may update this Cookie Policy to reflect:",
      technical_evolution_of_the_platform: "Technical evolution of the platform",
      tunisian_or_international_regulatory_changes: "Tunisian or international regulatory changes",
      addition_of_new_features_or_services: "Addition of new features or services",
      changes_will_be_published_on_this_page_with_the_up: "Changes will be published on this page with the update date. In case of significant changes, we will inform you via email or platform notification.",
      for_any_questions_regarding_our_use_of_cookies_or_: "For any questions regarding our use of cookies or to exercise your rights:",
      dpo_email_: "DPO Email:",
      support_tickets_: "Support Tickets:",
      postal_address_: "Postal Address:",
      national_authority_for_personal_data_protection_in: "National Authority for Personal Data Protection (INPDP)",
      last_updated_: "Last Updated:",
      version_: "Version :",
      applicable_to_: "Applicable to:",
      my_codes: "My Codes",
      reveal: "Reveal",
      article_1_scope: "ARTICLE 1 - SCOPE",
      digital_services: "Digital Services",
      article_2_digital_services_top_ups_codes_subscript: "ARTICLE 2 - DIGITAL SERVICES (Top-ups, Codes, Subscriptions)",
      mobile_top_up_: "Mobile Top-up:",
      digital_codes_gaming_streaming_licenses_: "Digital Codes (Gaming, Streaming, Licenses):",
      masked_code_: "Masked Code:",
      pdf_export_: "PDF Export:",
      article_3_customized_and_physical_products: "ARTICLE 3 - CUSTOMIZED AND PHYSICAL PRODUCTS",
      processing_: "Processing:",
      shipped_: "Shipped:",
      delivered_: "Delivered:",
      preparation_: "Preparation:",
      transport_: "Transport :",
      article_4_responsibilities: "ARTICLE 4 - RESPONSIBILITIES",
      risk_on_physical_products_: "Risk on Physical Products:",
      digital_service_not_received_: "Digital Service Not Received:",
      customization_files_: "Customization Files:",
      article_5_delivery_address: "ARTICLE 5 - DELIVERY ADDRESS",
      article_6_right_of_withdrawal: "ARTICLE 6 - RIGHT OF WITHDRAWAL",
      digital_services_provided_immediately_after_the_or: "Digital services provided immediately after the order (top-ups, delivered codes)",
      goods_made_to_the_customer_s_specifications_or_cle: "Goods made to the Customer's specifications or clearly personalized",
      perishable_products_or_products_with_a_limited_val: "Perishable products or products with a limited validity date",
      refund_policy: "Refund Policy",
      response_time_: "Response time:",
      publishing_company: "Publishing Company",
      company_name_: "Company Name:",
      legal_form_: "Legal Form:",
      share_capital_: "Share capital:",
      registration_: "Registration:",
      vat_number_: "VAT number:",
      headquarters: "Headquarters",
      address_: "Address:",
      location_: "Location:",
      management_and_publication: "Management and Publication",
      publication_director_: "Publication director:",
      editorial_manager_: "Editorial Manager:",
      data_protection_officer_: "Data Protection Officer:",
      technical_and_commercial_support: "Technical and Commercial Support",
      email_: "Email :",
      phone_: "Phone:",
      business_hours_: "Business Hours:",
      monday_to_friday_9_am_6_pm_tunisian_local_time_: "Monday to Friday, 9 AM - 6 PM (Tunisian local time)",
      recommendation_: "Recommendation:",
      legal_and_compliance_services: "Legal and Compliance Services",
      legal_email_: "Legal Email:",
      data_protection_: "Data Protection:",
      dispute_service_: "Dispute Service:",
      main_infrastructure: "Main Infrastructure",
      database_and_authentication: "Database and Authentication",
      provider_: "Provider:",
      security_: "Security:",
      certifications_: "Certifications :",
      complementary_services: "Complementary Services",
      transactional_email_: "Transactional Email:",
      audience_analysis_: "Audience Analysis:",
      monitoring_: "Monitoring :",
      cdn_: "CDN :",
      availability_and_maintenance: "Availability and Maintenance",
      guaranteed_uptime_rate: "Guaranteed uptime rate",
      monitoring_and_technical_support: "Monitoring and technical support",
      certified_tls_1_3_encryption: "Certified TLS 1.3 encryption",
      trademarks_and_logos: "Trademarks and Logos",
      registration_with_innorpi_national_institute_of_st: "Registration with INNORPI (National Institute of Standardization and Industrial Property)",
      international_protection_via_the_madrid_system: "International protection via the Madrid System",
      any_reproduction_without_express_authorization_is_: "Any reproduction without express authorization is prohibited",
      copyright: "Copyright",
      source_code_and_algorithms: "Source code and algorithms",
      design_and_user_interface: "Design and user interface",
      technical_documentation_and_editorial_content: "Technical documentation and editorial content",
      database_sui_generis_protection_: "Database (sui generis protection)",
      exception_: "Exception :",
      usage_licenses: "Usage Licenses",
      allowed: "Allowed",
      personal_and_non_commercial_use: "Personal and non-commercial use",
      access_via_browser_or_official_application: "Access via browser or official application",
      creation_of_a_single_account_per_person: "Creation of a single account per person",
      prohibited: "Prohibited",
      reverse_engineering_or_decompilation: "Reverse engineering or decompilation",
      unauthorized_commercial_use: "Unauthorized commercial use",
      creation_of_multiple_accounts: "Creation of multiple accounts",
      mass_data_extraction: "Mass data extraction",
      domain: "Domain",
      legal_framework: "Legal Framework",
      compliance: "Compliance",
      reference: "Reference",
      e_commerce: "E-commerce",
      tunisian_law_no_2000_83: "Tunisian Law No. 2000-83",
      full: "Full",
      articles_54_55: "Articles 54-55",
      data_protection: "Data Protection",
      organic_law_no_2018_20: "Organic Law No. 2018-20",
      inpdp_declaration: "INPDP Declaration",
      file_no_number_: "File No. [Number]",
      payment_services: "Payment Services",
      bct_regulation: "BCT Regulation",
      compliant_with_practices: "Compliant with practices",
      circular_xx_2022: "Circular XX/2022",
      consumption: "Consumption",
      consumer_protection_code: "Consumer Protection Code",
      respect_of_deadlines: "Respect of deadlines",
      articles_35_42: "Articles 35-42",
      taxation: "Taxation",
      customs_and_tax_code: "Customs and Tax Code",
      vat_collected: "VAT collected",
      vat_no_vat_number_: "VAT No: [VAT Number]",
      law_no_94_36: "Law No. 94-36",
      partner_licenses: "Partner licenses",
      innorpi: "INNORPI",
      regulatory_authorities: "Regulatory Authorities",
      inpdp: "INPDP",
      national_authority_for_the_protection_of_personal_: "National Authority for the Protection of Personal Data",
      central_bank_of_tunisia: "Central Bank of Tunisia",
      national_institute_of_standardization_and_industri: "National Institute of Standardization and Industrial Property",
      intermediary_role: "Intermediary Role",
      important_: "Important :",
      warranty_exclusions: "Warranty Exclusions",
      digital_services_: "Digital Services:",
      service_interruptions_: "Service Interruptions:",
      user_data_: "User Data:",
      fraudulent_use_: "Fraudulent Use:",
      liability_cap: "Liability Cap",
      order_amount: "Order Amount",
      cap_for_digital_services: "Cap for digital services",
      last_deposit: "Last Deposit",
      cap_for_processing_errors: "Cap for processing errors",
      applicable_law: "Applicable Law",
      tunisian_law: "Tunisian law",
      competent_courts: "Competent Courts",
      amicable_settlement: "Amicable Settlement",
      mediation: "Mediation",
      modification_notification: "Modification Notification",
      publication_on_this_page_with_update_date_indicati: "Publication on this page with update date indication",
      email_notification_to_active_users: "Email notification to active users",
      display_of_an_information_banner_in_the_applicatio: "Display of an information banner in the application",
      effective_date: "Effective Date",
      general_terms: "General Terms",
      tunisian_organic_law_no_2018_20_of_april_25_2018: "Tunisian Organic Law No. 2018-20 of April 25, 2018",
      data_controller_: "Data Controller:",
      data_protection_officer_dpo_: "Data Protection Officer (DPO):",
      when_you_use_our_platform_we_may_collect_the_follo: "When you use our platform, we may collect the following categories of data:",
      identification_data: "Identification Data",
      first_and_last_name: "First and last name",
      email_address: "Email address",
      tunisian_mobile_phone_number: "Tunisian mobile phone number",
      delivery_address_for_physical_products_: "Delivery address (for physical products)",
      financial_data: "Financial Data",
      deposit_history_amount_method_anonymized_payment_p: "Deposit history (amount, method, anonymized payment proof)",
      order_history_and_internal_balance_deductions: "Order history and Internal Balance deductions",
      electronic_invoices: "Electronic invoices",
      user_content_data: "User Content Data",
      files_uploaded_for_product_customization: "Files uploaded for product customization",
      avatar_and_profile_preferences: "Avatar and profile preferences",
      technical_data: "Technical Data",
      ip_address_and_connection_logs: "IP address and connection logs",
      device_type_browser_and_operating_system: "Device type, browser and operating system",
      preferences_language_dark_mode_: "Preferences (language, dark mode)",
      navigation_data_via_cookies: "Navigation data via cookies",
      your_data_is_processed_based_on_legal_grounds_defi: "Your data is processed based on legal grounds defined by Tunisian law:",
      purpose: "Purpose",
      legal_basis_law_2018_20_: "Legal Basis (Law 2018-20)",
      details: "Details",
      account_and_internal_balance_management: "Account and Internal Balance Management",
      contract_performance_art_13_: "Contract performance (Art. 13)",
      creation_of_eservices_wallet_deposit_validation_ba: "Creation of eServices Wallet, deposit validation, balance tracking, authentication",
      order_processing: "Order Processing",
      delivery_of_digital_codes_product_customization_in: "Delivery of digital codes, product customization, invoicing, after-sales support",
      payment_proof_archiving: "Payment Proof Archiving",
      legal_obligation_art_15_: "Legal obligation (Art. 15)",
      retention_of_financial_records_according_to_tunisi: "Retention of financial records according to Tunisian Commercial Code (10 years)",
      fraud_prevention: "Fraud Prevention",
      legitimate_interest_art_14_: "Legitimate interest (Art. 14)",
      behavior_analysis_to_secure_the_platform_and_prote: "Behavior analysis to secure the platform and protect our users",
      customer_support_improvement: "Customer Support & Improvement",
      responding_to_requests_via_tickets_improving_inter: "Responding to requests via tickets, improving interface and services",
      marketing_newsletters_: "Marketing (Newsletters)",
      explicit_consent_art_12_: "Explicit consent (Art. 12)",
      only_if_you_checked_the_acceptance_box_during_regi: "Only if you checked the acceptance box during registration",
      supabase_inc_: "Supabase Inc.",
      transactional_email_services: "Transactional email services",
      shipping_providers: "Shipping providers",
      retention_periods: "Retention Periods",
      active_account_data: "Active account data",
      transactional_data_and_invoices: "Transactional data and invoices",
      uploaded_customization_files: "Uploaded customization files",
      security_logs: "Security logs",
      deletion_procedure: "Deletion Procedure",
      anonymized: "Anonymized",
      securely_destroyed: "Securely destroyed",
      right_of_access: "Right of Access",
      obtain_confirmation_that_your_data_is_being_proces: "Obtain confirmation that your data is being processed and receive a copy.",
      right_to_rectification: "Right to Rectification",
      have_inaccurate_or_incomplete_data_corrected_: "Have inaccurate or incomplete data corrected.",
      right_to_erasure: "Right to Erasure",
      request_deletion_of_your_data_under_certain_condit: "Request deletion of your data under certain conditions.",
      right_to_restriction: "Right to Restriction",
      temporarily_suspend_processing_of_your_data_: "Temporarily suspend processing of your data.",
      right_to_object: "Right to Object",
      object_to_processing_for_legitimate_reasons_: "Object to processing for legitimate reasons.",
      right_to_data_portability: "Right to Data Portability",
      receive_your_data_in_a_structured_commonly_used_fo: "Receive your data in a structured, commonly used format.",
      how_to_exercise_your_rights_: "How to Exercise Your Rights?",
      technical_measures: "Technical Measures",
      ssl_tls_encryption_for_all_communications: "SSL/TLS encryption for all communications",
      firewalls_and_intrusion_detection_systems: "Firewalls and intrusion detection systems",
      regular_encrypted_backups: "Regular encrypted backups",
      passwords_stored_in_hashed_form_bcrypt_: "Passwords stored in hashed form (bcrypt)",
      two_factor_authentication_for_administrative_team: "Two-factor authentication for administrative team",
      organizational_measures: "Organizational Measures",
      restricted_data_access_based_on_need_to_know_princ: "Restricted data access based on \"need-to-know\" principle",
      mandatory_staff_training_on_data_protection: "Mandatory staff training on data protection",
      regular_security_audits: "Regular security audits",
      documented_procedures_in_case_of_data_breach: "Documented procedures in case of data breach",
      breach_notification: "Breach Notification",
      cookie_type: "Cookie Type",
      retention: "Retention",
      essential_cookies: "Essential Cookies",
      maintain_your_login_session_manage_your_cart_ensur: "Maintain your login session, manage your cart, ensure security",
      session_duration: "Session duration",
      analytical_cookies: "Analytical Cookies",
      measure_audience_understand_platform_usage_anonymi: "Measure audience, understand platform usage (anonymized)",
      maximum_13_months: "Maximum 13 months",
      remember_your_language_dark_light_mode: "Remember your language, dark/light mode",
      european_commission_standard_contractual_clauses: "European Commission Standard Contractual Clauses",
      data_protection_certifications_e_g_privacy_shield_: "Data protection certifications (e.g., Privacy Shield for the United States, when applicable)",
      strict_confidentiality_agreements_with_our_subcont: "Strict confidentiality agreements with our subcontractors",
      effective_date_: "Effective Date:",
      general_email_: "General email:",
      deposit_issue: "Deposit issue",
      non_functional_code: "Non-functional code",
      service_discontinued: "Service discontinued",
      terms_and_conditions_of_use: "Terms and Conditions of Use",
      important_note_: "Important note:",
      article_1_general_principle_no_refund: "ARTICLE 1 - GENERAL PRINCIPLE: NO REFUND",
      the_eservices_internal_balance_is_non_refundable_: "The eServices Internal Balance is non-refundable.",
      article_2_exceptional_cases_for_credit_or_refund: "ARTICLE 2 - EXCEPTIONAL CASES FOR CREDIT OR REFUND",
      status_pending_: "Status \"Pending\":",
      status_validated_: "Status \"Validated\":",
      exception_for_double_bank_transfer_: "Exception for double bank transfer:",
      timeframe_: "Timeframe:",
      verification_: "Verification:",
      solution_: "Solution :",
      article_3_procedure_for_admitted_exceptional_cases: "ARTICLE 3 - PROCEDURE FOR ADMITTED EXCEPTIONAL CASES",
      open_a_support_ticket: "Open a support ticket",
      provide_all_necessary_evidence_: "Provide all necessary evidence:",
      complete_screenshots: "Complete screenshots",
      transaction_identification_number_d17_flouci_: "Transaction identification number (D17/Flouci)",
      bank_transfer_proof: "Bank transfer proof",
      relevant_order_number: "Relevant order number",
      request_review_: "Request review:",
      decision_and_compensation_: "Decision and compensation:",
      article_4_applicable_fees: "ARTICLE 4 - APPLICABLE FEES",
      no_fees: "No Fees",
      processing_a_replacement_credit_request_defective_: "Processing a replacement credit request (defective code) is free of charge.",
      bank_transaction_fees: "Bank Transaction Fees",
      article_5_contact_and_processing_modalities: "ARTICLE 5 - CONTACT AND PROCESSING MODALITIES",
      the_ticket_system_ensures_organized_follow_up_secu: "The ticket system ensures organized follow-up, secure exchanges, and the ability to attach supporting documents.",
      you_can_track_the_progress_of_your_request_at_any_: "You can track the progress of your request at any time from your interface.",
      related_documents: "Related documents",
      delivery_policy: "Delivery Policy",
      last_updated_date_: "Last updated date:",
      publisher: "Publisher",
      legal_name_: "Legal name:",
      registered_office_: "Registered office:",
      legal_contact_: "Legal contact:",
      art_1_purpose: "Art 1. Purpose",
      these_general_terms_and_conditions_gtc_aim_to_defi: "These General Terms and Conditions (GTC) aim to define the rights and obligations of the parties within the framework of using the eServices platform and its economic model based on a prepaid internal balance. They govern access to the website eservices.tn and the associated mobile application, the creation of the eServices Wallet account, deposit of funds, and the purchase of digital services and customized products.",
      art_2_definitions: "Art 2. Definitions",
      platform_: "Platform:",
      user_client_: "User/Client:",
      account_eservices_wallet_: "Account / eServices Wallet:",
      internal_balance_: "Internal Balance:",
      services_: "Services :",
      deposit_: "Deposit:",
      order_: "Order:",
      art_3_acceptance_and_capacity: "Art 3. Acceptance and Capacity",
      art_4_service_description_and_role_of_eservices: "Art 4. Service Description and Role of eServices",
      the_management_of_a_prepaid_electronic_wallet_inte: "The management of a prepaid electronic wallet (Internal Balance).",
      the_purchase_of_services_provided_by_third_party_p: "The purchase of Services provided by third-party partners (telecom operators, game publishers, streaming services) or produced by eServices (customization).",
      art_5_account_creation_and_security: "Art 5. Account Creation and Security",
      art_6_internal_balance_top_up_nature_irrevocabilit: "Art 6. Internal Balance: Top-up, Nature, Irrevocability",
      validation_of_the_deposit_is_conditional_upon_rece: "Validation of the Deposit is conditional upon receipt and manual verification by eServices of valid payment proof.",
      the_internal_balance_is_strictly_attached_to_the_a: "The Internal Balance is strictly attached to the Account and cannot be assigned, sold, or transferred to a third party.",
      art_7_order_placement_and_payment: "Art 7. Order Placement and Payment",
      art_8_delivery: "Art 8. Delivery",
      the_right_of_withdrawal_is_excluded_: "The right of withdrawal is excluded.",
      delivery_according_to_the_terms_indicated_on_the_p: "Delivery according to the terms indicated on the product sheet. Delivery times begin after validation of customization by our team. Shipping costs and risks are specified at the time of order.",
      art_9_right_of_withdrawal_and_warranties: "Art 9. Right of Withdrawal and Warranties",
      services_fully_performed_before_the_end_of_the_wit: "Services fully performed before the end of the withdrawal period (top-ups, delivered codes)",
      goods_or_services_whose_price_depends_on_financial: "Goods or services whose price depends on financial market fluctuations",
      goods_made_to_their_specifications_or_clearly_cust: "Goods made to their specifications or clearly customized",
      the_provisions_of_the_tunisian_code_of_obligations: "The provisions of the Tunisian Code of Obligations and Contracts relating to hidden defects remain applicable. For a defective digital code, the Client must open a ticket within 48 hours to obtain a replacement code.",
      art_10_intellectual_property: "Art 10. Intellectual Property",
      the_platform_its_design_source_code_databases_logo: "The Platform, its design, source code, databases, logos, and editorial content are the exclusive property of eServices or its licensors and are protected by Tunisian copyright law and international conventions (INNORPI). Any file uploaded by the Client remains their intellectual property; they grant eServices a limited usage license for the strict execution of the order.",
      art_11_client_obligations_and_responsibilities: "Art 11. Client Obligations and Responsibilities",
      the_client_undertakes_not_to_: "The Client undertakes not to:",
      use_the_platform_for_illegal_or_fraudulent_purpose: "Use the Platform for illegal or fraudulent purposes",
      attempt_to_hack_disassemble_or_overload_the_infras: "Attempt to hack, disassemble, or overload the infrastructure",
      upload_files_containing_viruses_or_illicit_content: "Upload files containing viruses or illicit content",
      bypass_the_internal_balance_system: "Bypass the internal balance system",
      art_12_limitation_of_eservices_s_liability: "Art 12. Limitation of eServices's Liability",
      interruptions_due_to_maintenance_or_force_majeure: "Interruptions due to maintenance or force majeure",
      data_loss_related_to_client_s_fault: "Data loss related to Client's fault",
      content_or_availability_of_services_provided_by_th: "Content or availability of services provided by third-party partners (operators, publishers)",
      indirect_damages_loss_of_profits_loss_of_opportuni: "Indirect damages (loss of profits, loss of opportunity)",
      art_13_personal_data: "Art 13. Personal Data",
      art_14_suspension_and_termination: "Art 14. Suspension and Termination",
      art_15_modifications: "Art 15. Modifications",
      art_16_applicable_law_and_disputes: "Art 16. Applicable Law and Disputes",
      courts_of_registered_office_city_: "Courts of [Registered office city]",
      un_cookie_est_un_petit_fichier_texte_stock_sur_vot: "Un cookie est un petit fichier texte stocké sur votre appareil (ordinateur, tablette, smartphone) lorsque vous visitez un site web. Les cookies permettent au site de mémoriser vos actions et préférences sur une période donnée.",
      am_liorer_votre_exp_rience_utilisateur_et_personna: "Améliorer votre expérience utilisateur et personnaliser l'interface",
      assurer_le_fonctionnement_technique_du_site_connex: "Assurer le fonctionnement technique du site (connexion, gestion du panier, sécurité des transactions)",
      analyser_le_trafic_et_l_audience_du_site_pour_opti: "Analyser le trafic et l'audience du site pour optimiser nos services",
      enregistrer_vos_pr_f_rences_langue_mode_sombre_par: "Enregistrer vos préférences (langue, mode sombre, paramètres d'affichage)",
      prot_ger_la_plateforme_contre_les_activit_s_fraudu: "Protéger la plateforme contre les activités frauduleuses",
      loi_tunisienne_n_2018_20: "Loi tunisienne n° 2018-20",
      cookies_essentiels_techniques_: "Cookies essentiels (techniques)",
      indispensables_au_fonctionnement_de_la_plateforme_: "Indispensables au fonctionnement de la plateforme :",
      authentification_et_gestion_de_session_utilisateur: "Authentification et gestion de session utilisateur",
      maintien_de_la_s_curit_de_votre_compte_et_de_vos_t: "Maintien de la sécurité de votre compte et de vos transactions",
      conservation_des_articles_dans_votre_panier_entre_: "Conservation des articles dans votre panier entre les sessions",
      m_morisation_de_vos_pr_f_rences_de_confidentialit_: "Mémorisation de vos préférences de confidentialité",
      ces_cookies_ne_peuvent_pas_tre_d_sactiv_s_via_notr: "Ces cookies ne peuvent pas être désactivés via notre interface.",
      cookies_analytiques_statistiques_: "Cookies analytiques (statistiques)",
      nous_utilisons_des_outils_d_analyse_internes_pour_: "Nous utilisons des outils d'analyse internes pour :",
      mesurer_l_audience_et_les_performances_du_site: "Mesurer l'audience et les performances du site",
      comprendre_comment_les_utilisateurs_interagissent_: "Comprendre comment les utilisateurs interagissent avec la plateforme",
      d_tecter_et_r_soudre_les_probl_mes_techniques: "Détecter et résoudre les problèmes techniques",
      am_liorer_continuellement_l_exp_rience_utilisateur: "Améliorer continuellement l'expérience utilisateur",
      ces_cookies_sont_anonymis_s_et_ne_permettent_pas_v: "Ces cookies sont anonymisés et ne permettent pas votre identification personnelle.",
      cookies_de_pr_f_rences: "Cookies de préférences",
      ils_m_morisent_vos_choix_personnels_: "Ils mémorisent vos choix personnels :",
      langue_de_l_interface_fran_ais_arabe_anglais_: "Langue de l'interface (Français, Arabe, Anglais)",
      mode_d_affichage_sombre_clair_: "Mode d'affichage (sombre/clair)",
      param_tres_r_gionaux: "Paramètres régionaux",
      pr_f_rences_de_notification: "Préférences de notification",
      certains_services_int_gr_s_eservices_peuvent_d_pos: "Certains services intégrés à eServices peuvent déposer leurs propres cookies :",
      services_de_paiement_: "Services de paiement :",
      outils_d_analyse_: "Outils d'analyse :",
      services_d_email_transactionnel_: "Services d'email transactionnel :",
      nous_s_lectionnons_rigoureusement_nos_partenaires_: "Nous sélectionnons rigoureusement nos partenaires et nous assurons qu'ils respectent les standards de protection des données. Ces cookies sont soumis aux politiques de confidentialité de leurs émetteurs.",
      vous_avez_le_contr_le_sur_l_utilisation_des_cookie: "Vous avez le contrôle sur l'utilisation des cookies :",
      via_notre_bandeau_de_consentement: "Via notre bandeau de consentement",
      lors_de_votre_premi_re_visite_un_bandeau_vous_perm: "Lors de votre première visite, un bandeau vous permet d'accepter ou de refuser les cookies non essentiels. Vous pouvez modifier vos choix à tout moment en cliquant sur le lien \"Gérer les cookies\" en bas de page.",
      via_les_param_tres_de_votre_navigateur: "Via les paramètres de votre navigateur",
      vous_pouvez_configurer_votre_navigateur_pour_: "Vous pouvez configurer votre navigateur pour :",
      refuser_tous_les_cookies: "Refuser tous les cookies",
      accepter_uniquement_les_cookies_essentiels: "Accepter uniquement les cookies essentiels",
      _tre_averti_chaque_d_p_t_de_cookie: "Être averti à chaque dépôt de cookie",
      supprimer_automatiquement_les_cookies_la_fermeture: "Supprimer automatiquement les cookies à la fermeture",
      la_proc_dure_varie_selon_les_navigateurs_: "La procédure varie selon les navigateurs :",
      cons_quences_du_refus: "Conséquences du refus",
      si_vous_d_sactivez_les_cookies_: "Si vous désactivez les cookies :",
      vous_devrez_vous_reconnecter_chaque_visite: "Vous devrez vous reconnecter à chaque visite",
      votre_panier_ne_sera_pas_sauvegard_entre_les_sessi: "Votre panier ne sera pas sauvegardé entre les sessions",
      vos_pr_f_rences_langue_mode_sombre_ne_seront_pas_m: "Vos préférences (langue, mode sombre) ne seront pas mémorisées",
      certaines_fonctionnalit_s_pourraient_tre_limit_es: "Certaines fonctionnalités pourraient être limitées",
      la_s_curit_de_certaines_transactions_pourrait_tre_: "La sécurité de certaines transactions pourrait être réduite",
      les_cookies_ont_des_dur_es_de_vie_variables_: "Les cookies ont des durées de vie variables :",
      cookies_de_session_: "Cookies de session :",
      cookies_persistants_: "Cookies persistants :",
      cookies_d_authentification_: "Cookies d'authentification :",
      cookies_analytiques_: "Cookies analytiques :",
      politique_de_confidentialit_: "Politique de Confidentialité",
      les_donn_es_collect_es_via_les_cookies_sont_trait_: "Les données collectées via les cookies sont traitées de manière sécurisée",
      nous_ne_partageons_pas_vos_donn_es_de_navigation_d: "Nous ne partageons pas vos données de navigation à des fins commerciales sans votre consentement",
      les_cookies_analytiques_sont_anonymis_s: "Les cookies analytiques sont anonymisés",
      nous_conservons_les_logs_techniques_li_s_aux_cooki: "Nous conservons les logs techniques liés aux cookies pendant 1 an maximum",
      vous_disposez_d_un_droit_d_acc_s_de_rectification_: "Vous disposez d'un droit d'accès, de rectification et d'opposition au traitement de vos données",
      nous_pouvons_mettre_jour_cette_politique_de_cookie: "Nous pouvons mettre à jour cette Politique de Cookies pour refléter :",
      les_volutions_techniques_de_la_plateforme: "Les évolutions techniques de la plateforme",
      les_changements_r_glementaires_tunisiens_ou_intern: "Les changements réglementaires tunisiens ou internationaux",
      l_ajout_de_nouvelles_fonctionnalit_s_ou_services: "L'ajout de nouvelles fonctionnalités ou services",
      les_modifications_seront_publi_es_sur_cette_page_a: "Les modifications seront publiées sur cette page avec indication de la date de mise à jour. En cas de changement significatif, nous vous en informerons par email ou via une notification sur la plateforme.",
      pour_toute_question_concernant_notre_utilisation_d: "Pour toute question concernant notre utilisation des cookies ou pour exercer vos droits :",
      email_du_dpo_: "Email du DPO :",
      tickets_de_support_: "Tickets de support :",
      adresse_postale_: "Adresse postale :",
      instance_nationale_de_protection_des_donn_es_perso: "Instance Nationale de Protection des Données Personnelles (INPDP)",
      derni_re_mise_jour_: "Dernière mise à jour :",
      applicable_: "Applicable à :",
      mes_codes: "Mes Codes",
      r_v_ler: "Révéler",
      article_1_champ_d_application: "ARTICLE 1 - CHAMP D'APPLICATION",
      services_num_riques: "Services Numériques",
      article_2_services_num_riques_recharges_codes_abon: "ARTICLE 2 - SERVICES NUMÉRIQUES (Recharges, Codes, Abonnements)",
      recharge_mobile_: "Recharge Mobile :",
      codes_num_riques_gaming_streaming_licences_: "Codes Numériques (Gaming, Streaming, Licences) :",
      code_masqu_: "Code Masqué :",
      export_pdf_: "Export PDF :",
      article_3_produits_personnalis_s_et_physiques: "ARTICLE 3 - PRODUITS PERSONNALISÉS ET PHYSIQUES",
      en_traitement_: "En traitement :",
      exp_di_: "Expédié :",
      livr_: "Livré :",
      pr_paration_: "Préparation :",
      article_4_responsabilit_s: "ARTICLE 4 - RESPONSABILITÉS",
      risque_sur_les_produits_physiques_: "Risque sur les Produits Physiques :",
      service_num_rique_non_re_u_: "Service Numérique Non Reçu :",
      fichiers_de_personnalisation_: "Fichiers de Personnalisation :",
      article_5_coordonn_es_de_livraison: "ARTICLE 5 - COORDONNÉES DE LIVRAISON",
      article_6_droit_de_r_tractation: "ARTICLE 6 - DROIT DE RÉTRACTATION",
      les_services_num_riques_fournis_imm_diatement_apr_: "Les services numériques fournis immédiatement après la commande (recharges, codes livrés)",
      les_biens_confectionn_s_selon_ses_sp_cifications_o: "Les biens confectionnés selon ses spécifications ou nettement personnalisés",
      les_produits_p_rissables_ou_ayant_une_date_de_vali: "Les produits périssables ou ayant une date de validité limitée",
      politique_de_remboursement: "Politique de Remboursement",
      d_lai_de_r_ponse_: "Délai de réponse :",
      soci_t_ditrice: "Société éditrice",
      d_nomination_sociale_: "Dénomination sociale :",
      forme_juridique_: "Forme juridique :",
      capital_social_: "Capital social :",
      immatriculation_: "Immatriculation :",
      tva_intracommunautaire_: "TVA Intracommunautaire :",
      si_ge_social: "Siège social",
      adresse_: "Adresse :",
      g_olocalisation_: "Géolocalisation :",
      direction_et_publication: "Direction et publication",
      directeur_de_la_publication_: "Directeur de la publication :",
      responsable_ditorial_: "Responsable éditorial :",
      d_l_gu_la_protection_des_donn_es_: "Délégué à la Protection des Données :",
      support_technique_et_commercial: "Support technique et commercial",
      t_l_phone_: "Téléphone :",
      horaires_: "Horaires :",
      lundi_au_vendredi_9h_18h_heure_locale_tunisienne_: "Lundi au Vendredi, 9h-18h (heure locale tunisienne)",
      recommandation_: "Recommandation :",
      service_juridique_et_conformit_: "Service juridique et conformité",
      email_juridique_: "Email juridique :",
      protection_des_donn_es_: "Protection des données :",
      service_contentieux_: "Service contentieux :",
      infrastructure_principale: "Infrastructure principale",
      base_de_donn_es_et_authentification: "Base de données et authentification",
      fournisseur_: "Fournisseur :",
      localisation_: "Localisation :",
      s_curit_: "Sécurité :",
      services_compl_mentaires: "Services complémentaires",
      email_transactionnel_: "Email transactionnel :",
      analyse_d_audience_: "Analyse d'audience :",
      disponibilit_et_maintenance: "Disponibilité et maintenance",
      taux_de_disponibilit_garanti: "Taux de disponibilité garanti",
      surveillance_et_support_technique: "Surveillance et support technique",
      chiffrement_tls_1_3_certifi_: "Chiffrement TLS 1.3 certifié",
      marques_et_logos: "Marques et logos",
      d_p_t_innorpi_institut_national_de_la_normalisatio: "Dépôt INNORPI (Institut National de la Normalisation et de la Propriété Industrielle)",
      protection_internationale_via_le_syst_me_de_madrid: "Protection internationale via le système de Madrid",
      toute_reproduction_sans_autorisation_expresse_est_: "Toute reproduction sans autorisation expresse est interdite",
      droits_d_auteur: "Droits d'auteur",
      code_source_et_algorithmes: "Code source et algorithmes",
      design_et_interface_utilisateur: "Design et interface utilisateur",
      documentation_technique_et_contenu_ditorial: "Documentation technique et contenu éditorial",
      base_de_donn_es_protection_sui_generis_: "Base de données (protection sui generis)",
      licences_d_utilisation: "Licences d'utilisation",
      autoris_: "Autorisé",
      usage_personnel_et_non_commercial: "Usage personnel et non commercial",
      acc_s_via_navigateur_ou_application_officielle: "Accès via navigateur ou application officielle",
      cr_ation_d_un_compte_unique_par_personne: "Création d'un compte unique par personne",
      interdit: "Interdit",
      reverse_engineering_ou_d_compilation: "Reverse engineering ou décompilation",
      utilisation_commerciale_non_autoris_e: "Utilisation commerciale non autorisée",
      cr_ation_de_comptes_multiples: "Création de comptes multiples",
      extraction_massive_de_donn_es: "Extraction massive de données",
      domaine: "Domaine",
      cadre_l_gal: "Cadre légal",
      conformit_: "Conformité",
      r_f_rence: "Référence",
      commerce_lectronique: "Commerce électronique",
      loi_tunisienne_n_2000_83: "Loi tunisienne n°2000-83",
      compl_te: "Complète",
      protection_des_donn_es: "Protection des données",
      loi_organique_n_2018_20: "Loi organique n°2018-20",
      d_claration_inpdp: "Déclaration INPDP",
      dossier_n_num_ro_: "Dossier n° [Numéro]",
      services_de_paiement: "Services de paiement",
      r_glementation_bct: "Règlementation BCT",
      conforme_aux_usages: "Conforme aux usages",
      circulaire_xx_2022: "Circulaire XX/2022",
      consommation: "Consommation",
      code_de_la_consommation: "Code de la Consommation",
      respect_des_d_lais: "Respect des délais",
      fiscalit_: "Fiscalité",
      code_des_douanes_et_imp_ts: "Code des Douanes et Impôts",
      tva_collect_e: "TVA collectée",
      n_tva_num_ro_tva_: "N° TVA: [Numéro TVA]",
      droit_d_auteur: "Droit d'auteur",
      loi_n_94_36: "Loi n°94-36",
      licences_partenaires: "Licences partenaires",
      autorit_s_de_r_gulation: "Autorités de régulation",
      banque_centrale_de_tunisie: "Banque Centrale de Tunisie",
      institut_national_de_la_normalisation_et_de_la_pro: "Institut National de la Normalisation et de la Propriété Industrielle",
      r_le_d_interm_diaire: "Rôle d'intermédiaire",
      exclusions_de_garantie: "Exclusions de garantie",
      services_num_riques_: "Services numériques :",
      interruptions_de_service_: "Interruptions de service :",
      donn_es_utilisateur_: "Données utilisateur :",
      usage_frauduleux_: "Usage frauduleux :",
      plafonnement_de_responsabilit_: "Plafonnement de responsabilité",
      montant_de_la_commande: "Montant de la commande",
      plafond_pour_les_services_num_riques: "Plafond pour les services numériques",
      dernier_d_p_t: "Dernier dépôt",
      plafond_pour_les_erreurs_de_traitement: "Plafond pour les erreurs de traitement",
      droit_applicable: "Droit applicable",
      tribunaux_comp_tents: "Tribunaux compétents",
      r_glement_amiable: "Règlement amiable",
      m_diation: "Médiation",
      notification_des_modifications: "Notification des modifications",
      publication_sur_cette_page_avec_indication_de_la_d: "Publication sur cette page avec indication de la date de mise à jour",
      notification_par_email_aux_utilisateurs_actifs: "Notification par email aux utilisateurs actifs",
      affichage_d_un_bandeau_d_information_dans_l_applic: "Affichage d'un bandeau d'information dans l'application",
      entr_e_en_vigueur: "Entrée en vigueur",
      conditions_g_n_rales: "Conditions Générales",
      loi_organique_tunisienne_n_2018_20_du_25_avril_201: "Loi organique tunisienne n° 2018-20 du 25 avril 2018",
      responsable_du_traitement_: "Responsable du traitement :",
      d_l_gu_la_protection_des_donn_es_dpo_: "Délégué à la Protection des Données (DPO) :",
      dans_le_cadre_de_l_utilisation_de_notre_plateforme: "Dans le cadre de l'utilisation de notre plateforme, nous pouvons collecter les catégories de données suivantes :",
      donn_es_d_identification: "Données d'identification",
      nom_et_pr_nom: "Nom et prénom",
      adresse_e_mail: "Adresse e-mail",
      num_ro_de_t_l_phone_mobile_tunisien: "Numéro de téléphone mobile tunisien",
      adresse_de_livraison_pour_les_produits_physiques_: "Adresse de livraison (pour les produits physiques)",
      donn_es_financi_res: "Données financières",
      historique_des_d_p_ts_montant_m_thode_preuve_de_pa: "Historique des dépôts (montant, méthode, preuve de paiement anonymisée)",
      historique_des_commandes_et_d_bits_du_solde_intern: "Historique des commandes et débits du Solde Interne",
      factures_lectroniques: "Factures électroniques",
      donn_es_de_contenu_utilisateur: "Données de contenu utilisateur",
      fichiers_upload_s_pour_la_personnalisation_de_prod: "Fichiers uploadés pour la personnalisation de produits",
      avatar_et_pr_f_rences_de_profil: "Avatar et préférences de profil",
      donn_es_techniques: "Données techniques",
      adresse_ip_et_logs_de_connexion: "Adresse IP et logs de connexion",
      type_d_appareil_navigateur_et_syst_me_d_exploitati: "Type d'appareil, navigateur et système d'exploitation",
      pr_f_rences_langue_mode_sombre_: "Préférences (langue, mode sombre)",
      donn_es_de_navigation_via_cookies: "Données de navigation via cookies",
      le_traitement_de_vos_donn_es_s_effectue_sur_des_ba: "Le traitement de vos données s'effectue sur des bases légales définies par la loi tunisienne :",
      finalit_: "Finalité",
      base_l_gale_loi_2018_20_: "Base Légale (Loi 2018-20)",
      d_tails: "Détails",
      gestion_du_compte_et_du_solde_interne: "Gestion du Compte et du Solde Interne",
      ex_cution_du_contrat_art_13_: "Exécution du contrat (Art. 13)",
      cr_ation_du_portefeuille_eservices_validation_des_: "Création du Portefeuille eServices, validation des dépôts, suivi du solde, authentification",
      traitement_des_commandes: "Traitement des Commandes",
      livraison_des_codes_num_riques_personnalisation_de: "Livraison des codes numériques, personnalisation des produits, facturation, support post-vente",
      archivage_des_preuves_de_paiement: "Archivage des preuves de paiement",
      obligation_l_gale_art_15_: "Obligation légale (Art. 15)",
      conservation_des_justificatifs_financiers_conform_: "Conservation des justificatifs financiers conformément au Code de Commerce tunisien (10 ans)",
      pr_vention_de_la_fraude: "Prévention de la fraude",
      int_r_t_l_gitime_art_14_: "Intérêt légitime (Art. 14)",
      analyse_des_comportements_pour_s_curiser_la_platef: "Analyse des comportements pour sécuriser la plateforme et protéger nos utilisateurs",
      support_client_am_lioration: "Support client & amélioration",
      r_pondre_aux_demandes_via_tickets_am_liorer_l_inte: "Répondre aux demandes via tickets, améliorer l'interface et les services",
      consentement_expr_s_art_12_: "Consentement exprès (Art. 12)",
      uniquement_si_vous_avez_coch_la_case_d_acceptation: "Uniquement si vous avez coché la case d'acceptation lors de l'inscription",
      services_d_envoi_d_e_mails_transactionnels: "Services d'envoi d'e-mails transactionnels",
      prestataires_de_transport: "Prestataires de transport",
      dur_es_de_conservation: "Durées de conservation",
      donn_es_du_compte_actif: "Données du compte actif",
      donn_es_transactionnelles_et_factures: "Données transactionnelles et factures",
      fichiers_upload_s_pour_personnalisation: "Fichiers uploadés pour personnalisation",
      logs_de_s_curit_: "Logs de sécurité",
      proc_dure_de_suppression: "Procédure de suppression",
      anonymis_es: "Anonymisées",
      d_truites_de_mani_re_s_curis_e: "Détruites de manière sécurisée",
      droit_d_acc_s: "Droit d'accès",
      obtenir_la_confirmation_que_vos_donn_es_sont_trait: "Obtenir la confirmation que vos données sont traitées et en recevoir une copie.",
      droit_de_rectification: "Droit de rectification",
      faire_corriger_des_donn_es_inexactes_ou_incompl_te: "Faire corriger des données inexactes ou incomplètes.",
      droit_l_effacement: "Droit à l'effacement",
      demander_la_suppression_de_vos_donn_es_sous_certai: "Demander la suppression de vos données sous certaines conditions.",
      droit_la_limitation: "Droit à la limitation",
      suspension_temporaire_du_traitement_de_vos_donn_es: "Suspension temporaire du traitement de vos données.",
      droit_d_opposition: "Droit d'opposition",
      vous_opposer_au_traitement_pour_des_raisons_l_giti: "Vous opposer au traitement pour des raisons légitimes.",
      droit_la_portabilit_: "Droit à la portabilité",
      recevoir_vos_donn_es_dans_un_format_structur_et_li: "Recevoir vos données dans un format structuré et lisible.",
      comment_exercer_vos_droits_: "Comment exercer vos droits ?",
      mesures_techniques: "Mesures techniques",
      chiffrement_ssl_tls_pour_toutes_les_communications: "Chiffrement SSL/TLS pour toutes les communications",
      pare_feu_et_syst_mes_de_d_tection_d_intrusion: "Pare-feu et systèmes de détection d'intrusion",
      sauvegardes_r_guli_res_et_chiffr_es: "Sauvegardes régulières et chiffrées",
      mots_de_passe_stock_s_sous_forme_hach_e_bcrypt_: "Mots de passe stockés sous forme hachée (bcrypt)",
      authentification_deux_facteurs_pour_l_quipe_admini: "Authentification à deux facteurs pour l'équipe administrative",
      mesures_organisationnelles: "Mesures organisationnelles",
      acc_s_restreint_aux_donn_es_selon_le_principe_du_b: "Accès restreint aux données selon le principe du \"besoin d'en connaître\"",
      formation_obligatoire_du_personnel_la_protection_d: "Formation obligatoire du personnel à la protection des données",
      audits_de_s_curit_r_guliers: "Audits de sécurité réguliers",
      proc_dures_document_es_en_cas_de_violation_de_donn: "Procédures documentées en cas de violation de données",
      notification_en_cas_de_violation: "Notification en cas de violation",
      type_de_cookie: "Type de cookie",
      conservation: "Conservation",
      cookies_essentiels: "Cookies essentiels",
      maintenir_votre_session_de_connexion_g_rer_votre_p: "Maintenir votre session de connexion, gérer votre panier, assurer la sécurité",
      dur_e_de_la_session: "Durée de la session",
      cookies_analytiques: "Cookies analytiques",
      mesurer_l_audience_comprendre_l_usage_de_la_platef: "Mesurer l'audience, comprendre l'usage de la plateforme (anonymisé)",
      m_moriser_votre_langue_mode_sombre_clair: "Mémoriser votre langue, mode sombre/clair",
      clauses_contractuelles_types_de_la_commission_euro: "Clauses contractuelles types de la Commission Européenne",
      certifications_de_protection_des_donn_es_ex_privac: "Certifications de protection des données (ex: Privacy Shield pour les États-Unis, lorsque applicable)",
      accords_de_confidentialit_stricts_avec_nos_sous_tr: "Accords de confidentialité stricts avec nos sous-traitants",
      date_d_entr_e_en_vigueur_: "Date d'entrée en vigueur :",
      email_g_n_ral_: "Email général :",
      probl_me_de_d_p_t: "Problème de dépôt",
      code_non_fonctionnel: "Code non fonctionnel",
      service_interrompu: "Service interrompu",
      conditions_g_n_rales_d_utilisation: "Conditions Générales d'Utilisation",
      note_importante_: "Note importante :",
      article_1_principe_g_n_ral_absence_de_remboursemen: "ARTICLE 1 - PRINCIPE GÉNÉRAL : ABSENCE DE REMBOURSEMENT",
      le_solde_interne_eservices_n_est_pas_remboursable_: "Le Solde Interne eServices n'est pas remboursable.",
      article_2_cas_exceptionnels_de_cr_dit_ou_de_rembou: "ARTICLE 2 - CAS EXCEPTIONNELS DE CRÉDIT OU DE REMBOURSEMENT",
      statut_en_attente_: "Statut \"En attente\" :",
      statut_valid_: "Statut \"Validé\" :",
      exception_pour_double_virement_bancaire_: "Exception pour double virement bancaire :",
      d_lai_: "Délai :",
      v_rification_: "Vérification :",
      article_3_proc_dure_pour_les_cas_exceptionnels_adm: "ARTICLE 3 - PROCÉDURE POUR LES CAS EXCEPTIONNELS ADMIS",
      ouvrez_un_ticket_de_support: "Ouvrez un ticket de support",
      fournissez_toutes_les_preuves_n_cessaires_: "Fournissez toutes les preuves nécessaires :",
      captures_d_cran_compl_tes: "Captures d'écran complètes",
      num_ro_d_identification_de_transaction_d17_flouci_: "Numéro d'identification de transaction (D17/Flouci)",
      justificatifs_de_virement_bancaire: "Justificatifs de virement bancaire",
      num_ro_de_commande_concern_e: "Numéro de commande concernée",
      _tude_de_la_demande_: "Étude de la demande :",
      d_cision_et_compensation_: "Décision et compensation :",
      article_4_frais_applicables: "ARTICLE 4 - FRAIS APPLICABLES",
      sans_frais: "Sans Frais",
      le_traitement_d_une_demande_de_cr_dit_de_remplacem: "Le traitement d'une demande de crédit de remplacement (code défectueux) est gratuit.",
      frais_de_transaction_bancaire: "Frais de Transaction Bancaire",
      article_5_contact_et_modalit_s_de_traitement: "ARTICLE 5 - CONTACT ET MODALITÉS DE TRAITEMENT",
      le_syst_me_de_tickets_garantit_un_suivi_organis_la: "Le système de tickets garantit un suivi organisé, la sécurité des échanges et la possibilité de joindre des pièces justificatives.",
      vous_pouvez_suivre_l_avancement_de_votre_demande_t: "Vous pouvez suivre l'avancement de votre demande à tout moment depuis votre interface.",
      documents_connexes: "Documents connexes",
      politique_de_livraison: "Politique de Livraison",
      date_de_derni_re_mise_jour_: "Date de dernière mise à jour :",
      _diteur: "Éditeur",
      raison_sociale_: "Raison sociale :",
      tva_intracom_: "TVA Intracom :",
      si_ge_social_: "Siège social :",
      contact_l_gal_: "Contact légal :",
      art_1_objet: "Art 1. Objet",
      les_pr_sentes_conditions_g_n_rales_cgu_ont_pour_ob: "Les présentes Conditions Générales (CGU) ont pour objet de définir les droits et obligations des parties dans le cadre de l'utilisation de la plateforme eServices et de son modèle économique basé sur un solde interne prépayé. Elles régissent l'accès au site eservices.tn et à l'application mobile associée, la création du compte Portefeuille eServices, le dépôt de fonds, et l'achat de services numériques et produits personnalisés.",
      art_2_d_finitions: "Art 2. Définitions",
      plateforme_: "Plateforme :",
      utilisateur_client_: "Utilisateur/Client :",
      compte_portefeuille_eservices_: "Compte / Portefeuille eServices :",
      solde_interne_: "Solde Interne :",
      d_p_t_: "Dépôt :",
      commande_: "Commande :",
      art_3_acceptation_et_capacit_: "Art 3. Acceptation et Capacité",
      art_4_description_du_service_et_r_le_de_eservices: "Art 4. Description du Service et Rôle de eServices",
      la_gestion_d_un_portefeuille_lectronique_pr_pay_so: "La gestion d'un portefeuille électronique prépayé (Solde Interne).",
      l_achat_de_services_fournis_par_des_partenaires_ti: "L'achat de Services fournis par des partenaires tiers (opérateurs télécoms, éditeurs de jeux, services de streaming) ou produits par eServices (personnalisation).",
      art_5_cr_ation_et_s_curit_du_compte: "Art 5. Création et Sécurité du Compte",
      art_6_solde_interne_recharge_nature_irr_vocabilit_: "Art 6. Solde Interne : Recharge, Nature, Irrévocabilité",
      la_validation_du_d_p_t_est_conditionn_e_la_r_cepti: "La validation du Dépôt est conditionnée à la réception et vérification manuelle par eServices d'une preuve de paiement valide.",
      le_solde_interne_est_strictement_attach_au_compte_: "Le Solde Interne est strictement attaché au Compte et ne peut être cédé, vendu ou transféré à un tiers.",
      art_7_passation_de_commande_et_paiement: "Art 7. Passation de Commande et Paiement",
      art_8_livraison: "Art 8. Livraison",
      le_droit_de_r_tractation_est_exclu_: "Le droit de rétractation est exclu.",
      livraison_selon_les_modalit_s_indiqu_es_sur_la_fic: "Livraison selon les modalités indiquées sur la fiche produit. Les délais débutent après validation de la personnalisation par notre équipe. Les frais et risques de transport sont précisés au moment de la commande.",
      art_9_droit_de_r_tractation_et_garanties: "Art 9. Droit de Rétractation et Garanties",
      les_services_pleinement_ex_cut_s_avant_la_fin_du_d: "Les services pleinement exécutés avant la fin du délai de rétractation (recharges, codes livrés)",
      les_biens_ou_services_dont_le_prix_d_pend_de_fluct: "Les biens ou services dont le prix dépend de fluctuations des marchés financières",
      les_dispositions_du_code_des_obligations_et_des_co: "Les dispositions du Code des Obligations et des Contrats tunisiens relatives aux vices cachés restent applicables. Pour un code numérique défectueux, le Client doit ouvrir un ticket sous 48h pour obtenir un code de remplacement.",
      art_10_propri_t_intellectuelle: "Art 10. Propriété Intellectuelle",
      la_plateforme_son_design_son_code_source_ses_bases: "La Plateforme, son design, son code source, ses bases de données, ses logos et son contenu éditorial sont la propriété exclusive de eServices ou de ses concédants et sont protégés par le droit d'auteur tunisien et les conventions internationales (INNORPI). Tout fichier uploadé par le Client reste sa propriété intellectuelle ; il en concède une licence d'usage limitée à eServices pour la stricte exécution de la commande.",
      art_11_obligations_et_responsabilit_s_du_client: "Art 11. Obligations et Responsabilités du Client",
      le_client_s_engage_ne_pas_: "Le Client s'engage à ne pas :",
      utiliser_la_plateforme_des_fins_ill_gales_ou_fraud: "Utiliser la Plateforme à des fins illégales ou frauduleuses",
      tenter_de_pirater_d_sassembler_ou_surcharger_l_inf: "Tenter de pirater, désassembler ou surcharger l'infrastructure",
      uploader_des_fichiers_contenant_des_virus_ou_du_co: "Uploader des fichiers contenant des virus ou du contenu illicite",
      contourner_le_syst_me_de_solde_interne: "Contourner le système de solde interne",
      art_12_limitation_de_responsabilit_de_eservices: "Art 12. Limitation de Responsabilité de eServices",
      les_interruptions_dues_la_maintenance_ou_un_cas_de: "Les interruptions dues à la maintenance ou à un cas de force majeure",
      la_perte_de_donn_es_li_e_une_faute_du_client: "La perte de données liée à une faute du Client",
      le_contenu_ou_la_disponibilit_des_services_fournis: "Le contenu ou la disponibilité des services fournis par les partenaires tiers (opérateurs, éditeurs)",
      les_dommages_indirects_perte_de_b_n_fices_perte_d_: "Les dommages indirects (perte de bénéfices, perte d'opportunité)",
      la_responsabilit_de_eservices_si_elle_est_retenue_: "La responsabilité de eServices, si elle est retenue, ne pourra excéder le montant de la commande litigieuse ou du dernier Dépôt effectué.",
      art_13_donn_es_personnelles: "Art 13. Données Personnelles",
      art_14_suspension_et_r_solution: "Art 14. Suspension et Résolution",
      art_16_droit_applicable_et_litiges: "Art 16. Droit Applicable et Litiges",
      tribunaux_de_ville_du_si_ge_social_: "Tribunaux de [Ville du siège social]",
      bient_t_disponible: "Bientôt disponible",
      service_s_curis_et_fiable: "Service sécurisé et fiable",
      support_24_7_disponible: "Support 24/7 disponible",
      google: "Google",
      github: "GitHub",
      services: "Services",
      open_menu: "Open menu",
      close_menu: "Close menu",
      total_payer: "Total à payer",
      entrez_l: "Entrez l",
      r_sum_: "Résumé",
      votre_solde_actuel: "Votre Solde Actuel",
      instructions: "Instructions",
      comptes_bancaires: "Comptes bancaires",
      choisir_un_fichier: "Choisir un fichier",
      aujourd: "Aujourd",
      d_p_ts: "Dépôts",
      total_commandes: "Total Commandes",
      tickets_support: "Tickets Support",
      mes_commandes: "Mes Commandes",
      mes_d_p_ts: "Mes Dépôts",
      commandes_en_attente: "Commandes en attente",
      d_p_ts_en_attente: "Dépôts en attente",
      commandes: "Commandes",
      tickets: "Tickets",
      clients: "Clients",
      produits: "Produits",
      stock: "Stock",
      m_dia: "Média",
      recharger: "Recharger",
      boutique: "Boutique",
      support: "Support",
      historique: "Historique",
      promotion: "Promotion",
      produits_populaires: "Produits Populaires",
      bienvenue_: "Bienvenue,",
      chiffre_d_affaires_total: "Chiffre d'affaires total",
      offre_limit_e: "Offre Limitée",
      netflix_premium_20_: "Netflix Premium -20%",
      profitez_du_meilleur_du_streaming_prix_r_duit_: "Profitez du meilleur du streaming à prix réduit.",
      r_sum_du_jour: "Résumé du Jour",
      aucune_commande_r_cente: "Aucune commande récente",
      mes_favoris: "Mes Favoris",
      retrouvez_les_articles_que_vous_avez_aim_s_: "Retrouvez les articles que vous avez aimés.",
      aucun_favori: "Aucun favori",
      parcourez_le_catalogue_et_ajoutez_des_articles_vos: "Parcourez le catalogue et ajoutez des articles à vos coups de cœur.",
      modifier: "Modifier",
      supprimer: "Supprimer",
      rechercher_: "Rechercher...",
      nom_de_la_cat_gorie: "Nom de la catégorie",
      description_de_la_cat_gorie: "Description de la catégorie",
      preview: "Preview",
      nom_de_la_sous_cat_gorie: "Nom de la sous-catégorie",
      description_de_la_sous_cat_gorie: "Description de la sous-catégorie",
      s_lectionner_une_cat_gorie: "Sélectionner une catégorie",
      preuve_de_d_p_t: "Preuve de dépôt",
      montant: "Montant",
      m_thode: "Méthode",
      preuve_de_paiement: "Preuve de paiement",
      image_non_disponible: "Image non disponible",
      cliquez_pour_voir_le_code_complet: "Cliquez pour voir le code complet",
      aucun_d_p_t: "Aucun dépôt",
      voir_les_d_tails_de_la_commande: "Voir les détails de la commande",
      g_rez_les_commandes_des_clients: "Gérez les commandes des clients",
      montant_total: "Montant total",
      moyen_de_paiement: "Moyen de paiement",
      changer_le_statut_de_la_commande: "Changer le statut de la commande",
      aucune_commande: "Aucune commande",
      client: "Client",
      statut: "Statut",
      articles: "Articles",
      rechercher_un_produit_: "Rechercher un produit...",
      g_rez_votre_catalogue: "Gérez votre catalogue",
      best: "Best",
      aucun_produit_trouv_: "Aucun produit trouvé",
      rechercher_un_client_: "Rechercher un client...",
      g_rez_vos_utilisateurs: "Gérez vos utilisateurs",
      d_p_ts_: "Dépôts:",
      aucun: "Aucun",
      commandes_: "Commandes:",
      aucune: "Aucune",
      conversations_: "Conversations:",
      s_curisation_: "Sécurisation...",
      logo: "Logo",
      saisir_montant: "Saisir montant",
      produit_introuvable: "Produit introuvable",
      prix_de_base: "Prix de base",
      prix_total: "Prix total",
      cat_gorie: "Catégorie",
      sous_cat_gorie: "Sous-catégorie",
      m_thode_de_livraison: "Méthode de livraison",
      moyens_de_paiement: "Moyens de paiement",
      type_de_vente: "Type de vente",
      quantit_minimale: "Quantité minimale",
      s_lectionner_: "Sélectionner...",
      aucune_description_disponible_pour_ce_produit_: "Aucune description disponible pour ce produit.",
      valeur_du_produit: "Valeur du produit",
      s_lectionnez_la_quantit_souhait_e_et_ajoutez_au_pa: "Sélectionnez la quantité souhaitée et ajoutez au panier.",
      proc_dez_au_paiement_s_curis_via_votre_solde_ou_au: "Procédez au paiement sécurisé via votre solde ou autre méthode.",
      recevez_votre_code_instantan_ment_dans_votre_espac: "Recevez votre code instantanément dans votre espace \"Mes Codes\".",
      changement_en_cours_: "Changement en cours...",
      d_sactivation_: "Désactivation...",
      ex_probl_me_de_connexion: "Ex: Problème de connexion",
      d_crivez_votre_probl_me_en_d_tail_: "Décrivez votre problème en détail...",
      tapez_votre_r_ponse_: "Tapez votre réponse...",
      nouveau_ticket: "Nouveau ticket",
      sujet: "Sujet",
      type_d_assistance: "Type d'assistance",
      message: "Message",
      chargement_des_messages_: "Chargement des messages...",
      envoi_: "Envoi...",
      envoyer: "Envoyer",
      rechercher_un_service_: "Rechercher un service...",
      id_de_transaction: "ID de transaction",
      instructions_de_paiement: "Instructions de Paiement",
      ouvrez_l_application_d17_et_envoyez_le_montant: "Ouvrez l'application D17 et envoyez le montant",
      virement_bancaire: "Virement bancaire",
      d_p_ts_ce_mois: "Dépôts ce mois",
      d_penses_ce_mois: "Dépenses ce mois",
      aucun_d_p_t_trouv_: "Aucun dépôt trouvé",
      montant_personnalis_: "Montant personnalisé",
      choisissez_une_m_thode: "Choisissez une méthode",
      page_non_trouv_e: "Page non trouvée",
      produit_introuvable_: "Produit introuvable.",
      total_estim_: "Total estimé",
      jean: "Jean",
      dupont: "Dupont",
      rue_ville_code_postal: "Rue, Ville, Code postal",
      confirmer_le_mot_de_passe: "Confirmer le mot de passe",
      nouveau_mot_de_passe: "Nouveau mot de passe",
      v_rification_du_lien_: "Vérification du lien...",
      mot_de_passe_s_curis_: "Mot de passe sécurisé",
      chiffrement_de_niveau_bancaire: "Chiffrement de niveau bancaire",
      mise_jour_en_cours_: "Mise à jour en cours...",
      mettre_jour_le_mot_de_passe: "Mettre à jour le mot de passe",
      open_sidebar: "Open sidebar",
      open_user_menu: "Open user menu",
      d_connexion: "Déconnexion",
      fermer: "Fermer",
      image_pr_c_dente: "Image précédente",
      image_suivante: "Image suivante",
      aper_u: "Aperçu",
      rechercher_une_image_: "Rechercher une image...",
      biblioth_que_m_dia: "Bibliothèque Média",
      aucune_image_trouv_e: "Aucune image trouvée",
      votre_message_: "Votre message...",
      en_ligne: "En ligne",
      besoin_d_aide_: "Besoin d'aide ?",
      posez_moi_vos_questions_sur_les_recharges_ou_nos_s: "Posez-moi vos questions sur les recharges ou nos services.",
      valeur: "Valeur",
      s_rie_id: "Série / ID",
      date_d_achat: "Date d'achat",
      authentique: "Authentique",
      notifications: "Notifications",
      trustpilot: "Trustpilot",
      retour: "Retour"
    },
    message: {
      failed_to_fetch_admin_stats: "Failed to fetch admin stats",
      failed_to_update_profile: "Failed to update profile",
      failed_to_post_reply: "Failed to post reply",
      failed_to_update_status: "Failed to update status",
      failed_update_meta: "Failed update meta",
      failed_to_fetch_deposits: "Failed to fetch deposits",
      failed_to_update_deposit_status: "Failed to update deposit status",
      failed_to_load_media: "Failed to load media",
      sync_error: "Sync error",
      erreur_lors_de_la_synchronisation_: "Erreur lors de la synchronisation : ",
      upload_error: "Upload error",
      nom_mis_jour: "Nom mis à jour",
      erreur_de_renommage: "Erreur de renommage",
      failed_to_fetch_data: "Failed to fetch data",
      tout_semble_correct_: "Tout semble correct.",
      failed_to_fetch_tickets: "Failed to fetch tickets",
      erreur_lors_de_l: "Erreur lors de l",
      error_loading_product_detail_for_cart: "Error loading product detail for cart",
      failed_to_load_payment_settings: "Failed to load payment settings",
      error_loading_product_detail: "Error loading product detail",
      failed_to_load_services_page_data: "Failed to load services page data",
      failed_to_fetch_dashboard_data_: "Failed to fetch dashboard data:",
      failed_to_load_order_page_data: "Failed to load order page data",
      failed_to_send_reset_email: "Failed to send reset email",
      erreur_turnstile_: "Erreur Turnstile:",
      newsletter_subscription_error: "Newsletter subscription error",
      failed_to_fetch_ticket: "Failed to fetch ticket",
      failed_to_send_reply: "Failed to send reply",
      failed_to_fetch_dashboard_data: "Failed to fetch dashboard data",
      failed_to_fetch_categories_data: "Failed to fetch categories data",
      failed_to_save_category: "Failed to save category",
      failed_to_save_subcategory: "Failed to save subcategory",
      failed_to_delete: "Failed to delete",
      failed_to_fetch_stock_data: "Failed to fetch stock data",
      attempting_to_reveal_code_: "Attempting to reveal code:",
      failed_to_reveal_code_: "Failed to reveal code:",
      failed_to_copy_: "Failed to copy:",
      error_fetching_orders: "Error fetching orders",
      error_fetching_product: "Error fetching product",
      erreur_d: "Erreur d",
      failed_to_fetch_orders_count: "Failed to fetch orders count",
      failed_to_fetch_2fa_status: "Failed to fetch 2FA status",
      failed_to_generate_2fa_secret: "Failed to generate 2FA secret",
      failed_to_verify_2fa_code: "Failed to verify 2FA code",
      failed_to_disable_2fa: "Failed to disable 2FA",
      failed_to_regenerate_recovery_codes: "Failed to regenerate recovery codes",
      failed_to_change_password: "Failed to change password",
      error_fetching_tickets: "Error fetching tickets",
      error_creating_ticket: "Error creating ticket",
      error_fetching_ticket_detail: "Error fetching ticket detail",
      error_posting_reply: "Error posting reply",
      failed_to_fetch_catalog: "Failed to fetch catalog",
      failed_to_fetch_wallet_data: "Failed to fetch wallet data",
      d_p_t_soumis_avec_succ_s_: "Dépôt soumis avec succès !",
      failed_to_submit_deposit: "Failed to submit deposit",
      erreur_lors_de_la_soumission_veuillez_r_essayer_: "Erreur lors de la soumission. Veuillez réessayer.",
      erreur_lors_de_l_: "Erreur lors de l\\",
      erreur_oauth_callback_: "Erreur OAuth callback:",
      error_checking_session: "Error checking session",
      failed_to_reset_password: "Failed to reset password",
      upload_failed: "Upload failed",
      ai_error_: "AI Error:",
      erreur_de_s_curit_impossible_de_r_cup_rer_le_code_: "Erreur de sécurité : Impossible de récupérer le code secret.",
      erreur_lors_de_la_g_n_ration_du_document_pdf_: "Erreur lors de la génération du document PDF.",
      failed_to_fetch_favorite_products_details: "Failed to fetch favorite products details",
      _splashscreen_erreur_lors_de_la_v_rification_ota_: "[SplashScreen] Erreur lors de la vérification OTA:",
      _publiclandingroute_affichage_de_la_landingpage_pu: "[PublicLandingRoute] Affichage de la LandingPage (publique)",
      service_worker_enregistr_avec_succ_s_: "Service Worker enregistré avec succès:",
      _chec_de_l_: "Échec de l\\"
    },
    "Aucune preuve": "Aucune preuve.",
    "Erreur lors de la synchronisation : ": "Erreur lors de la synchronisation : ",
    "Nom mis à jour": "Nom mis à jour",
    "Erreur de renommage": "Erreur de renommage",
    "/": "/",
    "Tracking Number": "Tracking Number",
    "\\n": "\\n",
    "Tout semble correct": "Tout semble correct.",
    nom: "nom",
    statut: "statut",
    solde: "solde",
    date_creation: "date_creation",
    "Erreur lors de l": "Erreur lors de l",
    mobile: {
      nav: {
        home: "Accueil",
        orders_admin: "Commandes",
        support: "Support",
        catalog: "Découvrir",
        shop: "Boutique",
        orders: "Commandes",
        favorites: "Favoris",
        profile: "Profil"
      },
      desktop_only: {
        title: "Fonctionnalité Desktop uniquement",
        media: "Médiathèque",
        open_desktop: "Ouvrir sur Desktop"
      }
    },
    sidebar: {
      sections: {
        account: "Compte",
        preferences: "Préférences",
        navigation: "Navigation"
      }
    },
    T: "T",
    ProductCatalog: {
      search: {
        placeholder: "Rechercher un service..."
      },
      filters: {
        all: "Tous",
        onSale: "En vente",
        incoming: "En arrivage",
        soldOut: "Épuisé"
      },
      categories: {
        all: "Tous",
        codes: "Codes",
        licences: "Licences",
        subscriptions: "Abonnements",
        recharges: "Recharges"
      },
      product: {
        quickActivation: "Activation rapide",
        addToCart: "Ajouter",
        unavailable: "Indisponible"
      },
      empty: {
        noProductsFound: "Aucun produit trouvé"
      }
    },
    MobileSupport: {
      header: {
        titleAdmin: "Gestion du Support",
        titleClient: "Besoin d'aide ?",
        subtitleAdmin: "Répondez aux demandes des clients et gérez les tickets en attente.",
        subtitleClient: "Notre équipe technique est là pour vous accompagner 24/7.",
        openTicket: "Ouvrir un ticket"
      },
      list: {
        sectionTitleAdmin: "Toutes les demandes",
        sectionTitleClient: "Mes Demandes",
        ticketsCount: "{{count}} tickets",
        emptyAdmin: "Aucun ticket n'est actuellement ouvert.",
        emptyClient: "Vous n'avez aucun ticket ouvert."
      },
      modal: {
        title: "Nouveau ticket",
        subjectLabel: "Sujet",
        subjectPlaceholder: "Ex: Problème de connexion",
        assistanceTypeLabel: "Type d'assistance",
        messageLabel: "Message",
        messagePlaceholder: "Décrivez votre problème en détail...",
        submitButton: "Envoyer la demande"
      },
      detail: {
        ticketTitle: "Ticket #{{id}}",
        attachment: "Pièce jointe",
        supportLabel: "Support eServices",
        loadingMessages: "Chargement des messages..."
      },
      reply: {
        placeholder: "Tapez votre réponse...",
        sending: "Envoi...",
        send: "Envoyer",
        attachmentOptional: "Pièce jointe (optionnel)"
      }
    },
    MobileOrders: {
      header: {
        titleAdmin: "Gestion des commandes",
        titleClient: "Historique des commandes",
        subtitleAdmin: "Consultez et gérez les commandes de tous les clients.",
        subtitleClient: "Suivez l'état de vos achats en temps réel."
      },
      card: {
        orderLabel: "Commande #{{id}}",
        totalAdmin: "Montant total",
        totalClient: "Total payé"
      },
      item: {
        codeDelivered: "Code livré",
        accessDelivered: "Accès livré",
        viewAccess: "Voir l'accès",
        codePending: "Code en attente",
        codesCount: "{{count}} codes"
      },
      empty: {
        title: "Aucune commande",
        textAdmin: "Aucune commande n'a encore été passée sur la boutique.",
        textClient: "Vous n'avez pas encore passé de commande sur notre boutique.",
        discoverCatalog: "Découvrir le catalogue"
      }
    },
    MobileMyCodes: {
      header: {
        title: "Mes Codes",
        itemsCount: "{{count}} éléments",
        itemSingular: "1 élément"
      },
      alert: {
        deliveryPendingTitle: "Livraison en attente",
        deliveryPendingMessage: "Certains codes n'ont pas pu être générés automatiquement. Nos administrateurs vont les assigner manuellement.",
        viewOrders: "Voir mes commandes"
      },
      loading: "Chargement...",
      empty: {
        title: "Aucun code trouvé",
        subtitle: "Vos codes et accès apparaîtront ici",
        discoverProducts: "Découvrir les produits"
      },
      badges: {
        code: "Code",
        licence: "Licence",
        compte: "Compte",
        acces: "Accès",
        lien: "Lien"
      },
      list: {
        refLabel: "REF:",
        cmdLabel: "CMD #"
      },
      fallback: {
        product: "Produit"
      },
      drawer: {
        details: "Détails",
        close: "Fermer"
      },
      drawerCode: {
        yourCode: "Votre code",
        securing: "Sécurisation...",
        revealSecret: "Révéler le code secret",
        copied: "Copié !",
        copy: "Copier",
        hide: "Masquer"
      },
      drawerMeta: {
        reference: "Référence",
        order: "Commande"
      },
      security: {
        title: "Consignes de sécurité",
        description: "Ce code ou accès est strictement confidentiel. Ne le partagez jamais avec des tiers."
      },
      errors: {
        codeEmpty: "Le code est vide ou introuvable",
        codeRetrieveFail: "Impossible de récupérer le code."
      }
    },
    MobileProductDetail: {
      notFound: "Produit introuvable",
      badge: {
        bestSeller: "Meilleure vente"
      },
      valueLabel: "Valeur : {{value}}",
      reviews: "(4.8 • 124 avis)",
      price: {
        base: "Prix de base",
        total: "Prix total"
      },
      status: {
        onSale: "En vente",
        incoming: "En arrivage",
        soldOut: "Épuisé"
      },
      info: {
        title: "Informations du produit",
        category: "Catégorie",
        subCategory: "Sous-catégorie",
        deliveryMethod: "Méthode de livraison",
        paymentMethods: "Moyens de paiement",
        saleType: "Type de vente",
        minQuantity: "Quantité minimale"
      },
      deliveryMethods: {
        code_instantane: "Code instantané",
        mail_compte_code: "Mail compte code",
        mail_code: "Mail code",
        mail_acces: "Mail accès",
        mail_licence: "Mail licence",
        traitement_lien: "Traitement lien",
        livraison_domicile: "Livraison à domicile"
      },
      paymentMethods: {
        solde_interne: "Solde interne",
        flouci: "Flouci",
        d17: "D17",
        izi_pay: "IZI Pay",
        virement: "Virement",
        carte_bancaire: "Carte bancaire"
      },
      saleType: {
        detail: "Détail",
        gros: "Gros"
      },
      custom: {
        title: "Personnalisation",
        required: "Requis",
        selectPlaceholder: "Sélectionner...",
        enterField: "Entrez votre {{field}}",
        amountPlaceholder: "Saisir montant",
        fileUploading: "Chargement...",
        fileAdded: "Fichier ajouté",
        addFile: "Ajouter un fichier"
      },
      features: {
        title: "Inclus avec vos choix"
      },
      tabs: {
        description: "Description",
        howItWorks: "Comment ça marche ?"
      },
      description: {
        none: "Aucune description disponible pour ce produit.",
        productValue: "Valeur du produit"
      },
      howItWorks: {
        step1: "Sélectionnez la quantité souhaitée et ajoutez au panier.",
        step2: "Procédez au paiement sécurisé via votre solde ou autre méthode.",
        step3: "Recevez votre code instantanément dans votre espace \"Mes Codes\"."
      },
      actions: {
        outOfStock: "Rupture de stock",
        addToCart: "Ajouter au panier"
      },
      errors: {
        uploadError: "Erreur d'upload."
      }
    },
    VerifyPhone: {
      phone: {
        confirmRegistrationTitle: "Confirmez le numéro saisi à l'inscription",
        confirmRegistrationDescription:
          "Un code à 6 chiffres sera envoyé sur WhatsApp au numéro ci-dessous.",
        confirmationLabel: "Numéro à confirmer",
        verificationTitle: "Vérification de votre numéro",
        verificationDescription:
          "Pour sécuriser votre compte, merci de confirmer votre numéro WhatsApp.",
        whatsappPhoneLabel: "Numéro WhatsApp",
        whatsappPhonePlaceholder: "XXXXXXXX",
        phoneFormatHint:
          "Format attendu : XXXXXXXX (le préfixe +216 est appliqué automatiquement).",
        sendCodeButton: "Envoyer le code",
        sendCodeSending: "Envoi du code..."
      },
      code: {
        enterCodeTitle: "Entrez le code reçu",
        sentCodeDescription:
          "Nous avons envoyé un code à 6 chiffres sur WhatsApp au numéro +{{phone}}.",
        resendCodeIn: "Renvoyer le code dans {{countdown}}",
        resendCodeDefault: "Vous pouvez renvoyer un nouveau code.",
        resendButton: "Renvoyer le code",
        submitVerifying: "Vérification...",
        submitButton: "Valider le code"
      },
      success: {
        registrationSuccessTitle: "Inscription réussie",
        phoneVerifiedTitle: "Numéro vérifié",
        registrationSuccessDescription:
          "Votre compte a été créé. Connectez-vous avec votre email et mot de passe pour accéder à votre tableau de bord.",
        phoneVerifiedDescription:
          "Votre numéro WhatsApp est maintenant associé à votre compte. Vous pouvez accéder à votre tableau de bord.",
        registrationSuccessButton: "Se connecter",
        dashboardButton: "Accéder au tableau de bord"
      },
      errors: {
        phoneRequired: "Merci de saisir votre numéro de téléphone.",
        phoneInvalidLength:
          "Le numéro doit contenir 8 chiffres (format local tunisien).",
        phoneInvalid: "Numéro de téléphone invalide.",
        finalizationGeneric: "Erreur lors de la finalisation de l'inscription.",
        linkExpired: "Lien expiré. Veuillez repartir de l’inscription.",
        codeExpired: "Le code a expiré, veuillez en demander un nouveau.",
        tooManyAttempts: "Trop de tentatives, veuillez redemander un code plus tard.",
        phoneAlreadyUsed:
          "Ce numéro est déjà utilisé par un autre compte. Veuillez en choisir un autre.",
        emailAlreadyUsed:
          "Cet email est déjà utilisé. Connectez-vous ou réinitialisez le mot de passe.",
        invalidCodeServer: "Code invalide ou erreur serveur, veuillez réessayer.",
        confirmationGeneric: "Erreur lors de la vérification du code, veuillez réessayer.",
        emailNotFound:
          "Compte introuvable pour cet email. Veuillez recommencer l'inscription.",
        invalidCode: "Code invalide, veuillez vérifier et réessayer."
      }
    },
    legal: {
      documents: {
        subtitle: "Consultez tous nos documents officiels",
        intro: "Retrouvez ici tous nos documents légaux et politiques. Chaque document contient des informations importantes sur nos services, vos droits et nos engagements.",
        info_title: "Besoin d\\",
        info_text: "Si vous avez des questions concernant nos documents légaux, n\\"
      }
    },
    "Erreur lors du chargement des données": "Erreur lors du chargement des données",
    "Le nom de la catégorie est requis": "Le nom de la catégorie est requis",
    "Catégorie modifiée avec succès": "Catégorie modifiée avec succès",
    "Catégorie ajoutée avec succès": "Catégorie ajoutée avec succès",
    "Le nom et la catégorie sont requis": "Le nom et la catégorie sont requis",
    "Sous-catégorie modifiée avec succès": "Sous-catégorie modifiée avec succès",
    "Sous-catégorie ajoutée avec succès": "Sous-catégorie ajoutée avec succès",
    "Erreur lors de la suppression": "Erreur lors de la suppression",
    "La modification doit être effectuée seulement via le Dashboard admin desktop": "La modification doit être effectuée seulement via le Dashboard admin desktop.",
    code_id: "code_id",
    "Erreur d": "Erreur d",
    "Dépôt soumis avec succès !": "Dépôt soumis avec succès !",
    "Erreur lors de la soumission. Veuillez réessayer": "Erreur lors de la soumission. Veuillez réessayer.",
    error: "Une erreur est survenue",
    error_description: "error_description",
    code: "code",
    access_token: "access_token",
    refresh_token: "refresh_token",
    view: "Vue",
    "Erreur de sécurité : Impossible de récupérer le code secret": "Erreur de sécurité : Impossible de récupérer le code secret.",
    "Erreur lors de la génération du document PDF": "Erreur lors de la génération du document PDF.",
    android: {
      app_name: "eServices",
      title_activity_main: "eServices"
    }
  }
};

export { fr };
export default fr;
